const luxurypro = [
    {
        "id": 275,
        "name": "3D Down vest",
        "slug": "3d-down-vest-DINYRBXYM",
        "sku": "DINYRBXYM",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1kzNzCO0OrNTSNuNXnizhPT8ayUfhcXJa",
        "modified_at": 1783584865,
        "price": 22.5,
        "min_price": 22.5,
        "max_price": 27.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1uJWvbJFdSMI9kTpJaqz7lgWrVsvu4rqr?usp=drive_link",
        "description": "Product Introduction：Made from durable 130g broken twill fabric, this 3D down vest combines lightweight comfort with a sleek, modern look. The sleeveless design allows easy layering over shirts or hoodies, making it perfect for outdoor activities, travel, and everyday wear. A versatile choice for autumn and winter and a thoughtful gift for family or friends.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/113dD9w35xZCsiweu2TZ-9z9zVrTmrGPN",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1kzNzCO0OrNTSNuNXnizhPT8ayUfhcXJa",
            "https://lh3.googleusercontent.com/d/113dD9w35xZCsiweu2TZ-9z9zVrTmrGPN"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "130g Broken twill fabric160g"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Down vest",
                "variant_id": "DINYRBXYM-130G-BROKEN-TWILL-FABRIC160G",
                "location": "CN",
                "material": "130g Broken twill fabric160g",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2609,
        "name": "AOP EGD Beach Pants",
        "slug": "aop-egd-beach-pants-EGDSTK",
        "sku": "EGDSTK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1bhfj48vQqy3GHpJZPcHWfERu2a5C2q9t",
        "modified_at": 1790045387,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/18YjM5afEp_WXVZ0jlgEIkbg57TMq3ohl?usp=drive_link",
        "description": "Product Introduction：Drawstring elastic waist beach shorts with full customizable 3D all-over print. Loose wide leg design, lightweight quick-dry fabric for summer seaside trips, match coordinating shirts, fresh personalized holiday gifts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Skin-friendly & unrestricted. 4-way super stretch, flexible, body-hugging and shape-retaining.<br />\n<br />\n4.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1wfkbkzlRnFNdu0vqMsEA2Yr0pJGKS80P",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1bhfj48vQqy3GHpJZPcHWfERu2a5C2q9t",
            "https://lh3.googleusercontent.com/d/12kEBYy2p42cFSeEMOCUof9A7a9NkF9MX",
            "https://lh3.googleusercontent.com/d/1fq0MgkMaEWR_FMFZNb6J0uS9LOf83Mn8",
            "https://lh3.googleusercontent.com/d/1wxU-TIQG9XrVy-j1zNiNgg0IIs_EBbtb",
            "https://lh3.googleusercontent.com/d/1wfkbkzlRnFNdu0vqMsEA2Yr0pJGKS80P"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Four-side strench polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Beach Pants",
                "variant_id": "EGDSTK",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 411,
        "name": "Airmax Sneaker",
        "slug": "airmax-sneaker-AZ53",
        "sku": "AZ53",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1tsHzkS0eajOm4zUdduPsnrB5oq9yBJjx",
        "modified_at": 1783418292,
        "price": 33,
        "min_price": 33,
        "max_price": 43,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1tlFrSBa0yVtcrzGbNSIl-bM5VtQ-3Urr?usp=drive_link",
        "description": "Product Introduction：Custom Regular Air Cushion Sneakers. Flexible and durable microfiber upper, breathable mesh lining. Air cushion plus EVA insole deliver shock absorption and foot support, slip-resistant RB outsole, suitable for commuting and sports all year round.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/14xTlXusFFOz2_2WR_GGYFppgjUh9BE7d",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1tsHzkS0eajOm4zUdduPsnrB5oq9yBJjx",
            "https://lh3.googleusercontent.com/d/14xTlXusFFOz2_2WR_GGYFppgjUh9BE7d"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Airmax Sneaker",
                "variant_id": "AZ53-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 967,
        "name": "Kids' Air Cushion Shoes",
        "slug": "kids-air-cushion-shoes-S69-K",
        "sku": "S69-K",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1w5sVBj3xZgSOQQe1w1iMmXldAek0l_WJ",
        "modified_at": 1783418292,
        "price": 28,
        "min_price": 28,
        "max_price": 33,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ImJfwWH9viXCQli8g2IFKzhRzgcGH_1I?usp=drive_link",
        "description": "Product Introduction：Custom full 3D print available. Breathable polyester knit upper, flexible TPR sole with air cushion for shock absorption, lightweight for kids’ school and outdoor activities, gentle on feet all day.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1KxYe1GAutwnvj7uZBAKLWENfWjqFY0mQ",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1w5sVBj3xZgSOQQe1w1iMmXldAek0l_WJ",
            "https://lh3.googleusercontent.com/d/1KxYe1GAutwnvj7uZBAKLWENfWjqFY0mQ"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "28",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "29",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "30",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "31",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "32",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "33",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "34",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Kids' Air Cushion Shoes",
                "variant_id": "S69-K",
                "location": "CN",
                "material": "Sole: TPR with air cushion\nUpper: Polyester fly knit (Polyester Fiber)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "size": "35",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 935,
        "name": "Low-Top Air Force Board Shoes",
        "slug": "low-top-air-force-board-shoes-F40",
        "sku": "F40",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1uY04DDap1n-mJBZ4VAPxWAkpHjn_af7E",
        "modified_at": 1783418292,
        "price": 41,
        "min_price": 41,
        "max_price": 48,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1shaBcazqwgo0hamOa7GZ1vAGKu3MfMt5?usp=drive_link",
        "description": "Product Introduction：3D full-print low-top air force sneakers with customizable patterns. Wear-resistant and crease-proof microfiber upper, breathable K209 mesh lining, soft EVA insole for foot comfort. Thick slip-resistant RB sole adds height, suitable for casual wear and commuting all year, full sizes available for men and women.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/13OVKlvwZG5mjYqN0MV9QGeir9QuAywZm",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1uY04DDap1n-mJBZ4VAPxWAkpHjn_af7E",
            "https://lh3.googleusercontent.com/d/13OVKlvwZG5mjYqN0MV9QGeir9QuAywZm"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Microfiber (55-60% Polyurethane Resin",
                    "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "Box"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "36",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "36",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "37",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "37",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "38",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "38",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "39",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "39",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "40",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "40",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "41",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "41",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "42",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "42",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "43",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "43",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "44",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "44",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "45",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "45",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "46",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "46",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "47",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "47",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "48",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "48",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "36",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "36",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "37",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "37",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "38",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "38",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "39",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "39",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "40",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "40",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "41",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "41",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "42",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "42",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "43",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "43",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "44",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "44",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "45",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "45",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "46",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "46",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "47",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "47",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "48",
                "material": "Upper: Microfiber (55-60% Polyurethane Resin",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low-Top Air Force Board Shoes",
                "variant_id": "F40-36373839404142434445464748-BOX",
                "location": "CN",
                "packaging": "Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "48",
                "material": "40-45% Nylon)\nLining: K209 Mesh (100% Polyester Fiber)\nInsole: Black Hypalon\nSole: RB (Polyethylene)",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 407,
        "name": "Low Top Sports Shoes",
        "slug": "low-top-sports-shoes-F8J-W",
        "sku": "F8J-W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1tzpmk3y7mUBFiTK2mBdPVPug_E7rACv9",
        "modified_at": 1783418292,
        "price": 44,
        "min_price": 44,
        "max_price": 51,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1KbyUm8oFWhio6OLfssFpEwGD9yihlwFL?usp=drive_link",
        "description": "Product Introduction：Exquisite eye-catching 3D custom print, wear-resistant and easy-to-clean microfiber upper, breathable 100% polyester mesh lining that prevents rubbing feet. Full sizes available, versatile for daily outfits, great for personal wear or gifting.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1XWHGsTiUhKTrTDKaRezhzalaJeKuPYfN",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1tzpmk3y7mUBFiTK2mBdPVPug_E7rACv9",
            "https://lh3.googleusercontent.com/d/1XWHGsTiUhKTrTDKaRezhzalaJeKuPYfN"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Low Top Sports Shoes",
                "variant_id": "F8J-W-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: K209 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 409,
        "name": "Max Soul Sneaker",
        "slug": "max-soul-sneaker-F21W",
        "sku": "F21W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1-aIFGfoeTkdmsumwwcflT0lHCcyC0NQH",
        "modified_at": 1783418292,
        "price": 30,
        "min_price": 30,
        "max_price": 46,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1PITEX5EPnTSYurfr-IxzroByb4yEbFfF?usp=drive_link",
        "description": "Product Introduction：Custom Blade Running Shoes. Lightweight and breathable polyester flyknit upper, skin-friendly breathable synthetic leather lining. Shock-absorbing shaped EVA insole, flexible cushioning MD blade outsole. Suitable for running and daily commuting, full sizes available for men and women.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1XkC5MHDY2Wy76Kk9BxuFjkULk7LOp2lK",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1-aIFGfoeTkdmsumwwcflT0lHCcyC0NQH",
            "https://lh3.googleusercontent.com/d/1XkC5MHDY2Wy76Kk9BxuFjkULk7LOp2lK"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Max Soul Sneaker",
                "variant_id": "F21W-3536373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Polyester Flyknit (Polyester Fiber)\nLining: Breathable Synthetic Leather (40% Polyester Filament, 10% Cotton, 30% Polyurethane, 10% Color Paste, 10% Filler)\nInsole: Shaping Support Pad (EVA: Ethylene-Vinyl Acetate Copolymer)\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 574,
        "name": "Men's loafers",
        "slug": "mens-loafers-BZ15W",
        "sku": "BZ15W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1FtZRR_bguGp3a5dpmdlh9YJGuFHbGL4_",
        "modified_at": 1783418292,
        "price": 31,
        "min_price": 31,
        "max_price": 41,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1DVB2T2r7d2g7LpTV6QPbJF3r0PRLq-P3?usp=drive_link",
        "description": "Product Introduction：These all-over print men's loafers support custom 3D printing. Crafted from breathable, skin-friendly polyester canvas, they feature contoured insoles that fit feet perfectly. Lightweight shock-absorbing soft MD outsoles match all outfits year-round, ideal for commuting and trips.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1ffJ7cc6w7uxeqwpwZLF9caYzenlxfkoS",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1FtZRR_bguGp3a5dpmdlh9YJGuFHbGL4_",
            "https://lh3.googleusercontent.com/d/1ffJ7cc6w7uxeqwpwZLF9caYzenlxfkoS"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "White"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Men's loafers",
                "variant_id": "BZ15W-373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: 100% polyester canvas (polyester fiber)\nLining: Polyester canvas (polyester fiber)\nInsole: Contoured support insole\nOutsole: MD (Ethylene-Vinyl Acetate Copolymer, EVA)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 586,
        "name": "AJ13",
        "slug": "aj13-LX-B",
        "sku": "LX-B",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1WPpqHnZGqGfFMgydCKq79OV8sBk5qdcP",
        "modified_at": 1783418292,
        "price": 42,
        "min_price": 42,
        "max_price": 50,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1wVTSGrK0GQuuGbpGZsNOllglIbDqSwuv?usp=drive_link",
        "description": "Product Introduction：Eye-catching custom 3D full-print color clash design with trendy high-top silhouette. Breathable fabric and soft Hi-Poly insole cushion feet without rubbing. Suitable all year round, match well with cargo and casual pants for street strolls and sports events.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1hgTUAtW1GoFpOupsxsXrdQNHBVal28zo",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1WPpqHnZGqGfFMgydCKq79OV8sBk5qdcP",
            "https://lh3.googleusercontent.com/d/1hgTUAtW1GoFpOupsxsXrdQNHBVal28zo"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ13",
                "variant_id": "LX-B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space (100% Polyester + Polyurethane + Calcium Carbonate + Wood Powder + Other 15%),\nLining: D02 (100% Polyester Fiber (Full Polyester)),\nInsole: Black Sea Wave,\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 577,
        "name": "Sports Shoes-2",
        "slug": "sports-shoes-2-F71B",
        "sku": "F71B",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1nZcMVS_qZ2HEJLbi9_5KoxmRWsgczXv8",
        "modified_at": 1783418292,
        "price": 43,
        "min_price": 43,
        "max_price": 48,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1MWOrnO4WjMkwzDusBV4D7KJcPYw2J7yx?usp=drive_link",
        "description": "Product Introduction：High-top casual sneakers feature custom all-over print design. Made of PU and oxford cloth for sturdiness and breathability, paired with flexible anti-slip TPR soles. Soft and rub-free, versatile for all seasons, ideal daily wear or holiday gifts for youngsters.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1kB-uYA97wpvOo7ppBRUd3UFH7Z-dkGfR",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1nZcMVS_qZ2HEJLbi9_5KoxmRWsgczXv8",
            "https://lh3.googleusercontent.com/d/1kB-uYA97wpvOo7ppBRUd3UFH7Z-dkGfR"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: PU + Oxford Fabric\nSole: TPR"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Sports Shoes-2",
                "variant_id": "F71B-UPPER-MESH-SOLE-EVA",
                "location": "CN",
                "material": "Upper: PU + Oxford Fabric\nSole: TPR",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 153,
        "name": "AOP Women's Maxi Hoodie",
        "slug": "aop-womens-maxi-hoodie-VSCQLMS",
        "sku": "VSCQLMS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1VLFeSWSjgK1pfZpjbgJDEcUgMzFBrvsn",
        "modified_at": 1783584865,
        "price": 18.5,
        "min_price": 18.5,
        "max_price": 23.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1dOMn7JIn4224lz-0JbCQIKB7q8C74zHw?usp=drive_link",
        "description": "Product Introduction：AOP women's maxi hoodie featuring a relaxed longline silhouette and soft fleece-like texture for cozy comfort. The oversized fit creates effortless streetwear style while maintaining warmth. Ideal for lounging, travel, casual outings, and layering. Suitable for autumn and winter. Easy to pair with sneakers or boots. Great holiday gift item.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/19PQo-mX1bRxO4ZnyzOrsFTVkDSPlhwC8",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1VLFeSWSjgK1pfZpjbgJDEcUgMzFBrvsn",
            "https://lh3.googleusercontent.com/d/19PQo-mX1bRxO4ZnyzOrsFTVkDSPlhwC8"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Maxi Hoodie",
                "variant_id": "VSCQLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 34,
        "name": "2D Half-Zip Hoodie",
        "slug": "2d-half-zip-hoodie-2DBLLWY",
        "sku": "2DBLLWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1rlW83rYJdIsZFrlp7lGY-bgwRzIm4nvE",
        "modified_at": 1785486868,
        "price": 21.5,
        "min_price": 21.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1y0ytWf0aKGB_mo6_zN5ZH7IuSaW5aPzp?usp=drive_link",
        "description": "Product Introduction：This 2D half-zip hoodie features 9 classic colors, sizes S–5XL. Soft, relaxed-fit and versatile, great for casual daily and outdoor wear in spring, autumn and winter. Easy to match, ideal as a practical holiday gift.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/14Xus73zlKxLYr32t3HAJGslVbAyzT2T4",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1rlW83rYJdIsZFrlp7lGY-bgwRzIm4nvE",
            "https://lh3.googleusercontent.com/d/14Xus73zlKxLYr32t3HAJGslVbAyzT2T4"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Royal Blue",
                    "Navy Blue",
                    "Orange",
                    "Bright Red",
                    "Black",
                    "Burgundy",
                    "Army Green",
                    "Coffee",
                    "Khaki",
                    "Dark Green",
                    "Light Gray",
                    "Dark Gray",
                    "Sky Blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Royal Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Orange",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Bright Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Dark Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Light Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Dark Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Half-Zip Hoodie",
                "variant_id": "2DBLLWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "color": "Sky Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 304,
        "name": "AOP Basketball Crew Neck Cardigan",
        "slug": "aop-basketball-crew-neck-cardigan-TOLYLLQKS",
        "sku": "TOLYLLQKS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1mE4U2dbodPtwTZFD9KzLmktGi7kfWLi4",
        "modified_at": 1783584865,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1CM1TK0DRS2WYPqJxxkydpyxLEj-qIyzo?usp=drive_link",
        "description": "Product Introduction：Crafted from breathable bird-eye polyester, this basketball crew neck cardigan delivers lightweight comfort and a clean athletic style. The classic crew neckline and button-front design create a versatile look, while the relaxed fit allows easy movement. Perfect for team events, basketball games, training sessions, or casual everyday wear, it pairs effortlessly with shorts or joggers.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1RaTT5xtFTgH8PEgiRD6sCusQg6Droiw8",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1mE4U2dbodPtwTZFD9KzLmktGi7kfWLi4",
            "https://lh3.googleusercontent.com/d/1RaTT5xtFTgH8PEgiRD6sCusQg6Droiw8"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball Crew Neck Cardigan",
                "variant_id": "TOLYLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2390,
        "name": "AOP HNH Collared zip polo shirt",
        "slug": "aop-hnh-collared-zip-polo-shirt-HNNFLLLPOLO",
        "sku": "HNNFLLLPOLO",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1kyIgO2QozvszXFz-zVSnIZFypqMlnsJ7",
        "modified_at": 1783584866,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1puVOrAsMCdff23vlWAlfqqKIfh4X6dbo?usp=drive_link",
        "description": "Product Introduction：AOP HNH Collared zip polo shirt with custom 3D all-over print, tailored neat fit, breathable fabric, sizes S-8XL, ideal for daily work, team activities and personalized holiday gifts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected. ",
        "size_guide": "https://lh3.googleusercontent.com/d/1H16YejV0aHZGrw2ycwgNE9chSoG1Wzib",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1kyIgO2QozvszXFz-zVSnIZFypqMlnsJ7",
            "https://lh3.googleusercontent.com/d/1H16YejV0aHZGrw2ycwgNE9chSoG1Wzib"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL",
                    "7XL",
                    "8XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "180gPolyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "7XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared zip polo shirt",
                "variant_id": "HNNFLLLPOLO",
                "location": "CN",
                "material": "180gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "8XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 596,
        "name": "High-top AJ1",
        "slug": "high-top-aj1-LH-W",
        "sku": "LH-W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Rz_shCCKzRqRQbULPCSb1Kr5l6OlF4Uj",
        "modified_at": 1783418292,
        "price": 44,
        "min_price": 44,
        "max_price": 49,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1R50OnJn2e2Q2ohYs8LsEQAwWApSRMJ4o?usp=drive_link",
        "description": "Product Introduction：Customizable high-top AJ1 sneakers with all-over print. Durable & breathable space fabric paired with soft Hi-Poly insoles to cushion feet without chafing. Wear-resistant RB outsole, versatile all year round, perfect for students & trendsetters for daily wear or holiday gifts.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1CDQe64tyGFohfEX1Ont6CR41_zFBCJLV",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Rz_shCCKzRqRQbULPCSb1Kr5l6OlF4Uj",
            "https://lh3.googleusercontent.com/d/1CDQe64tyGFohfEX1Ont6CR41_zFBCJLV"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Black"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-top AJ1",
                "variant_id": "LH-W-UPPER-SPACE-100-POLYESTER-POLYURETHANE-CALCIUM-CARBONATE-WOOD-POWDER-OTHER-15-LINING-D02-100-POLYESTER-FIBER-FULL-POLYESTER-INSOLE-BLACK-HEBEIOUTSOLE-RB-POLYETHYLENE",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 270,
        "name": "3D Thick Fleece Zip Hoodie",
        "slug": "3d-thick-fleece-zip-hoodie-TBHRLLWY",
        "sku": "TBHRLLWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/14-nWkeUCiGIQTWcTLIPIi4xQt1LxW-HJ",
        "modified_at": 1783584865,
        "price": 31.5,
        "min_price": 31.5,
        "max_price": 36.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1fLg2520kOR2rb9sAfOMuY9PwGnsxgbvw?usp=drive_link",
        "description": "Product Introduction：Designed with a full-zip front and thick fleece lining, this 3D zip hoodie provides outstanding warmth and all-day comfort. The relaxed fit makes layering easy, while the vibrant all-over print adds bold style. Perfect for outdoor adventures, travel, and everyday wear in autumn and winter. A practical and stylish gift for any occasion.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Fine short plush, soft & skin-friendly. Warm, lightweight and comfortable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, shade dry. No high heat drying to prevent clumping.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1ZVeSMfximjBZmQ3rWZfntAehv6OlzRd2",
        "gallery": [
            "https://lh3.googleusercontent.com/d/14-nWkeUCiGIQTWcTLIPIi4xQt1LxW-HJ",
            "https://lh3.googleusercontent.com/d/1ZVeSMfximjBZmQ3rWZfntAehv6OlzRd2"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "180gHeavy flannel fleece"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Zip Hoodie",
                "variant_id": "TBHRLLWY-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31.5,
                        "non_contiguous": 36.5
                    },
                    "EU": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    },
                    "CA": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 583,
        "name": "AJ4 high-top sneakers white",
        "slug": "aj4-high-top-sneakers-white-BZ77W",
        "sku": "BZ77W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/19LLth1-7soMFYOqfUDz_dAlq89VXgHwA",
        "modified_at": 1783418292,
        "price": 49,
        "min_price": 49,
        "max_price": 54,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1DIkZNC70MaiNREujJNrhDbMJCJ2NMkXe?usp=drive_link",
        "description": "Product Introduction：AJ4 high-top sneakers support custom full 3D printing. The upper made of microfiber and mesh is breathable and durable. TPR air-cushion sole offers cushioning to protect feet without chafing. Trendy silhouette matches all outfits year-round, available in a full range of sizes.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1hRzUggbbDRoBp47KWD8vIq9Ca-WbgZCv",
        "gallery": [
            "https://lh3.googleusercontent.com/d/19LLth1-7soMFYOqfUDz_dAlq89VXgHwA",
            "https://lh3.googleusercontent.com/d/1hRzUggbbDRoBp47KWD8vIq9Ca-WbgZCv"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "White"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AJ4 high-top sneakers white",
                "variant_id": "BZ77W-OUTSOLE-EVA-UPPER-PU",
                "location": "CN",
                "material": "Upper: Microfiber + Mesh + PVC Drip Molding\nOutsole: TPR with Air Cushion",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 425,
        "name": "3D Adults Baseball Cap",
        "slug": "3d-adults-baseball-cap-CRBQM",
        "sku": "CRBQM",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1a5OcfINC_8iMXASs1I3K9S77P5xKAUEp",
        "modified_at": 1773974356,
        "price": 15,
        "min_price": 15,
        "max_price": 20,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 17,
            "name": "Cap & Hat",
            "slug": "cap-hat",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/hat.jpg",
            "description": null,
            "modified_at": 1786348981
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1zR9Qk7ry_Qa-VYbISqzm_7StR7DgxxEh?usp=drive_link",
        "description": "Product Introduction：This blank white adult baseball cap supports full 3D all-over custom printing. It features a well-shaped design and breathable, durable fabric. Suitable for daily commutes and outdoor trips, customizable patterns make it a unique souvenir gift for festivals.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Crisp, durable, wrinkle-resistant, well-shaped and easy to maintain.<br />\n<br />\n3.Washing Instructions：Regular wash, medium iron. Do not wring, hang dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1a5OcfINC_8iMXASs1I3K9S77P5xKAUEp",
            "https://lh3.googleusercontent.com/d/1KCMLR_WoGMmQi13gv2Yks9ZOtW3Qvxq_"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "220g Twill"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Adults Baseball Cap",
                "variant_id": "CRBQM-ONE-SIZE-220G-TWILL",
                "location": "CN",
                "color": "3D",
                "material": "220g Twill",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 752,
        "name": "3D Adult Baseball Cap with Eyelets",
        "slug": "3d-adult-baseball-cap-with-eyelets-FP-CRBQMQK",
        "sku": "FP-CRBQMQK",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1wcz3PNsZ_eYNXSRbRD1gWsNgTe9DsM-D",
        "modified_at": 1777019950,
        "price": 15,
        "min_price": 15,
        "max_price": 20,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 17,
            "name": "Cap & Hat",
            "slug": "cap-hat",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/hat.jpg",
            "description": null,
            "modified_at": 1786348981
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1X7L3odd5tRQcGtMmBNMeiPT2gQGxx97J?usp=drive_link",
        "description": "Product Introduction：This plain white baseball cap supports full 3D custom all-over printing with breathable vents to keep your head cool all day long. Durable fabric suits outdoor trips and daily wear, and you can DIY unique patterns for creative holiday gifts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Wrinkle & wear resistant, quick-dry, non-deformable, easy care, colorfast.<br />\n<br />\n3.Washing Instructions：Cold gentle wash, machine washable. No high heat drying / bleach. Medium-low iron. Low shrinkage.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1wcz3PNsZ_eYNXSRbRD1gWsNgTe9DsM-D",
            "https://lh3.googleusercontent.com/d/11ku1MxPNcxk1gr1meg6_8Zy2bqR-Ycvp"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% Polyester"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Adult Baseball Cap with Eyelets",
                "variant_id": "FP-CRBQMQK-100-POLYESTER",
                "location": "CN",
                "color": "3D",
                "material": "100% Polyester",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 909,
        "name": "Slip-On Canvas Shoes",
        "slug": "slip-on-canvas-shoes-WK6W",
        "sku": "WK6W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1MqHLCEmY4TS9bJMqf-YYwGenqTiqv01Q",
        "modified_at": 1788516924,
        "price": 32,
        "min_price": 32,
        "max_price": 37,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1nYVqVIitDUg_uuSyMNFjt7PAXTlbBhX7?usp=drive_link",
        "description": "<p>Processing Time: 7-9 days</p><p>Shipping Time: 10-16 days for Logo+TM design<br />\n7-14 days for No logo+normal design</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1nYVqVIitDUg_uuSyMNFjt7PAXTlbBhX7?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/1Nkl88dy3HnFXc8H1Fjll_Xvq5ODoYj5Z",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1MqHLCEmY4TS9bJMqf-YYwGenqTiqv01Q",
            "https://lh3.googleusercontent.com/d/1Nkl88dy3HnFXc8H1Fjll_Xvq5ODoYj5Z"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Black"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Mesh Fabric + Tpu"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Slip-On Canvas Shoes",
                "variant_id": "WK6W",
                "location": "CN",
                "material": "Mesh Fabric + Tpu",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 308,
        "name": "AOP Shirt with Real Stitch Detailing",
        "slug": "aop-shirt-with-real-stitch-detailing-TOLNFLKS-Z",
        "sku": "TOLNFLKS-Z",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1lOECU0DE6dFaAyz1KQLIK6JLY0aUURoe",
        "modified_at": 1783584865,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1q2QxDE-tZCOrC6_eZVoULpDI2E-jD-_u?usp=drive_link",
        "description": "Product Introduction：Featuring authentic stitch detailing, this shirt delivers a premium, sporty look with added depth and durability. The comfortable fit ensures ease of movement, making it ideal for casual wear, team events, outdoor activities, or everyday styling. Easy to pair with jeans, shorts, or joggers for a polished and versatile appearance.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1LriXSrRcPxCIYDX9KwspkOju728yllHI",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1lOECU0DE6dFaAyz1KQLIK6JLY0aUURoe",
            "https://lh3.googleusercontent.com/d/1LriXSrRcPxCIYDX9KwspkOju728yllHI"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170g Polyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Real Stitch Detailing",
                "variant_id": "TOLNFLKS-Z-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 337,
        "name": "AOP Shoulder-Connected Short Sleeve Shirt",
        "slug": "aop-shoulder-connected-short-sleeve-shirt-MQAJBPJDX",
        "sku": "MQAJBPJDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1wg3_UWz-ieYFqnJq9xhi667icn1CHfbT",
        "modified_at": 1783584865,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1FuObeE2hosAB8E3QENrYoul4RJdOJ0eK?usp=drive_link",
        "description": "Product Introduction：Featuring a seamless shoulder-connected design, this short-sleeve shirt offers a clean, modern look with enhanced comfort and freedom of movement. The relaxed fit makes it ideal for casual outings, work, travel, or everyday wear. Easy to pair with jeans, shorts, or chinos, it delivers a versatile style suitable for any occasion.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1WjXVNCkNnBatZxFrG4slt2Xjd1hFYQ4m",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1wg3_UWz-ieYFqnJq9xhi667icn1CHfbT",
            "https://lh3.googleusercontent.com/d/1WjXVNCkNnBatZxFrG4slt2Xjd1hFYQ4m"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shoulder-Connected Short Sleeve Shirt",
                "variant_id": "MQAJBPJDX-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 231,
        "name": "3D Ugly Sweater",
        "slug": "3d-ugly-sweater-TBFZZWY",
        "sku": "TBFZZWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1fU5bxMxzLUncVpgLN3srpoW6S6kRSiQX",
        "modified_at": 1783584865,
        "price": 19.5,
        "min_price": 19.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ehobq8O-5HBZi9vfXNNRUpgZbr5HEuGw?usp=drive_link",
        "description": "Product Introduction：AOP 3D Ugly Sweater features a bold textured knit design with vibrant all-over print, offering a cozy relaxed fit and warm comfort. Perfect for holiday parties, winter gatherings, and festive events. Ideal for autumn and winter seasons. Great gift for friends or family. Easy to pair with jeans everyday style.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick textured fabric, warm & stretchy. Relaxed slim style, cozy without bulk in cold seasons.<br />\n<br />\n4.Washing Instructions：Hand wash preferred. Lay flat to dry. Do not hang.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1qhnrWsDTNls6Jxv_SJ_2h1fTSEPHm31R",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1fU5bxMxzLUncVpgLN3srpoW6S6kRSiQX",
            "https://lh3.googleusercontent.com/d/1qhnrWsDTNls6Jxv_SJ_2h1fTSEPHm31R"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL",
                    "XS"
                ]
            },
            {
                "option": "material",
                "values": [
                    "270gArtificial wool"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Ugly Sweater",
                "variant_id": "TBFZZWY-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 118,
        "name": "2D Bust String H oodie",
        "slug": "2d-bust-string-h-oodie-2DCSWY",
        "sku": "2DCSWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1YU3X9AY28W5-C8EbqABO0puHsHL7ajUA",
        "modified_at": 1785486868,
        "price": 25.5,
        "min_price": 25.5,
        "max_price": 30.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1w6_qLld-wq5vSqlXOMuq8LtJRs626Xnu?usp=drive_link",
        "description": "Product Introduction：The Bust String Hoodie features a unique drawstring detail that creates a stylish silhouette while offering a comfortable and adjustable fit. Made from soft and durable fabric, it is perfect for casual wear, street style, travel, or everyday layering. A trendy and versatile gift choice for fashion lovers, friends, or family on birthdays, holidays, or special occasions.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1reMAjIV9D-Vyd7ZQH6Q_Ql8DAqUZhtsa",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1YU3X9AY28W5-C8EbqABO0puHsHL7ajUA",
            "https://lh3.googleusercontent.com/d/1reMAjIV9D-Vyd7ZQH6Q_Ql8DAqUZhtsa"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Army Green",
                    "Blue",
                    "Khaki",
                    "Grey",
                    "Black",
                    "Pink"
                ]
            },
            {
                "option": "material",
                "values": [
                    "95% polyster+5% cotton"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Bust String H oodie",
                "variant_id": "2DCSWY-95-POLYSTER5-COTTON",
                "location": "CN",
                "material": "95% polyster+5% cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 169,
        "name": "AOP hooded baseball jacket",
        "slug": "aop-hooded-baseball-jacket-DMBQWT",
        "sku": "DMBQWT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1bvwget6H_C_tqu1J-40bznBq63-ikSyp",
        "modified_at": 1783584865,
        "price": 28.5,
        "min_price": 28.5,
        "max_price": 33.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1pRNu_iEtfPsPHf_lp0kbGKqIb0h42LRd?usp=drive_link",
        "description": "Product Introduction：This AOP hooded baseball jacket features a bold all-over print with contrasting sleeves, adjustable hood, and ribbed trims. Designed for a stylish streetwear look with a comfortable fit. Perfect for casual outings, sports, and daily wear. Ideal for spring, autumn, and mild winter. Easy to match with jeans or joggers.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1sKmuzQ2HwRgSvzya0w72KZHVRhqlB-vu",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1bvwget6H_C_tqu1J-40bznBq63-ikSyp",
            "https://lh3.googleusercontent.com/d/1sKmuzQ2HwRgSvzya0w72KZHVRhqlB-vu"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP hooded baseball jacket",
                "variant_id": "DMBQWT-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 271,
        "name": "3D Hockey Jersey",
        "slug": "3d-hockey-jersey-TBBBF",
        "sku": "TBBBF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1SE8PUQVvhXZcO3lbNLh_ewnQzooA4NLN",
        "modified_at": 1783584865,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1E0Jh9UdmHtzSsbsh7uEBD6FspOpWcTYK?usp=drive_link",
        "description": "Product Introduction：Made from lightweight 140g bird-eye polyester, this 3D hockey jersey offers excellent breathability and lasting comfort. The classic athletic fit allows unrestricted movement, while the vibrant all-over print creates a bold game-day look. Ideal for hockey games, training, casual wear, or team events, it also makes a great gift for sports enthusiasts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/176PyNCgdOoS9FTgBVJgmEmn7821KsC7M",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1SE8PUQVvhXZcO3lbNLh_ewnQzooA4NLN",
            "https://lh3.googleusercontent.com/d/176PyNCgdOoS9FTgBVJgmEmn7821KsC7M"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Hockey Jersey",
                "variant_id": "TBBBF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 255,
        "name": "3D Jogger",
        "slug": "3d-jogger-TBWK",
        "sku": "TBWK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1mItr07Thp9yMjpcjhLcfPL8acBOLVOrC",
        "modified_at": 1783584865,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1jwTfavZnQoxipLkT_oDC_Wl_ycvDjs3W?usp=drive_link",
        "description": "Product Introduction：Featuring a vibrant all-over print and a modern tapered fit, these 3D joggers deliver all-day comfort with a stylish look. The elastic waistband and cuffed ankles provide a secure fit, making them perfect for casual outings, travel, workouts, or lounging. A versatile gift for friends, family, or fitness enthusiasts year-round.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard rub/wring, shade dry, no sun/high iron to keep luster.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1mitDUkCjVs5IHZ8seV_qaa5aKR-c2MaT",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1mItr07Thp9yMjpcjhLcfPL8acBOLVOrC",
            "https://lh3.googleusercontent.com/d/1mitDUkCjVs5IHZ8seV_qaa5aKR-c2MaT"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Jogger",
                "variant_id": "TBWK-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2308,
        "name": "AOP Universal Ribbed Cuffed Sweatpants",
        "slug": "aop-universal-ribbed-cuffed-sweatpants-TBLWSJWK",
        "sku": "TBLWSJWK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/18LtbcWThR2aUjYYlJTVOu-CvAiIsQ8Yk",
        "modified_at": 1783584866,
        "price": 17.5,
        "min_price": 17.5,
        "max_price": 22.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1RPLLZtuIcEwHIlHz6jixohzwnpBLz4aW?usp=drive_link",
        "description": "Product Introduction：This AOP Universal Ribbed Cuffed Sweatpants features 3D all-over custom print, with an elastic waistband and ribbed cuffs for a snug, non-restrictive fit. Skin-friendly fabric offers soft comfort, while the loose fit ensures versatile casual wear—perfect for lounging, workouts, and daily outings.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1fEAcx8WXEx_maGOkjq2re9ygUkzH7v8o",
        "gallery": [
            "https://lh3.googleusercontent.com/d/18LtbcWThR2aUjYYlJTVOu-CvAiIsQ8Yk",
            "https://lh3.googleusercontent.com/d/1fEAcx8WXEx_maGOkjq2re9ygUkzH7v8o"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air Layer"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal Ribbed Cuffed Sweatpants",
                "variant_id": "TBLWSJWK",
                "location": "CN",
                "material": "200g Air Layer",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 309,
        "name": "AOP Long-Sleeve Hockey Cardigan",
        "slug": "aop-long-sleeve-hockey-cardigan-TOLNHLCXBQKS",
        "sku": "TOLNHLCXBQKS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1MdwJbHdn2nBfy2fkMCMC-5OrO9omXd73",
        "modified_at": 1783584865,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1H-0l90c1OB2a67F2_mRcEfQKasCsiBY3?usp=drive_link",
        "description": "Product Introduction：Designed with a classic button-front style and long sleeves, this AOP hockey cardigan combines sporty appeal with everyday comfort. The relaxed fit allows easy movement, making it ideal for hockey fans, team events, casual outings, or layering in cooler weather. Pairs effortlessly with jeans, joggers, or athletic wear for a versatile look.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1ffaY7EW3x_emHx0pEevhaZKtsI3mqTWd",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1MdwJbHdn2nBfy2fkMCMC-5OrO9omXd73",
            "https://lh3.googleusercontent.com/d/1ffaY7EW3x_emHx0pEevhaZKtsI3mqTWd"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan",
                "variant_id": "TOLNHLCXBQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 408,
        "name": "High Top Sports Shoes-2",
        "slug": "high-top-sports-shoes-2-D17BJ",
        "sku": "D17BJ",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1IOJAudEIHe_OrfE9SHKejoGtXd1avxQE",
        "modified_at": 1783418292,
        "price": 44,
        "min_price": 44,
        "max_price": 51,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1E4JjTQtU_ExcPHwo4P4d8lUwskxvZaw8?usp=drive_link",
        "description": "Product Introduction：Embossed high-top AJ1 with integrated heel molding, supports full-print custom personalization. Sturdy scratch-resistant microfiber upper, breathable 100% polyester mesh lining to protect feet. Full size range available, versatile for all seasons, ideal for daily outings and sporty outfits.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1RO0HkMrHb3vkYZnFJvTBxeBZkFJlzflD",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1IOJAudEIHe_OrfE9SHKejoGtXd1avxQE",
            "https://lh3.googleusercontent.com/d/1RO0HkMrHb3vkYZnFJvTBxeBZkFJlzflD"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-2",
                "variant_id": "D17BJ-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 852,
        "name": "2D Elderly Style Crossbody Bag",
        "slug": "2d-elderly-style-crossbody-bag-2DLNKXKB",
        "sku": "2DLNKXKB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/10en4Hj-qrTa6jnn4SUPLgFVbAfbkgyS-",
        "modified_at": 1785396355,
        "price": 22,
        "min_price": 22,
        "max_price": 27,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 18,
            "name": "Bag & Wallet",
            "slug": "bag-wallet",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/bag.jpg",
            "description": null,
            "modified_at": 1773762814
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1XKByD--Cg9QIsh1fMRnsMT6TQUkyRs4K?usp=drive_link",
        "description": "Product Introduction：Elegant handbag with crossbody strap designed for seniors, featuring delicate embossed texture and colorful tassel ornament. Spacious interior with multi compartments for easy storage, wear-resistant and practical for daily shopping and outings.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Wrinkle & wear resistant, colorfast, quick-dry & non-deformable, all-purpose bag fabric.<br />\n<br />\n3.Washing Instructions：Cold water wash. No bleach or sun exposure, dry in shade.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/10VHjUUPdVKsg3dLcFmhbuYgmqq1BW5Fu",
        "gallery": [
            "https://lh3.googleusercontent.com/d/10en4Hj-qrTa6jnn4SUPLgFVbAfbkgyS-",
            "https://lh3.googleusercontent.com/d/10VHjUUPdVKsg3dLcFmhbuYgmqq1BW5Fu"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "one size"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Gray",
                    "Pink",
                    "Khaki",
                    "Burgundy",
                    "Blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU Leather"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Elderly Style Crossbody Bag",
                "variant_id": "2DLNKXKB-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Elderly Style Crossbody Bag",
                "variant_id": "2DLNKXKB-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "color": "Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Elderly Style Crossbody Bag",
                "variant_id": "2DLNKXKB-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Elderly Style Crossbody Bag",
                "variant_id": "2DLNKXKB-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Elderly Style Crossbody Bag",
                "variant_id": "2DLNKXKB-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Elderly Style Crossbody Bag",
                "variant_id": "2DLNKXKB-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 237,
        "name": "3D Long-sleeved T-shirt",
        "slug": "3d-long-sleeved-t-shirt-TBCXT",
        "sku": "TBCXT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ElY7JJEagYkQ_BxbXy--JfDhuTSV8jyH",
        "modified_at": 1783584865,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1MCJXznxQ6mCoX2BNlVn860HiX_PPBDVo?usp=drive_link",
        "description": "Product Introduction：Soft 3D long-sleeved T-shirt with a sleek, body-friendly fit that enhances a clean and modern silhouette. Ideal for casual wear, office layering, travel, and light outdoor activities. Suitable for men seeking comfort and versatility. Perfect gift for birthdays or holidays. Wear in spring, autumn, or cool summer evenings, easy to style.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/10oJrMgZJFsoF_QVoefLzW0ijonv2MmyV",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ElY7JJEagYkQ_BxbXy--JfDhuTSV8jyH",
            "https://lh3.googleusercontent.com/d/10oJrMgZJFsoF_QVoefLzW0ijonv2MmyV"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170g Polyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Long-sleeved T-shirt",
                "variant_id": "TBCXT-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 126,
        "name": "2D three pocket sweatshirt",
        "slug": "2d-three-pocket-sweatshirt-SKDWY",
        "sku": "SKDWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1bWHoGRk4xmFcXz3Y0YrOtH9dw_T1xBSH",
        "modified_at": 1785486868,
        "price": 25.5,
        "min_price": 25.5,
        "max_price": 30.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1HaOPkZbMZZ8E1O31kvnXL7BK4YYp15e5?usp=drive_link",
        "description": "Product Introduction：This 2D three-pocket sweatshirt, available in 6 colors (sizes S–3XL), features a half-zip hooded design and functional pockets. Its tailored fit offers casual utility, ideal for spring/autumn layering, easy to style, and a practical gift for everyday wearers.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1mrK0esY9eTy1_mN7QB2KSizNcQ-yfljG",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1bWHoGRk4xmFcXz3Y0YrOtH9dw_T1xBSH",
            "https://lh3.googleusercontent.com/d/1mrK0esY9eTy1_mN7QB2KSizNcQ-yfljG"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Burgundy",
                    "Military green",
                    "Khaki",
                    "Blue",
                    "Dark blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Military green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Dark blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Military green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Dark blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Military green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Dark blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Military green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Dark blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Military green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Dark blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Burgundy",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Military green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D three pocket sweatshirt",
                "variant_id": "SKDWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Dark blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2832,
        "name": "AOP Crew neck realistic line hockey cardigan",
        "slug": "aop-crew-neck-realistic-line-hockey-cardigan-TOLYLZSXTBQKS",
        "sku": "TOLYLZSXTBQKS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/19f2dLW27UZuUTgIxPYJs4vI4FtDZPxXL",
        "modified_at": 1790045387,
        "price": 15.5,
        "min_price": 15.5,
        "max_price": 20.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ybs6F5n1--cepfpl9Rbtakrm9hFG5Huf?usp=drive_link",
        "description": "Product Introduction：This AOP crew neck hockey cardigan features bold all-over prints with realistic line detailing that captures the dynamic spirit of the sport. The classic crew neck design offers a clean, timeless look, while the relaxed fit ensures easy layering and all-day comfort. Made from soft, durable fabric, it provides cozy warmth for cooler days. Available in sizes S through 5XL, it's perfect for hockey games, casual outings, or team gatherings. A great gift for players, fans, or sports enthusiasts for birthdays or championship celebrations. Suitable for autumn, winter, and early spring, it pairs effortlessly with tees, jeans, or joggers—style with sneakers or boots for a sporty, confident look that stands out on and off the rink.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Bird-eye polyster,Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1l24yPfQnwXt71yAujh-quiohCzTy1Xwn",
        "gallery": [
            "https://lh3.googleusercontent.com/d/19f2dLW27UZuUTgIxPYJs4vI4FtDZPxXL",
            "https://lh3.googleusercontent.com/d/1BhQhMhmnMF_hEV_dSiFWgu6e0Tk9caWM",
            "https://lh3.googleusercontent.com/d/1AtBsjQE4uuCOV5A8obPYHwNR8JrLr0QY",
            "https://lh3.googleusercontent.com/d/1QWs8fLU01SFyekFO5QdkHsYKrcuPSxpH",
            "https://lh3.googleusercontent.com/d/1l24yPfQnwXt71yAujh-quiohCzTy1Xwn"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "L",
                    "XL",
                    "M",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    ""
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Crew neck realistic line hockey cardigan",
                "variant_id": "TOLYLZSXTBQKS",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2519,
        "name": "AOP Mesh panel short sleeve T shirt",
        "slug": "aop-mesh-panel-short-sleeve-t-shirt-DDBPJDX",
        "sku": "DDBPJDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ZA7FBYitaw_Q8DjxACIGvyYflF-oe2zA",
        "modified_at": 1783584867,
        "price": 15.5,
        "min_price": 15.5,
        "max_price": 20.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1K0-7R-84KhzxvraO1W-bX8QDB9uE9pB8?usp=drive_link",
        "description": "Product Introduction：Mesh spliced V-neck longline short sleeve tee fully customizable with full 3D all-over prints. Loose draping fit, breathable mesh for summer sports & daily commute, simple standalone wear, unique custom gifts for men on holidays.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n4.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1ENl-Tlr8cVVIJFhuTMPiqIRvjXIWq8cL",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ZA7FBYitaw_Q8DjxACIGvyYflF-oe2zA",
            "https://lh3.googleusercontent.com/d/1ENl-Tlr8cVVIJFhuTMPiqIRvjXIWq8cL"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% Polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Mesh panel short sleeve T shirt",
                "variant_id": "DDBPJDX",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 720,
        "name": "UV printing-40Oz Stainless Steel Tumbler",
        "slug": "uv-printing-40oz-stainless-steel-tumbler-BBBUV",
        "sku": "BBBUV",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/113D5lu9w5N3ngIz_sE0AXOuJGfjEO7yG",
        "modified_at": 1784270350,
        "price": 19.5,
        "min_price": 19.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 15,
            "name": "Drinkware",
            "slug": "drinkware",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/drinkware.jpg",
            "description": null,
            "modified_at": 1773763799
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1aahAyCz1-ad3-crfOgEma2jV4J6IQQeQ?usp=drive_link",
        "description": "Product Introduction：This 40oz stainless steel tumbler features 3D all-over print customization. With long-lasting UV printing and a comfortable handle, it offers double-wall insulation and a leak-proof design, ideal for daily use as a practical personalized gift.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Drop-proof | Leakproof | Insulated for hot & cold | Lightweight, ideal for daily & outdoor use.<br />\n<br />\n3.Washing Instructions：Regular hand wash, periodic seal cleaning. No steel wool / acid cleaners; no carbonated & alkaline beverages; Do not heat empty.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/113D5lu9w5N3ngIz_sE0AXOuJGfjEO7yG"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "40oz"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Green",
                    "Gray",
                    "Brown",
                    "Light blue",
                    "White",
                    "Light pink",
                    "Magenta"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Stainless Steel"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Gray",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Light blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Light pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler",
                "variant_id": "BBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Magenta",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 721,
        "name": "UV printing-40Oz Stainless Steel Tumbler-2",
        "slug": "uv-printing-40oz-stainless-steel-tumbler-2-EDBBBUV",
        "sku": "EDBBBUV",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/10OwMxMhuBlKs2lyjjk2GdNYnEFVoG3j7",
        "modified_at": 1784270350,
        "price": 20.5,
        "min_price": 20.5,
        "max_price": 25.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 15,
            "name": "Drinkware",
            "slug": "drinkware",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/drinkware.jpg",
            "description": null,
            "modified_at": 1773763799
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/12q-xbE_YxZJP8TK6DUbIYAso54koD2f5?usp=drive_link",
        "description": "Product Introduction：This 40oz stainless steel tumbler-2 features 3D all-over print customization. With long-lasting UV printing and a comfortable handle, it offers double-wall insulation and a leak-proof design, ideal for daily use as a practical personalized gift.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Drop-proof | Leakproof | Insulated for hot & cold | Lightweight, ideal for daily & outdoor use.<br />\n<br />\n3.Washing Instructions：Regular hand wash, periodic seal cleaning. No steel wool / acid cleaners; no carbonated & alkaline beverages; Do not heat empty.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/10OwMxMhuBlKs2lyjjk2GdNYnEFVoG3j7"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "40OZ"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Rose quartz",
                    "Storm Sea",
                    "Tree",
                    "Black",
                    "Light green",
                    "Light purple",
                    "Red rust",
                    "Fog color",
                    "Gulf leaves",
                    "White",
                    "Lake blue",
                    "Light blue",
                    "Charcoal",
                    "Sand dunes",
                    "Barbie pink",
                    "Cream white",
                    "Light pink",
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Stainless Steel"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Rose quartz",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Storm Sea",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Tree",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Light green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Light purple",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Red rust",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Fog color",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Gulf leaves",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Lake blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Light blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Charcoal",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Sand dunes",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Barbie pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Cream white",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "Light pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "UV printing-40Oz Stainless Steel Tumbler-2",
                "variant_id": "EDBBBUV-40OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "40OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "color": "3D",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 383,
        "name": "Alloy Luxury Quartz Watch",
        "slug": "alloy-luxury-quartz-watch-5033SB",
        "sku": "5033SB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/13uUkd_LY4fvTWALd6-4xHWVuGj62SoIT",
        "modified_at": 1783936881,
        "price": 18.5,
        "min_price": 18.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 7,
            "name": "Watch",
            "slug": "watch",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/watch.jpg",
            "description": null,
            "modified_at": 1773193285
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/144hjwZ5b_cvKS_4Z4BTNwvAB7oM3Py4W?usp=drive_link",
        "description": "Product Introduction：Classic business style, bold dial with a steady strap, practical date function for everyday convenience. Great for office work and business meetings, solid craftsmanship with lasting durability, exudes professionalism.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Harder than regular metal, sturdy, fine texture, great value.<br />\n<br />\n3.Packaging：No box|Standard Paper Box|Luxury Leather Box<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1Ua93ihwjmhqYB9_Njgb0IG_YIB-q1sof",
        "gallery": [
            "https://lh3.googleusercontent.com/d/13uUkd_LY4fvTWALd6-4xHWVuGj62SoIT",
            "https://lh3.googleusercontent.com/d/1Ua93ihwjmhqYB9_Njgb0IG_YIB-q1sof"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "Gold",
                    "Black",
                    "Steel",
                    "Silver+Gold Chain",
                    "Silver Gold"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Alloy material"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "No box",
                    "Standard Paper Box",
                    "Luxury Leather Box"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "color": "Gold",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "color": "Steel",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "color": "Silver+Gold Chain",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18.5,
                        "non_contiguous": 23.5
                    },
                    "EU": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    },
                    "CA": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "color": "Silver Gold",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Gold",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Steel",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Silver+Gold Chain",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "color": "Silver Gold",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "color": "Gold",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "color": "Steel",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "color": "Silver+Gold Chain",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Alloy Luxury Quartz Watch",
                "variant_id": "5033SB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "color": "Silver Gold",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 384,
        "name": "3755 Stainless Steel Watch",
        "slug": "3755-stainless-steel-watch-3755SBSWK",
        "sku": "3755SBSWK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ZPdTSKJjRPa05Jlo6Zc4J5mHZgQ9NAsT",
        "modified_at": 1783936881,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 22.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 7,
            "name": "Watch",
            "slug": "watch",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/watch.jpg",
            "description": null,
            "modified_at": 1773193285
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1oBiXgNR0D8RcM-HhJbjLZmswwl9cd52L?usp=drive_link",
        "description": "Product Introduction：Retro artistic design, round dial full of vintage charm, premium textured strap. Adds character to daily outfits and cultural events, precise and reliable timekeeping, outstanding quality. <br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution. <br />\n<br />\n2.Material：Harder than regular metal, sturdy, fine texture, great value. <br />\n<br />\n3.Packaging：No box|Standard Paper Box|Luxury Leather Box <br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is. <br />\n<br />\n5.Here are the key points to note： <br />\n<br />\n- Product images are for reference only. <br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity. <br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1P4r-28KmH_SQ52nMqv5oKROnB7beXcQW",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ZPdTSKJjRPa05Jlo6Zc4J5mHZgQ9NAsT",
            "https://lh3.googleusercontent.com/d/1P4r-28KmH_SQ52nMqv5oKROnB7beXcQW"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "Black",
                    "Silver"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Alloy material"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "No box",
                    "Standard Paper Box",
                    "Luxury Leather Box"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3755 Stainless Steel Watch",
                "variant_id": "3755SBSWK-ONE-COLOR-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3755 Stainless Steel Watch",
                "variant_id": "3755SBSWK-ONE-COLOR-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "color": "Silver",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3755 Stainless Steel Watch",
                "variant_id": "3755SBSWK-ONE-COLOR-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3755 Stainless Steel Watch",
                "variant_id": "3755SBSWK-ONE-COLOR-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Silver",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3755 Stainless Steel Watch",
                "variant_id": "3755SBSWK-ONE-COLOR-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3755 Stainless Steel Watch",
                "variant_id": "3755SBSWK-ONE-COLOR-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "color": "Silver",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 580,
        "name": "Adult Crocs-Black",
        "slug": "adult-crocs-black-BZ39",
        "sku": "BZ39",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1qtL06a4YxRY7Bndf3HqMAh5ryAJpmNbV",
        "modified_at": 1783418292,
        "price": 20,
        "min_price": 20,
        "max_price": 25,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1G_rnfjmn5d_GhlZOyJDeX6pve9IedZim?usp=drive_link",
        "description": "<p>Processing Time: 7-9 days</p><p>Shipping Time: 10-16 days for Logo+TM design<br />\n7-14 days for No logo+normal design</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1G_rnfjmn5d_GhlZOyJDeX6pve9IedZim?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/1-Dj8nBk2DSkDx465IcsDCILzROuFzF21",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1qtL06a4YxRY7Bndf3HqMAh5ryAJpmNbV",
            "https://lh3.googleusercontent.com/d/1-Dj8nBk2DSkDx465IcsDCILzROuFzF21"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "EVA"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Crocs-Black",
                "variant_id": "BZ39-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2086,
        "name": "2D Cargo Denim Jacket",
        "slug": "2d-cargo-denim-jacket-2DGZNZ",
        "sku": "2DGZNZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1d8GnNEgiEWmHJwhgPg0Zp2_gRCaHfxI5",
        "modified_at": 1785486868,
        "price": 28.5,
        "min_price": 28.5,
        "max_price": 33.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1JY7GSGxKxwLgZD0FemiOjXo5srNwESu3?usp=drive_link",
        "description": "Product Introduction：This 2D Cargo Denim Jacket (Black/LightBlue/DarkBlue, sizes S–5XL) features a classic trucker fit with vintage stitching. Its durable denim and functional pockets create a rugged street-style look, ideal for spring/autumn casual outings, work, or as a timeless gift for men. Easy to pair with jeans or chinos.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Thick & durable, scratch-proof, good shape retention. Stylish with age, versatile wear.<br />\n<br />\n3.Washing Instructions：Cold wash inside out. Wash alone initially to avoid color run. Minimal bleach.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1F1gFLkR9uQ21OKDO7RTVGtcDsgDqahxk",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1d8GnNEgiEWmHJwhgPg0Zp2_gRCaHfxI5",
            "https://lh3.googleusercontent.com/d/1F1gFLkR9uQ21OKDO7RTVGtcDsgDqahxk"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "LightBlue",
                    "DarkBlue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Denim"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "S",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "S",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "M",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "M",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "L",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "L",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "2XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "2XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "3XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "3XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "4XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "4XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "5XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "5XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Cargo Denim Jacket",
                "variant_id": "2DGZNZ",
                "location": "CN",
                "material": "Denim",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28.5,
                        "non_contiguous": 33.5
                    },
                    "EU": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    },
                    "CA": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "size": "5XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2182,
        "name": "AOP Bomber Jacket Lightweight",
        "slug": "aop-bomber-jacket-lightweight-FXYJKB",
        "sku": "FXYJKB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ebNEHOQMH9Yo5hD6vj7iVnzoFt4PcrcR",
        "modified_at": 1783584866,
        "price": 25.5,
        "min_price": 25.5,
        "max_price": 30.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1HzTyiMhFY9EsPXfjlQX1lp5-29IWmFAz?usp=drive_link",
        "description": "Product Introduction：This lightweight Bomber Jacket features 3D all-over personalized printing, with a classic contrast ribbed collar and cuffs. Available in sizes XS–5XL, it offers a relaxed, stylish fit perfect for casual outings and streetwear looks. Ideal for spring and autumn, it’s a great gift for fashion lovers and pairs easily with any bottoms.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1FyVQ_NDHhSCFd_OMR8ZyPJr2LeO2hrsm",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ebNEHOQMH9Yo5hD6vj7iVnzoFt4PcrcR",
            "https://lh3.googleusercontent.com/d/1FyVQ_NDHhSCFd_OMR8ZyPJr2LeO2hrsm"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Broken Card Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Bomber Jacket Lightweight",
                "variant_id": "FXYJKB",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 193,
        "name": "AOP Thick bomber jacket",
        "slug": "aop-thick-bomber-jacket-FXYJK",
        "sku": "FXYJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1eBSey_hV1d_f_qlPp2rHYNZ8AA8eOOp4",
        "modified_at": 1783584865,
        "price": 36.5,
        "min_price": 36.5,
        "max_price": 41.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1OWVPFlcJPGvpIYsTAWFpg4xA8cJdCRQD?usp=drive_link",
        "description": "Product Introduction：Thick bomber jacket featuring padded silhouette with contrast black collar, cuffs, and hem. Subtle all-over print adds modern streetwear touch. Designed for warmth and comfort, it offers structured fit ideal for commuting, travel, and casual outings. Perfect for autumn and winter layering. Easy to pair with jeans or sneakers look.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1CyrWtEccXPVX6jVhyN8Kyi4UepzoKLF3",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1eBSey_hV1d_f_qlPp2rHYNZ8AA8eOOp4",
            "https://lh3.googleusercontent.com/d/1CyrWtEccXPVX6jVhyN8Kyi4UepzoKLF3"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "130g Broken twill fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Thick bomber jacket",
                "variant_id": "FXYJK-130G-BROKEN-TWILL-FABRIC",
                "location": "CN",
                "material": "130g Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36.5,
                        "non_contiguous": 41.5
                    },
                    "EU": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    },
                    "CA": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34.5,
                        "non_contiguous": 39.5
                    },
                    "EU": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    },
                    "CA": {
                        "mainland": 39.5,
                        "non_contiguous": 39.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2183,
        "name": "AOP Lightweight Bomber Jacket With Placket",
        "slug": "aop-lightweight-bomber-jacket-with-placket-FXYJKB-1",
        "sku": "FXYJKB-1",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/15XzYl84azj-GSzkxEe7U8W7eKZ8f4_9T",
        "modified_at": 1783584866,
        "price": 25.5,
        "min_price": 25.5,
        "max_price": 30.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1-Sk8jlz45JvgfBMbJJbkfKRo_bTcqCWX?usp=drive_link",
        "description": "Product Introduction：This placket-equipped lightweight bomber jacket supports 3D full-print customisation, available in XS-5XL. Contrast rib trim elevates its trendy look, fits spring and autumn wear, matches various bottoms well, and works as nice holiday gifts for street-style enthusiasts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1RYramA4TaLP2B8LxtImadpavfdtBbvTg",
        "gallery": [
            "https://lh3.googleusercontent.com/d/15XzYl84azj-GSzkxEe7U8W7eKZ8f4_9T",
            "https://lh3.googleusercontent.com/d/1RYramA4TaLP2B8LxtImadpavfdtBbvTg"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Broken Card Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket",
                "variant_id": "FXYJKB-1",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2184,
        "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
        "slug": "aop-lightweight-bomber-jacket-with-placket-without-sleeve-pocket-FXYJKB-2",
        "sku": "FXYJKB-2",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1zs0Glc3LtnE8DQlcYQDQjqr9HqZA3vTp",
        "modified_at": 1783584866,
        "price": 25.5,
        "min_price": 25.5,
        "max_price": 30.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1Qj45saLSqpLyDOiIUZwY-0V4G_gWySUA?usp=drive_link",
        "description": "Product Introduction：This lightweight bomber jacket with placket (no sleeve pockets) features 3D all-over custom printing, available in XS–5XL. Its sleek contrast rib design offers a relaxed fit, ideal for spring/autumn casual outings, easy to match, and a great gift for fashion lovers.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1avfdaz3cWxKGViqlcVy-0XuTC197Ze3g",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1zs0Glc3LtnE8DQlcYQDQjqr9HqZA3vTp",
            "https://lh3.googleusercontent.com/d/1avfdaz3cWxKGViqlcVy-0XuTC197Ze3g"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Broken Card Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Lightweight Bomber Jacket With Placket Without Sleeve Pocket",
                "variant_id": "FXYJKB-2",
                "location": "CN",
                "material": "Broken Card Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 305,
        "name": "AOP Basketball V-Neck Cardigan",
        "slug": "aop-basketball-v-neck-cardigan-TOLVLLQKS",
        "sku": "TOLVLLQKS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1uA_1FT0Suu_fxFDYFIN2rjcOvrtpYQri",
        "modified_at": 1783584865,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1pVHVSA-UhOkfLgDKAa223zMACaUbvYcL?usp=drive_link",
        "description": "Product Introduction：Designed with a classic V-neck and button-front style, this basketball cardigan delivers a clean athletic look with everyday comfort. The relaxed fit allows unrestricted movement, making it perfect for basketball games, team events, training sessions, or casual wear. Easy to pair with basketball shorts, joggers, or jeans for a sporty, versatile outfit.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1mCp4b_Xdmb1peIIrXBGGKeYCqaVADJVV",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1uA_1FT0Suu_fxFDYFIN2rjcOvrtpYQri",
            "https://lh3.googleusercontent.com/d/1mCp4b_Xdmb1peIIrXBGGKeYCqaVADJVV"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Basketball V-Neck Cardigan",
                "variant_id": "TOLVLLQKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2110,
        "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
        "slug": "aop-brazilian-collar-shirt-megbxlcs-MEGBXLCS",
        "sku": "MEGBXLCS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1sKma2oNJGulHduIKD5yxhN-f_7r47F0o",
        "modified_at": 1783584865,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1Ho-58-fnpxGSXkTF03WJFYrLNOOywihU?usp=drive_link",
        "description": "Product Introduction：This Cuban-collar shirt features eye-catching 3D all-over custom printing, available in sizes S–5XL. The relaxed fit is lightweight and stylish, perfect for beach days or casual outings, easy to match, and a great gift for all ages in warm seasons.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Skin-friendly & unrestricted. 4-way super stretch, flexible, body-hugging and shape-retaining.<br />\n<br />\n4.Washing Instructions：Cold gentle wash. No hard rubbing or wringing. No bleach. Low heat tumble dry / shade dry. No high heat ironing, to retain elasticity.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/10C2hu0rHCS3NsnvPdnaK7_5omRckgmgV",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1sKma2oNJGulHduIKD5yxhN-f_7r47F0o",
            "https://lh3.googleusercontent.com/d/10C2hu0rHCS3NsnvPdnaK7_5omRckgmgV"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Four-side strench polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Brazilian Collar Shirt-MEGBXLCS",
                "variant_id": "MEGBXLCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 262,
        "name": "3D Button Baseball Jacket",
        "slug": "3d-button-baseball-jacket-BBJKJRNL",
        "sku": "BBJKJRNL",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1E9d422CiF4Mh_y4Gel2f-_OwHTlJFMVh",
        "modified_at": 1783584865,
        "price": 23.5,
        "min_price": 23.5,
        "max_price": 28.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/13XxmOg0bAH8KOMHKd0hWE56caTeVG0Hi?usp=drive_link",
        "description": "Product Introduction：Featuring a classic snap-button front and vibrant all-over print, this 3D baseball jacket delivers a timeless sporty look with everyday comfort. The relaxed fit makes it easy to layer over T-shirts or hoodies, perfect for casual outings, school, travel, and outdoor activities. A stylish gift for sports fans, friends, or family in spring and autumn.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1rOoWIEPuerrqKDyJPdBqLCLFGnMzb6dk",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1E9d422CiF4Mh_y4Gel2f-_OwHTlJFMVh",
            "https://lh3.googleusercontent.com/d/1rOoWIEPuerrqKDyJPdBqLCLFGnMzb6dk"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Button Baseball Jacket",
                "variant_id": "BBJKJRNL-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2971,
        "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
        "slug": "aop-mhn-zip-hoodie-250-japanese-fabric-MHNLLLMSRBU250",
        "sku": "MHNLLLMSRBU250",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Lebo7PCq1yl7j0dmuu9VzIIUcyDOTl3I",
        "modified_at": 1790045387,
        "price": 21.5,
        "min_price": 21.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1wVlK2G-xfzzJgeQCSxZ8molha0PwAFfA?usp=drive_link",
        "description": "Product Introduction：This full-zip hooded jacket is made of 250g fabric with a loose dropped-shoulder silhouette and practical side pockets. The material is soft and breathable, supporting 3D all-over print customization. It works great as outerwear in spring and autumn, offered in multiple unisex sizes.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：High density & color fastness, no fading or pilling. Smooth, draping, wrinkle-resistant and durable. Shape-retaining, skin-friendly and breathable.<br />\n<br />\n4.Washing Instructions：Lukewarm wash. No high heat drying. Do not wring vigorously.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1eyVYu8vjdwtdqJU2MeVTK0W_skE-Rnyi",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Lebo7PCq1yl7j0dmuu9VzIIUcyDOTl3I",
            "https://lh3.googleusercontent.com/d/1j5HONY_BNeM6t0tcJ7QK60ewJXPtfcXc",
            "https://lh3.googleusercontent.com/d/1BYBooHOP001pDia-QCawfItnP5KhtnkN",
            "https://lh3.googleusercontent.com/d/11_V9QazJxTVtak1Q4tqX8wvYfJfmrScP",
            "https://lh3.googleusercontent.com/d/1eyVYu8vjdwtdqJU2MeVTK0W_skE-Rnyi"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "250g Micro Fleece"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Zip Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLLLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2972,
        "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
        "slug": "aop-egd-japanese-fabric-crew-neck-sweatshirt-250g-EGDRBBYLWY250",
        "sku": "EGDRBBYLWY250",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1I-zIBguF-Fi5_F6LMeg7h6iag3KxJYNr",
        "modified_at": 1790045387,
        "price": 19.5,
        "min_price": 19.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1X4Wd5VPd3FdZMEpzJ4H8TayszLBs46Pm?usp=drive_link",
        "description": "Product Introduction：This crewneck sweatshirt is made of 250g fabric with a neat simple round neck. The loose fit suits all body types, crafted from soft, skin-friendly and breathable material. It supports 3D all-over print customization, ideal for inner or outer wear in spring and autumn, available in full unisex sizes.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：High density & color fastness, no fading or pilling. Smooth, draping, wrinkle-resistant and durable. Shape-retaining, skin-friendly and breathable.<br />\n<br />\n4.Washing Instructions：Lukewarm wash. No high heat drying. Do not wring vigorously.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1xlpqOVcNoXD-R67rACLKuyRFqZAg16dL",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1I-zIBguF-Fi5_F6LMeg7h6iag3KxJYNr",
            "https://lh3.googleusercontent.com/d/1po6yGmwzl2yrv6FulCV8ciCXX1okZ3W5",
            "https://lh3.googleusercontent.com/d/16D4ePFNwwa23WLPIWyEFzAcQnDvwWJpo",
            "https://lh3.googleusercontent.com/d/1CEByxPvBQ4IxF7lYN4eDYCdwsy4WXkTN",
            "https://lh3.googleusercontent.com/d/1xlpqOVcNoXD-R67rACLKuyRFqZAg16dL"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "250g Micro Fleece"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Japanese Fabric Crew Neck Sweatshirt 250g",
                "variant_id": "EGDRBBYLWY250-SLXLM2XL3XL4XL5XL",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2970,
        "name": "AOP MHN Hoodie 250, Japanese Fabric",
        "slug": "aop-mhn-hoodie-250-japanese-fabric-MHNLMSRBU250",
        "sku": "MHNLMSRBU250",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1fe1HLAWa3Tqg_2HQllf7_R3HdUPwie-E",
        "modified_at": 1790045387,
        "price": 21.5,
        "min_price": 21.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1tUcAM6u5ynDAzM8d54pj_BPHseU-YG0O?usp=drive_link",
        "description": "Product Introduction：This hoodie is crafted from 250g fabric with a relaxed dropped-shoulder cut and a practical front kangaroo pocket. Made of soft and breathable material, it supports 3D all-over print customization, easy to match for daily wear in spring and autumn, and available in full unisex sizes.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：High density & color fastness, no fading or pilling. Smooth, draping, wrinkle-resistant and durable. Shape-retaining, skin-friendly and breathable.<br />\n<br />\n4.Washing Instructions：Lukewarm wash. No high heat drying. Do not wring vigorously.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/12vsZ-9Yl_KdetNXo9ajHLaiMYYAnJwZl",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1fe1HLAWa3Tqg_2HQllf7_R3HdUPwie-E",
            "https://lh3.googleusercontent.com/d/1NrFJ-Sc_6bn2h3irVpEUijZTLV29J-9R",
            "https://lh3.googleusercontent.com/d/1XNy2TvZmc4YsHe5ZrIExacnYp-OFeYou",
            "https://lh3.googleusercontent.com/d/1UeWj_4Z7pT7hRzuHzr4fdKQOP0aQLAWA",
            "https://lh3.googleusercontent.com/d/12vsZ-9Yl_KdetNXo9ajHLaiMYYAnJwZl"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "250g Micro Fleece"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MHN Hoodie 250, Japanese Fabric",
                "variant_id": "MHNLMSRBU250",
                "location": "CN",
                "material": "250g Micro Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 307,
        "name": "AOP Shirt with Front Logo",
        "slug": "aop-shirt-with-front-logo-TOLNFLKS-B",
        "sku": "TOLNFLKS-B",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1JIASsEcnGQ4vhxc9gXQyZ1BjqeA8p0N-",
        "modified_at": 1783584865,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1PL2IQOqZ5S3MiL-WqpahkQjU1sq7QxWZ?usp=drive_link",
        "description": "Product Introduction：Designed with a clean front logo, this shirt offers a modern, eye-catching look for everyday wear. The comfortable fit allows easy movement, making it ideal for casual outings, team events, streetwear, or weekend activities. Easy to pair with jeans, shorts, or joggers for a stylish and versatile outfit.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1JOlv42H7hmJU3jUIiJ6doTeNHfAK8EDg",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1JIASsEcnGQ4vhxc9gXQyZ1BjqeA8p0N-",
            "https://lh3.googleusercontent.com/d/1JOlv42H7hmJU3jUIiJ6doTeNHfAK8EDg"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Mesh material"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Shirt with Front Logo",
                "variant_id": "TOLNFLKS-B-MESH-MATERIAL",
                "location": "CN",
                "material": "Mesh material",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2171,
        "name": "AOP European Size Crew Neck Short Sleeve",
        "slug": "aop-european-size-crew-neck-short-sleeve-AIOTX",
        "sku": "AIOTX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1NxJsDIon41basZDr5NGWL5AOtq9ZuSoG",
        "modified_at": 1783584866,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ed2hPecqzGQ0gsSHHYkYEfIArrxtAH0p?usp=drive_link",
        "description": "Product Introduction：This European Size Crew Neck Short Sleeve T-shirt, available in sizes XS–5XL, features 3D all-over custom printing. With a classic crew neck and soft breathable fabric, it offers a regular fit, ideal for casual daily wear, street style, and gifting, perfect for summer and easy to pair with jeans or shorts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/10lCCDsXKo9DUr4o6XdWXxFhBqyLJsNwd",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1NxJsDIon41basZDr5NGWL5AOtq9ZuSoG",
            "https://lh3.googleusercontent.com/d/10lCCDsXKo9DUr4o6XdWXxFhBqyLJsNwd"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "XS"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170gPolyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size Crew Neck Short Sleeve",
                "variant_id": "AIOTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 590,
        "name": "Adult Punchy Shoes",
        "slug": "adult-punchy-shoes-CRDDX",
        "sku": "CRDDX",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1MBr7C045d5bFVcDHjbhNcO3LGiGVL-7P",
        "modified_at": 1784624763,
        "price": 18,
        "min_price": 18,
        "max_price": 23,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1EuQbd2QdbyLY-kXweuRkOCG_EuN8DGSP?usp=drive_link",
        "description": "<p>Processing Time: 7-9 days</p><p>Shipping Time: 10-16 days for Logo+TM design<br />\n7-14 days for No logo+normal design</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1EuQbd2QdbyLY-kXweuRkOCG_EuN8DGSP?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/1L5Mj5iYZtoAvEgduHlig7QwvZjvSPL0u",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1MBr7C045d5bFVcDHjbhNcO3LGiGVL-7P",
            "https://lh3.googleusercontent.com/d/1IQQsuNtVNeiFEFLGRZenR5NQIn8PC9Ee",
            "https://lh3.googleusercontent.com/d/1VTf2TYz80n_a_a2dORaDxqHEVj_ywXWl",
            "https://lh3.googleusercontent.com/d/1L5Mj5iYZtoAvEgduHlig7QwvZjvSPL0u"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "EVA"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Adult Punchy Shoes",
                "variant_id": "CRDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2459,
        "name": "AOP HNH Collared button polo shirt",
        "slug": "aop-hnh-collared-button-polo-shirt-HNHFLMKPL",
        "sku": "HNHFLMKPL",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1EZhLWcKIeXgSlbesV6kkkwreRYPCeAuE",
        "modified_at": 1783584866,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/13KCjmkd6Hz270HUWGE4P1kYI7Hy6I36h?usp=drive_link",
        "description": "Product Introduction：AOP HNH Collared button polo shirt with custom 3D all-over print, neat tailored fit, breathable fabric, sizes S-8XL, perfect for work, group events and personalized holiday gifts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1dwB4OvVMMdNaTH0m6oNbLGf2nErmfc-G",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1EZhLWcKIeXgSlbesV6kkkwreRYPCeAuE",
            "https://lh3.googleusercontent.com/d/1dwB4OvVMMdNaTH0m6oNbLGf2nErmfc-G"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "L",
                    "XL",
                    "M",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL",
                    "7XL",
                    "8XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "180g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "7XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Collared button polo shirt",
                "variant_id": "HNHFLMKPL",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "8XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2518,
        "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
        "slug": "aop-regular-fit-crew-neck-t-shirt-us-size-birds-eye-fabric-TBDXTX-NYB",
        "sku": "TBDXTX-NYB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1lZrMs2QhGujyr7PoPBrKSCnZk-MH4OL_",
        "modified_at": 1783584867,
        "price": 17.5,
        "min_price": 17.5,
        "max_price": 22.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/14F4CrljlglDopGdRvFVrBhfkvJwPZNac?usp=drive_link",
        "description": "Product Introduction：Regular-fit crew neck tee made of breathable bird's eye fabric, fully customizable with full 3D all-over prints. Quick-dry for sports & daily wear in spring summer, easy to match all bottoms, unisex sizes for custom holiday gifts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1Eu9ZCds2g6YYmNxYGlZRPldEoX9aJhxH",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1lZrMs2QhGujyr7PoPBrKSCnZk-MH4OL_",
            "https://lh3.googleusercontent.com/d/1Eu9ZCds2g6YYmNxYGlZRPldEoX9aJhxH"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL Material:140 Mesh Fabric"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit crew neck T shirt (US size| birds eye fabric)",
                "variant_id": "TBDXTX-NYB",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "6XL Material:140 Mesh Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2178,
        "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
        "slug": "aop-standard-version-adult-baseball-cardigan-print-piping-TBBBKSDY",
        "sku": "TBBBKSDY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1m6_CyvDpMBU0bcj9iHByvNIa8TbXiekl",
        "modified_at": 1783584866,
        "price": 15.5,
        "min_price": 15.5,
        "max_price": 20.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/12yJ5h2svyt-YNTGB9aYKfo6Imbhrh8jN?usp=drive_link",
        "description": "Product Introduction：This Standard Version Adult Baseball Cardigan with Print Piping, available in sizes XS–6XL, features 3D all-over custom printing. With printed piping details, a button placket, and breathable mesh fabric, it offers a loose, sporty fit, ideal for streetwear, casual outings, and gifting, perfect for warm weather.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1eKtwFtpNfInibz7n6d8SB3JNl-la6wq9",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1m6_CyvDpMBU0bcj9iHByvNIa8TbXiekl",
            "https://lh3.googleusercontent.com/d/1eKtwFtpNfInibz7n6d8SB3JNl-la6wq9"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird's Eye Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Standard Version Adult Baseball Cardigan Print Piping",
                "variant_id": "TBBBKSDY",
                "location": "CN",
                "material": "140g Bird's Eye Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 589,
        "name": "Children's Punchy Shoes",
        "slug": "childrens-punchy-shoes-RTDDX",
        "sku": "RTDDX",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1uvM3_ZzJ-2Uq0nxduWCqBglPbn10Jf9w",
        "modified_at": 1783418292,
        "price": 17,
        "min_price": 17,
        "max_price": 22,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ZGgxE90PAL2Pd7eMFQYIu42yCBY78lz4?usp=drive_link",
        "description": "<p>Processing Time: 7-9 days</p><p>Shipping Time: 10-16 days for Logo+TM design<br />\n7-14 days for No logo+normal design</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1ZGgxE90PAL2Pd7eMFQYIu42yCBY78lz4?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/1NKuqRVF7kSb62_Ad0HhRxbz_Vr9-Iwmb",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1uvM3_ZzJ-2Uq0nxduWCqBglPbn10Jf9w",
            "https://lh3.googleusercontent.com/d/1NKuqRVF7kSb62_Ad0HhRxbz_Vr9-Iwmb"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "23-24",
                    "25-26",
                    "27-28",
                    "29-30",
                    "31-32",
                    "33-34"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "White"
                ]
            },
            {
                "option": "material",
                "values": [
                    "EVA"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "23-24",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "23-24",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "25-26",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "25-26",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "27-28",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "27-28",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "29-30",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "29-30",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "31-32",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "31-32",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "33-34",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Children's Punchy Shoes",
                "variant_id": "RTDDX-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "size": "33-34",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 47,
        "name": "2D hooded denim jacket",
        "slug": "2d-hooded-denim-jacket-LMNZJK",
        "sku": "LMNZJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1dIr0q2hdN56aa5vYCs5W86xivY_BMmdw",
        "modified_at": 1785486868,
        "price": 29.5,
        "min_price": 29.5,
        "max_price": 34.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/101bVEAEDLKRlwGLpTNKDVjcpLjM1gt-_?usp=drive_link",
        "description": "Product Introduction：This 2D hooded denim jacket comes in light and dark blue, sizes S–5XL. Durable, relaxed-fit with a stylish hood, great for casual daily wear in spring and autumn. Easy to match, ideal as a practical holiday gift.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1HK-zCxeKCGL5d6k99DhUtK0Afh29D-m0",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1dIr0q2hdN56aa5vYCs5W86xivY_BMmdw",
            "https://lh3.googleusercontent.com/d/1HK-zCxeKCGL5d6k99DhUtK0Afh29D-m0"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Light Blue",
                    "Dark Blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "S",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "S",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "M",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "M",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "L",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "L",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "XL",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "2XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "2XL",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "3XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "3XL",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "4XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "4XL",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "5XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D hooded denim jacket",
                "variant_id": "LMNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "5XL",
                "color": "Dark Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 36,
        "name": "2D Denim Jacket",
        "slug": "2d-denim-jacket-2DNZJK",
        "sku": "2DNZJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1fBEsZ5DwlagnRW5e7ZK1715p_wnFYz9F",
        "modified_at": 1785486868,
        "price": 37.5,
        "min_price": 37.5,
        "max_price": 42.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1tddrVb5V6-Uo9lv4wXRv-au7Y36cMF7U?usp=drive_link",
        "description": "Product Introduction：This 2D denim jacket comes in black and blue, sizes M–4XL. Durable with a relaxed fit, perfect for casual daily wear in spring and autumn. Easy to match, ideal as a practical holiday gift for all.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1rM04GBa2GVDS-OoGeaBP28bqjx2pcoVO",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1fBEsZ5DwlagnRW5e7ZK1715p_wnFYz9F",
            "https://lh3.googleusercontent.com/d/1rM04GBa2GVDS-OoGeaBP28bqjx2pcoVO"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Denim Jacket",
                "variant_id": "2DNZJK-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "size": "4XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 390,
        "name": "3pcs Bedding Set",
        "slug": "3pcs-bedding-set-CSSJT",
        "sku": "CSSJT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1j6RqLbOJ6KhnbkV5oS7Ap-FLJfOmaPuJ",
        "modified_at": 1785487715,
        "price": 24.5,
        "min_price": 24.5,
        "max_price": 46,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1QOCzx04cqse1dUoeU4PaAO3YOWXNcs05?usp=drive_link",
        "description": "Product Introduction：This 3-piece bedding set boasts 3D full-print custom patterns with vivid colors. Soft, durable and stylish, it decorates bedrooms perfectly. Ideal for daily use and great festival gifts for family and friends.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Soft anti-slip suede, perfect lining, snug and non-slip.<br />\n<br />\n3.Washing Instructions：Cold gentle wash. No sun or hard rubbing, prevent lint & pilling.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1j6RqLbOJ6KhnbkV5oS7Ap-FLJfOmaPuJ",
            "https://lh3.googleusercontent.com/d/1prnRj6-XJiAvb9PthtT2itZ4wIRVKWmw"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "168x229cm",
                    "264x229cm",
                    "230x260cm",
                    "230x230cm",
                    "200x230cm",
                    "150x200cm",
                    "180x200cm",
                    "170x220cm",
                    "230x280cm",
                    "264x240cm",
                    "231x221cm",
                    "180x220cm",
                    "130x150cm"
                ]
            },
            {
                "option": "color",
                "values": [
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "280 grams brushed fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-168X229CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "168x229cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-264X229CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "264x229cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-230X260CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x260cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 37,
                        "non_contiguous": 42
                    },
                    "EU": {
                        "mainland": 38,
                        "non_contiguous": 38
                    },
                    "CA": {
                        "mainland": 42,
                        "non_contiguous": 42
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-230X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x230cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37,
                        "non_contiguous": 42
                    },
                    "EU": {
                        "mainland": 38,
                        "non_contiguous": 38
                    },
                    "CA": {
                        "mainland": 42,
                        "non_contiguous": 42
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35,
                        "non_contiguous": 40
                    },
                    "EU": {
                        "mainland": 36,
                        "non_contiguous": 36
                    },
                    "CA": {
                        "mainland": 40,
                        "non_contiguous": 40
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-200X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "200x230cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-150X200CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "150x200cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 27,
                        "non_contiguous": 32
                    },
                    "EU": {
                        "mainland": 28,
                        "non_contiguous": 28
                    },
                    "CA": {
                        "mainland": 32,
                        "non_contiguous": 32
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-180X200CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "180x200cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-170X220CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "170x220cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-230X280CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x280cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-264X240CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "264x240cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-231X221CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "231x221cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-180X220CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "180x220cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3pcs Bedding Set",
                "variant_id": "CSSJT-130X150CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "130x150cm",
                "color": "3D",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 392,
        "name": "Quilt Blanket-Black Border",
        "slug": "quilt-blanket-black-border-LXHFMBZ",
        "sku": "LXHFMBZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1v7wwqGTSesqvVT_w9a9twRWo2Q_A89XR",
        "modified_at": 1785487715,
        "price": 14,
        "min_price": 14,
        "max_price": 53,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1g09eykUOtMfyp0n8ZxMq2oHaF2yRLnCo?usp=drive_link",
        "description": "Product Introduction：This quilt blanket with black border features 3D full-print custom design, bright and long-lasting. Soft and practical for sofa or bedroom, ideal as a thoughtful festival gift for family and friends.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Soft anti-slip suede, perfect lining, snug and non-slip.<br />\n<br />\n3.Washing Instructions：Cold gentle wash. No sun or hard rubbing, prevent lint & pilling.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1v7wwqGTSesqvVT_w9a9twRWo2Q_A89XR",
            "https://lh3.googleusercontent.com/d/1edSdWiKbPpDYlVsQaCbfR-Vn1ND5T91R"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "75x100cm",
                    "130x150cm",
                    "140x152cm",
                    "150x200cm",
                    "180x200cm",
                    "173x203cm",
                    "200x230cm",
                    "230x230cm",
                    "230x260cm",
                    "230x280cm",
                    "175x230cm"
                ]
            },
            {
                "option": "material",
                "values": [
                    "280 grams brushed fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-75X100CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "75x100cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14,
                        "non_contiguous": 19
                    },
                    "EU": {
                        "mainland": 15,
                        "non_contiguous": 15
                    },
                    "CA": {
                        "mainland": 19,
                        "non_contiguous": 19
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-130X150CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "130x150cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-140X152CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "140x152cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24,
                        "non_contiguous": 29
                    },
                    "EU": {
                        "mainland": 25,
                        "non_contiguous": 25
                    },
                    "CA": {
                        "mainland": 29,
                        "non_contiguous": 29
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-150X200CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "150x200cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-180X200CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "180x200cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-173X203CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "173x203cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-200X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "200x230cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-230X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x230cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-230X260CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x260cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-230X280CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x280cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48,
                        "non_contiguous": 53
                    },
                    "EU": {
                        "mainland": 49,
                        "non_contiguous": 49
                    },
                    "CA": {
                        "mainland": 53,
                        "non_contiguous": 53
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilt Blanket-Black Border",
                "variant_id": "LXHFMBZ-175X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "175x230cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2222,
        "name": "AOP European Size V Neck Short Sleeve",
        "slug": "aop-european-size-v-neck-short-sleeve-VLDXDYB",
        "sku": "VLDXDYB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1zyxJe9ezn1JejI1AncgSIwfKQ8AdW48u",
        "modified_at": 1783584866,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1jgdSO69aPS09Kg-5t9YYfQMQdXPucjsz?usp=drive_link",
        "description": "Product Introduction：This European size V-neck short sleeve features 3D all-over custom printing, available in XS–5XL. Its tailored V-neck design flatters the upper body, ideal for spring/summer casual wear, easy to pair with any bottoms, and a thoughtful gift for style-conscious individuals.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1UjLlGmYMHi_rRvZHS5R2yYIVEZMqpKK2",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1zyxJe9ezn1JejI1AncgSIwfKQ8AdW48u",
            "https://lh3.googleusercontent.com/d/1UjLlGmYMHi_rRvZHS5R2yYIVEZMqpKK2"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170g Cotton-like",
                    "140g Bird's Eye Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "material": "170g Cotton-like",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP European Size V Neck Short Sleeve",
                "variant_id": "VLDXDYB",
                "location": "CN",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "material": "140g Bird's Eye Fabric",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3179,
        "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
        "slug": "aop-meg-raglan-sleeve-v-neck-football-jersey-MEGCJXVLZQF",
        "sku": "MEGCJXVLZQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1KgbQSMNyEC1bMt5uS3eHXUUSb7Dt21Xg",
        "modified_at": 1790045388,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1YL0FAXTVejxZZ9zRT1TSEjZrB0cSTPAc?usp=drive_link",
        "description": "Product Introduction：This raglan-sleeve V-neck soccer jersey features a full-print 3D personalized pattern for a dynamic visual impact. The raglan sleeve design enhances shoulder mobility, while the V-neckline flatters the neck shape, offering a crisp and refreshing fit. Ideal for on-field competition or outdoor sports activities, it also makes a great gift for soccer fans—perfect for summer wear, whether worn alone or as a layering piece.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1q7R49Vhrtzv_dXqMTpP845RXAZL6k3Io",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1KgbQSMNyEC1bMt5uS3eHXUUSb7Dt21Xg",
            "https://lh3.googleusercontent.com/d/1i46VfdNFNAEQBylCWnbSef0KP8ztYx3x",
            "https://lh3.googleusercontent.com/d/1fjuCMXxVCBKqaHZU2WCsG0VmnF9jlgTA",
            "https://lh3.googleusercontent.com/d/12leVkcSo5lVY01xEZh3Hw3jPEmaiuhf-",
            "https://lh3.googleusercontent.com/d/1q7R49Vhrtzv_dXqMTpP845RXAZL6k3Io"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Raglan Sleeve V-neck Football Jersey",
                "variant_id": "MEGCJXVLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2173,
        "name": "AOP V Neck Short Sleeve 2",
        "slug": "aop-v-neck-short-sleeve-2-CHRVLTX",
        "sku": "CHRVLTX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Nx6TfiMjEy9XCCNo9J5zPF9_vUvJa1_P",
        "modified_at": 1783584866,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1n_NG8-OSLBBPO-MB5Fow1K0foRO2R-Ut?usp=drive_link",
        "description": "Product Introduction：This V Neck Short Sleeve T-shirt, available in sizes S–5XL, features 3D all-over custom printing. With a flattering V-neckline and soft, breathable fabric, it offers a tailored fit, ideal for casual outings, street style, and gifting, perfect for warm weather and easy to mix and match.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1QVWqSkfMYR3oFyIDnO9Y0sbP8cXLe_Sh",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Nx6TfiMjEy9XCCNo9J5zPF9_vUvJa1_P",
            "https://lh3.googleusercontent.com/d/1QVWqSkfMYR3oFyIDnO9Y0sbP8cXLe_Sh"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170gPolyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP V Neck Short Sleeve 2",
                "variant_id": "CHRVLTX",
                "location": "CN",
                "material": "170gPolyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2701,
        "name": "AOP HHQ Children's V Neck Basketball Uniform",
        "slug": "aop-hhq-childrens-v-neck-basketball-uniform-HHQETVLLQF",
        "sku": "HHQETVLLQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1RP6-fzGDuQxd3biWMF05nwSxav2yxoch",
        "modified_at": 1790045387,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1RxoTj0YT2qHkXEeBkwzIUMkGpIpx8buz?usp=drive_link",
        "description": "Product Introduction：Professional basketball jersey with unrestrictive sport cut, fully customizable with team logos & numbers via 3D print. Breathable sweat-wicking fabric for intense games, sizes for teens & adults, perfect for team bulk orders.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1D6pWNONPgpHadAnrciwlnmZRh1Ue-5vu",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1RP6-fzGDuQxd3biWMF05nwSxav2yxoch",
            "https://lh3.googleusercontent.com/d/1spPIaMJnLKDJz00SDeBGvX02JEgoru3e",
            "https://lh3.googleusercontent.com/d/18YWvqYRzL0_sJhScZu6xlyugPvAiGj8d",
            "https://lh3.googleusercontent.com/d/1ay7nBGXVCCXD8Bh64r-2rZFHOBdsufyH",
            "https://lh3.googleusercontent.com/d/1D6pWNONPgpHadAnrciwlnmZRh1Ue-5vu"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "18M",
                    "2T",
                    "3T",
                    "4T",
                    "5T",
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "18M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HHQ Children's V Neck Basketball Uniform",
                "variant_id": "HHQETVLLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 578,
        "name": "velvet hole shoes",
        "slug": "velvet-hole-shoes-P65",
        "sku": "P65",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1issSpWiDr5r-KwoVJ3MeYDuhb6_6fCf7",
        "modified_at": 1783418292,
        "price": 21,
        "min_price": 21,
        "max_price": 26,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1iPK1cyFzDXBPaItZSAFtUh-BornGORif?usp=drive_link",
        "description": "<p>Processing Time: 7-9 days</p><p>Shipping Time: 10-16 days for Logo+TM design<br />\n7-14 days for No logo+normal design</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1iPK1cyFzDXBPaItZSAFtUh-BornGORif?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/12eZomRyTXfRPGcB-h5aAWR9W67JurGVn",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1issSpWiDr5r-KwoVJ3MeYDuhb6_6fCf7",
            "https://lh3.googleusercontent.com/d/12eZomRyTXfRPGcB-h5aAWR9W67JurGVn"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Black"
                ]
            },
            {
                "option": "material",
                "values": [
                    "EVA"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "velvet hole shoes",
                "variant_id": "P65-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 387,
        "name": "4pcs Bedding Set",
        "slug": "4pcs-bedding-set-CSSIJT",
        "sku": "CSSIJT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1XoNkFzYq2Z-q52MZWXqLd5X2WMhZV69o",
        "modified_at": 1785487715,
        "price": 38,
        "min_price": 38,
        "max_price": 55,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1bODt3k2eJaXoa5Dk15l-km-JHZGkAmGY?usp=drive_link",
        "description": "Product Introduction：This 4pcs bedding set features a clean and elegant design with a soft color palette, creating a cozy and inviting bedroom atmosphere. The complete set offers comfort, style, and easy matching with various interiors. Perfect for bedrooms, guest rooms, and holiday home décor. A great gift choice for housewarmings, Christmas, birthdays, or anyone who loves a warm and relaxing sleep environment.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Soft and plush surface with delicate touch, great warmth and pill-resistant.<br />\n<br />\n3.Washing Instructions：Wash inside out, no hard rubbing. Shade dry, avoid strong sun.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1XoNkFzYq2Z-q52MZWXqLd5X2WMhZV69o",
            "https://lh3.googleusercontent.com/d/1qem0dK3i_JxKyH_6IaUaA9jlEVCY-8bk"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "280 grams brushed fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "4pcs Bedding Set",
                "variant_id": "CSSIJT-S-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "S",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "4pcs Bedding Set",
                "variant_id": "CSSIJT-M-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "M",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "4pcs Bedding Set",
                "variant_id": "CSSIJT-L-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "L",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "4pcs Bedding Set",
                "variant_id": "CSSIJT-XL-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "XL",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 50,
                        "non_contiguous": 55
                    },
                    "EU": {
                        "mainland": 51,
                        "non_contiguous": 51
                    },
                    "CA": {
                        "mainland": 55,
                        "non_contiguous": 55
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 48,
                        "non_contiguous": 53
                    },
                    "EU": {
                        "mainland": 49,
                        "non_contiguous": 49
                    },
                    "CA": {
                        "mainland": 53,
                        "non_contiguous": 53
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 233,
        "name": "3D Beach shorts",
        "slug": "3d-beach-shorts-TBSTK",
        "sku": "TBSTK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1hEAegMg4EnJKIceFiOBtOX954LBYkZVC",
        "modified_at": 1783584865,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ScXYksz3eZ7b6Da9wQKVBPtjrpelDiVN?usp=drive_link",
        "description": "Product Introduction：Lightweight 3D beach shorts with relaxed fit and soft drawstring waist deliver breathable comfort and modern summer style. Ideal for seaside trips, poolside lounging, and vacation wear. Suitable for men and women, great gift for summer holidays. Easy to pair with tees and sandals, perfect for warm weather outfits choice.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1_8037tl68NeFJl2w7gTpxnrdh2r2BUTx",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1hEAegMg4EnJKIceFiOBtOX954LBYkZVC",
            "https://lh3.googleusercontent.com/d/1_8037tl68NeFJl2w7gTpxnrdh2r2BUTx"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Beach shorts",
                "variant_id": "TBSTK-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 707,
        "name": "2D leather crossbody bag",
        "slug": "2d-leather-crossbody-bag-2DPGXKB",
        "sku": "2DPGXKB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1TfXqW4n0WWPif0IrqgpobKLrsM0bMS_0",
        "modified_at": 1785396354,
        "price": 13,
        "min_price": 13,
        "max_price": 18,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 18,
            "name": "Bag & Wallet",
            "slug": "bag-wallet",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/bag.jpg",
            "description": null,
            "modified_at": 1773762814
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1pWM6RdwTw-79iNssG8DJZnMrFbzy1mN2?usp=drive_link",
        "description": "Product Introduction：Adjustable crossbody strap frees hands for travel and daily errands, minimalist printed leather appearance. Great everyday gift, wear-resistant leather adapts to long-term outdoor use.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Flexible, waterproof, varied patterns, good value and nice shaping effect.<br />\n<br />\n3.Washing Instructions：Damp cloth cleaning only. No soaking, sun exposure or alcohol.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1TfXqW4n0WWPif0IrqgpobKLrsM0bMS_0",
            "https://lh3.googleusercontent.com/d/1_QkIDRPAAiSVKU-exA1JcHyAyMeaKBeN"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "one size"
                ]
            },
            {
                "option": "color",
                "values": [
                    " Black",
                    "Brown"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D leather crossbody bag",
                "variant_id": "2DPGXKB-ONE-SIZE-PU",
                "location": "CN",
                "size": "one size",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather crossbody bag",
                "variant_id": "2DPGXKB-ONE-SIZE-PU",
                "location": "CN",
                "size": "one size",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2535,
        "name": "AOP Women's V Neck Football Jersey",
        "slug": "aop-womens-v-neck-football-jersey-NVVLGLQF",
        "sku": "NVVLGLQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1JTYstrNN4dYA3KXQ4C_QQdON26Dtf7es",
        "modified_at": 1783584867,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1VsoG7CLO3YZFbuwJqcLG6JYrRU67RVan?usp=drive_link",
        "description": "Product Introduction：Women's V-neck mesh cropped football jersey with full custom 3D all-over print. Cropped cut highlights waist, breathable mesh for summer sports & streetwear, match high-waisted bottoms, trendy custom gifts for young ladies.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n4.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1Aq3rUhNgi40IAZMiBJkh6LuOZqzaEo4W",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1JTYstrNN4dYA3KXQ4C_QQdON26Dtf7es",
            "https://lh3.googleusercontent.com/d/1Aq3rUhNgi40IAZMiBJkh6LuOZqzaEo4W"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% Polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Women's V Neck Football Jersey",
                "variant_id": "NVVLGLQF",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's V Neck Football Jersey",
                "variant_id": "NVVLGLQF",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's V Neck Football Jersey",
                "variant_id": "NVVLGLQF",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's V Neck Football Jersey",
                "variant_id": "NVVLGLQF",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's V Neck Football Jersey",
                "variant_id": "NVVLGLQF",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's V Neck Football Jersey",
                "variant_id": "NVVLGLQF",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2676,
        "name": "AOP MEG Crop Rugby Jersey",
        "slug": "aop-meg-crop-rugby-jersey-MEGLQGLQF",
        "sku": "MEGLQGLQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1y0kfwamNyfR_SFFkE62GcO4cg4A1Zu6v",
        "modified_at": 1783584867,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1_IcyaBZ7yLodbyLdyNgyR3684FIyDkxv?usp=drive_link",
        "description": "Product Introduction：Cropped rugby top highlights your figure with full AOP custom printing. Quick-dry breathable fabric suits workouts and streetwear for spring & summer. Versatile matching, a great fashion gift for trendy girls and best friends.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.\"<br />\n<br />\n<br />\n<br />\n<br />\n",
        "size_guide": "https://lh3.googleusercontent.com/d/1BkZnNVTn0kEA4us4DjHxc19w13XR1oDK",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1y0kfwamNyfR_SFFkE62GcO4cg4A1Zu6v",
            "https://lh3.googleusercontent.com/d/1BkZnNVTn0kEA4us4DjHxc19w13XR1oDK"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Crop Rugby Jersey",
                "variant_id": "MEGLQGLQF",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 28,
        "name": "2D Leather Jacket 4 - Stand Collar Jacket",
        "slug": "2d-leather-jacket-4-stand-collar-jacket-2DPYLLJK",
        "sku": "2DPYLLJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/13SjM0trd9hBiIS58fusDXDEIB25B7bV8",
        "modified_at": 1785486868,
        "price": 42.5,
        "min_price": 42.5,
        "max_price": 47.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/19WYxV_F-oq39_C7RJDSoNVuvBcywT07T?usp=drive_link",
        "description": "Product Introduction：This 2D stand-collar leather Jacket 4 comes in black, red, yellow, coffee and light blue, sizes S–5XL. Sleek and versatile, perfect for casual and street wear in spring and autumn. Easy to match, ideal as a stylish holiday gift.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Stiff compact fabric | Wind & water resistant | Durable stylish | Vintage upscale | Warm keeping.<br />\n<br />\n3.Washing Instructions：Reduce washing; spot clean with leather cleaner. No soak/sun exposure, shade storage, keep off oil/sharp items, condition seasonally.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1KCoWImL8QpmF_KqlXwHVPFvY8BUuo33D",
        "gallery": [
            "https://lh3.googleusercontent.com/d/13SjM0trd9hBiIS58fusDXDEIB25B7bV8",
            "https://lh3.googleusercontent.com/d/1yqJvPN-w2ycvW96YiI56uvDBtg-rRt-l",
            "https://lh3.googleusercontent.com/d/1KCoWImL8QpmF_KqlXwHVPFvY8BUuo33D"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Red",
                    "Yellow",
                    "Coffee",
                    "Light Blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU leather"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "S",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "S",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "S",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "S",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "M",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "M",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "M",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "M",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "L",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "L",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "L",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "L",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "XL",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "2XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "2XL",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "2XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "2XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "3XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "3XL",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "3XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "3XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "4XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "4XL",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "4XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "4XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "5XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "5XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "5XL",
                "color": "Yellow",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "5XL",
                "color": "Coffee",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 4 - Stand Collar Jacket",
                "variant_id": "2DPYLLJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42.5,
                        "non_contiguous": 47.5
                    },
                    "EU": {
                        "mainland": 43.5,
                        "non_contiguous": 43.5
                    },
                    "CA": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40.5,
                        "non_contiguous": 45.5
                    },
                    "EU": {
                        "mainland": 41.5,
                        "non_contiguous": 41.5
                    },
                    "CA": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    }
                },
                "size": "5XL",
                "color": "Light Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 584,
        "name": "STAN SMITH Shoes",
        "slug": "stan-smith-shoes-F3B",
        "sku": "F3B",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Awo3ZS2fm7DYXR7mTCSfIE4CkAqyEJdy",
        "modified_at": 1783418292,
        "price": 38,
        "min_price": 38,
        "max_price": 46,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1UALNQmt9kBwFxD50q9j2ayChzcuIv5j5?usp=drive_link",
        "description": "Product Introduction：This classic Stan Smith silhouette supports custom 3D full-print customization. It features breathable mesh lining and soft Hi-Poly insoles to avoid rubbing feet during long wear. The wear-resistant anti-slip RB outsole matches all outfits year-round, ideal for daily commuting for men and women.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1EwLhIziqDMoTkfL_58ZL8hrf0tzvlMOk",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Awo3ZS2fm7DYXR7mTCSfIE4CkAqyEJdy",
            "https://lh3.googleusercontent.com/d/1EwLhIziqDMoTkfL_58ZL8hrf0tzvlMOk"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White sole",
                    "Black sole"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "38",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "38",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "39",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "39",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "40",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "40",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "41",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "41",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "42",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "42",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "43",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "43",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "44",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "44",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "45",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "45",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "46",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "46",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "47",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "47",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "48",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "size": "48",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "38",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "38",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "39",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "39",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "40",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "40",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "41",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "41",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "42",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "42",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "43",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "43",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "44",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "44",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "45",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "45",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "46",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "46",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "47",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "47",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "48",
                "color": "White sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "STAN SMITH Shoes",
                "variant_id": "F3B-3839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Space Fabric (Polyester + Polyurethane + Calcium Carbonate + Wood Powder + 15% Other Components)\nLining: D02 Mesh Fabric (100% Polyester)\nInsole: Black Hi-Poly Foam Insole\nOutsole: RB (Polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 39,
                        "non_contiguous": 44
                    },
                    "EU": {
                        "mainland": 40,
                        "non_contiguous": 40
                    },
                    "CA": {
                        "mainland": 44,
                        "non_contiguous": 44
                    }
                },
                "size": "48",
                "color": "Black sole",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 29,
        "name": "2D leather jacket 5 - There is a button on the collar",
        "slug": "2d-leather-jacket-5-there-is-a-button-on-the-collar-2DPYLKYK",
        "sku": "2DPYLKYK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/13fa6gxueFSeMn15_tQNYRM8sa3Ybxx1r",
        "modified_at": 1785486868,
        "price": 46.5,
        "min_price": 46.5,
        "max_price": 51.5,
        "is_new": false,
        "is_best_seller": true,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1RFD2DEUUsOGZkK_ur09KqhKR9bij8PF6?usp=drive_link",
        "description": "Product Introduction：This 2D leather jacket 5 with collar button is available in black, blue and brown, sizes S–3XL. Stylish tailored fit, great for casual and street wear in spring and autumn. Easy to match, ideal as a fashionable holiday gift.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Stiff compact fabric | Wind & water resistant | Durable stylish | Vintage upscale | Warm keeping.<br />\n<br />\n3.Washing Instructions：Reduce washing; spot clean with leather cleaner. No soak/sun exposure, shade storage, keep off oil/sharp items, condition seasonally.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/17t0SgcvphkRQLFWCzMUAPRknwCzu10X1",
        "gallery": [
            "https://lh3.googleusercontent.com/d/13fa6gxueFSeMn15_tQNYRM8sa3Ybxx1r",
            "https://lh3.googleusercontent.com/d/17t0SgcvphkRQLFWCzMUAPRknwCzu10X1"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Blue",
                    "Brown"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU leather"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "S",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "S",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "M",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "L",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "2XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D leather jacket 5 - There is a button on the collar",
                "variant_id": "2DPYLKYK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "3XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3173,
        "name": "AOP NGA V-neck Adult Football Jersey",
        "slug": "aop-nga-v-neck-adult-football-jersey-NGAVLCRZQF",
        "sku": "NGAVLCRZQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ATgQmbqN7aref3rL64-YxVn6CeaL6_nz",
        "modified_at": 1789719744,
        "price": 17.5,
        "min_price": 17.5,
        "max_price": 22.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/145Yj22ZSsfOdYrOOIaP5zZ-HFyq9VXVb?usp=drive_link",
        "description": "Product Introduction：This V-neck adult soccer jersey features a 3D all-over printed pattern that creates a dynamic, sporty look with a sharp, stylish fit. The V-neck design elegantly flatters the neckline, while the relaxed, breathable fit allows for easy, unrestricted movement. Perfect for the pitch or everyday athletic wear, it makes a vibrant choice for soccer enthusiasts. Ideal for summer, it can be worn on its own and paired with athletic shorts or casual trousers to showcase a passionate, competitive edge.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：140g Bird-eye polyster (Light soft cool touch, breathable mesh, sweat-wicking & fast drying.)<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1vsHaBq7Gi6QxzZ2lBSkuQhBeGSf3Mq_3",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ATgQmbqN7aref3rL64-YxVn6CeaL6_nz",
            "https://lh3.googleusercontent.com/d/12VbGssfTzHWxpeBqLLQ_6qrXn9hYDtGv",
            "https://lh3.googleusercontent.com/d/1t1DfYry08hLWh-SL53YI_am4yEB8vA8M",
            "https://lh3.googleusercontent.com/d/1_tFKQE3mLMMdlPJdYe9DIUHAXw2MD1bM",
            "https://lh3.googleusercontent.com/d/1vsHaBq7Gi6QxzZ2lBSkuQhBeGSf3Mq_3"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA V-neck Adult Football Jersey",
                "variant_id": "NGAVLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3335,
        "name": "AOP MEG raglan sleeve folded collar football jersey",
        "slug": "aop-meg-raglan-sleeve-folded-collar-football-jersey-MEGCJXZLZQF",
        "sku": "MEGCJXZLZQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1hktiFCTAf6B9d-XjZnXA6qPjJTwl-y1e",
        "modified_at": 1784624493,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1oZgBEMnlB2qU0m1SsJAVKy6BoWpwiYrQ?usp=drive_link",
        "description": "Product Introduction：Folded-collar soccer jersey plus beach pants set, bird-eye fabric dries fast. Perfect for sports and leisure, works on field and at the beach, comfy and practical.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/12i8d5lI5l4U2uoh7SlJ2LNAUz_bJwhhs",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1hktiFCTAf6B9d-XjZnXA6qPjJTwl-y1e",
            "https://lh3.googleusercontent.com/d/1yvvEwimCL8b6UxBtsqb5mWopEHs5dV-h",
            "https://lh3.googleusercontent.com/d/1LRumPzpwYBylUW1UUmt4SbVeFr_EsWAJ",
            "https://lh3.googleusercontent.com/d/12i8d5lI5l4U2uoh7SlJ2LNAUz_bJwhhs"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG raglan sleeve folded collar football jersey",
                "variant_id": "MEGCJXZLZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3198,
        "name": "AOP NGA Round-Neck Adult Football Jersey",
        "slug": "aop-nga-round-neck-adult-football-jersey-NGAYLCRZQF",
        "sku": "NGAYLCRZQF",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ESc6TuAxs2Yl6BmBdPgk_ZmRVT-HhJrq",
        "modified_at": 1790045388,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/145Yj22ZSsfOdYrOOIaP5zZ-HFyq9VXVb?usp=drive_link",
        "description": "Product Introduction：This crewneck adult soccer jersey features a full-print 3D personalized pattern that creates a vibrant, dynamic look. The crewneck design offers a clean and simple style, while the loose, breathable fit ensures lightweight comfort and unrestricted movement during sports. Ideal for on-field competition or outdoor activities, it also makes an energetic gift for soccer fans—perfect for wearing alone in summer for a fresh, cool feel.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1SN2svXQsR072MJ6or-U5zRYS-rFEZDFe",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ESc6TuAxs2Yl6BmBdPgk_ZmRVT-HhJrq",
            "https://lh3.googleusercontent.com/d/1MfTWqqsobhog9-tyQ_mZGetqEHsloke6",
            "https://lh3.googleusercontent.com/d/1vrkfzUmDMjwURVa6wq4nz8oxKuGeIF92",
            "https://lh3.googleusercontent.com/d/1SN2svXQsR072MJ6or-U5zRYS-rFEZDFe"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGA Round-Neck Adult Football Jersey",
                "variant_id": "NGAYLCRZQF-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3238,
        "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
        "slug": "aop-meg-football-crewneck-raglan-sleeve-short-sleeve-MEGZQCJXDX",
        "sku": "MEGZQCJXDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1-lm0h4B-Jn5yZjA5eJY4eo1MbwXUbrOd",
        "modified_at": 1790220752,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1A6MBl6TLg2d5oznZUObn48Y41TIQ4n5q?usp=drive_link",
        "description": "Product Introduction：This soccer crewneck raglan short-sleeve shirt features a 3D all-over print personalized pattern, delivering a dynamic and eye-catching visual effect with vibrant colors. The raglan sleeve design flatters the shoulder line, offering an energetic and stylish look when worn, while the classic crewneck adds versatile appeal. The loose, comfortable fit makes it perfect for soccer training, outdoor sports, or casual daily wear. It is an exciting gift for soccer buddies or sports enthusiasts. Ideal for summer and warm weather, it pairs effortlessly with athletic shorts or casual pants for a sporty, sunny vibe.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1-XVTBfNnpI-q1c7GNI8imjxOt7hBRenD",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1-lm0h4B-Jn5yZjA5eJY4eo1MbwXUbrOd",
            "https://lh3.googleusercontent.com/d/1wVtCXjJ-TX3bNyYEzW9EA-EuY6s6Hd4V",
            "https://lh3.googleusercontent.com/d/1tF28kJA-UzhC5jbl8gb_e6ZvCYCugZd6",
            "https://lh3.googleusercontent.com/d/1OY54QJvIjK_f_piXk1Pd1H1P-l7QyO40",
            "https://lh3.googleusercontent.com/d/1-XVTBfNnpI-q1c7GNI8imjxOt7hBRenD"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP MEG Football Crewneck Raglan Sleeve Short Sleeve",
                "variant_id": "MEGZQCJXDX-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3465,
        "name": "AOP EDG Sweatshirt with Arm Pockets",
        "slug": "aop-edg-sweatshirt-with-arm-pockets-EDGSBKDWY",
        "sku": "EDGSBKDWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1AP1Ffn01NzRhAmMECBuuTtve3CBDJ93i",
        "modified_at": 1783667749,
        "price": 23.5,
        "min_price": 23.5,
        "max_price": 28.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1OhvYn0Q4weFpqatocFNf52x4IzoOsH3e?usp=drive_link",
        "description": "Product Introduction：Arm-pocket hoodie with bold design detail, thick warm air layer fabric. Statement spring/autumn piece, functional pocket adds streetwear edge.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1MIUJmEC00j9z_GFQAaGqJxaw68pZb_gH",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1AP1Ffn01NzRhAmMECBuuTtve3CBDJ93i",
            "https://lh3.googleusercontent.com/d/1cclqHgZbaPgl0g9rUGPm9GmW7f7lyzJ1",
            null,
            "https://lh3.googleusercontent.com/d/1MIUJmEC00j9z_GFQAaGqJxaw68pZb_gH"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "250g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EDG Sweatshirt with Arm Pockets",
                "variant_id": "EDGSBKDWY-250G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "250g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 135,
        "name": "AOP Stand collar half zip long sleeves",
        "slug": "aop-stand-collar-half-zip-long-sleeves-LLBLLCX",
        "sku": "LLBLLCX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1pP1AJ7CUcV14sCIGXXvEGfp6Zakk1NxP",
        "modified_at": 1783584864,
        "price": 19.5,
        "min_price": 19.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/13CSXkQPtfZDf8alRFLswZiinssqSUya5?usp=drive_link",
        "description": "Product Introduction：AOP stand-collar half-zip long-sleeve top featuring a clean, modern silhouette with a structured neckline and smooth fit. The half-zip adds sporty versatility and easy layering. Ideal for casual wear, commuting, travel, and light outdoor activities. Suitable for spring, autumn, and mild winter. Easy to style with jeans, joggers, or trousers.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick textured fabric, warm & stretchy. Relaxed slim style, cozy without bulk in cold seasons.<br />\n<br />\n4.Washing Instructions：Hand wash preferred. Lay flat to dry. Do not hang.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1Z36k89H_XtSt8DF8lyN-P4_OSHqdKTUZ",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1pP1AJ7CUcV14sCIGXXvEGfp6Zakk1NxP",
            "https://lh3.googleusercontent.com/d/1Z36k89H_XtSt8DF8lyN-P4_OSHqdKTUZ"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Stand collar half zip long sleeves",
                "variant_id": "LLBLLCX-270G-ARTIFICIAL-WOOL-90-POLYESTER-10-SPANDEX-BLENDED-BY-MODERN-TECHNIQUE",
                "location": "CN",
                "material": "270g Artificial wool (90% polyester + 10% spandex blended by modern technique)",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 406,
        "name": "High Top Sports Shoes-1",
        "slug": "high-top-sports-shoes-1-D17B",
        "sku": "D17B",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1eSqMoxnajWJfh4o9twv9C2622uUdobvO",
        "modified_at": 1783418292,
        "price": 44,
        "min_price": 44,
        "max_price": 51,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/10kKKlNydhWaF9wgovOUty-NNJMzsYqYv?usp=drive_link",
        "description": "Product Introduction：High-top AJ1 silhouette fits snugly around the ankles. The microfiber upper is flexible and durable, while the 100% polyester mesh lining delivers breathable comfort with no stuffiness. Available in a full range of sizes, it’s perfect for daily commutes and casual wear, ideal for personal use or gifting.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Packaging：BOX or NO BOX<br />\n<br />\n3.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n4.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1iF5_Gf6qcVNCibv6LhFhzq75Rc4yVDaW",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1eSqMoxnajWJfh4o9twv9C2622uUdobvO",
            "https://lh3.googleusercontent.com/d/1iF5_Gf6qcVNCibv6LhFhzq75Rc4yVDaW"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "NO BOX",
                    "BOX"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-NO-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "NO BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High Top Sports Shoes-1",
                "variant_id": "D17B-36373839404142434445464748-BOX",
                "location": "CN",
                "material": "Upper: Microfiber (55-60% polyurethane resin, 40-45% nylon)\nLining: D02 mesh fabric (100% polyester)\nInsole: Black high-elastic EVA foam\nOutsole: RB rubber (polyethylene)",
                "packaging": "BOX",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46,
                        "non_contiguous": 51
                    },
                    "EU": {
                        "mainland": 47,
                        "non_contiguous": 47
                    },
                    "CA": {
                        "mainland": 51,
                        "non_contiguous": 51
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44,
                        "non_contiguous": 49
                    },
                    "EU": {
                        "mainland": 45,
                        "non_contiguous": 45
                    },
                    "CA": {
                        "mainland": 49,
                        "non_contiguous": 49
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2104,
        "name": "2D Women's Fleece Hooded Denim Jacket",
        "slug": "2d-womens-fleece-hooded-denim-jacket-2DNSJRLMNZJK",
        "sku": "2DNSJRLMNZJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1pgsm-3LEg_VkgGAtBjGyN9BWYC9_CULS",
        "modified_at": 1790044795,
        "price": 32.5,
        "min_price": 32.5,
        "max_price": 37.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1sfnJt9SMb6Fm7qQb_mAgu_rL1MFLtS3i?usp=drive_link",
        "description": "Product Introduction：This 2D women's fleece hooded denim jacket (sizes S–5XL) features a soft sherpa lining, detachable drawstring hood, and classic trucker silhouette. Its warm, casual design is ideal for winter layering, easy to style, and a cozy gift for women.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1TgxcPL-cQknVLG0aVJmyOAauXNY2cDnm",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1pgsm-3LEg_VkgGAtBjGyN9BWYC9_CULS",
            "https://lh3.googleusercontent.com/d/1kYDvGK9tFYCnPcmkMqUFFp5GoQi05dRd",
            "https://lh3.googleusercontent.com/d/1DHwNeTu0lYT5I191NvKstz2ZT8AxSEtp",
            "https://lh3.googleusercontent.com/d/1YNlt0HhIuXOAsHE3M2KDeLPdpqLkm3MU",
            "https://lh3.googleusercontent.com/d/1TgxcPL-cQknVLG0aVJmyOAauXNY2cDnm"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "L",
                    "XL",
                    "M",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    ""
                ]
            },
            {
                "option": "color",
                "values": [
                    "LightBlue",
                    "DarkBlue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% Polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "4XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "4XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "5XL",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "5XL",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "",
                "color": "LightBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Women's Fleece Hooded Denim Jacket",
                "variant_id": "2DNSJRLMNZJK",
                "location": "CN",
                "material": "100% Polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "",
                "color": "DarkBlue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2207,
        "name": "AOP Women's Long Sleeve Shirt",
        "slug": "aop-womens-long-sleeve-shirt-NSCXCS",
        "sku": "NSCXCS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1V99vtWl3biO16kfWne96sS8hgiQSFxOm",
        "modified_at": 1783584866,
        "price": 15.5,
        "min_price": 15.5,
        "max_price": 20.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1UnlP9IoAe75LSK7bgD19v9TNOu1-zoR6?usp=drive_link",
        "description": "Product Introduction：This women's long sleeve shirt features 3D all-over personalized printing, available in sizes S–5XL. Its classic button-down design offers a tailored yet relaxed fit, ideal for spring/autumn casual or office wear, easy to layer, and a refined gift for style-conscious women.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cool dry textured, breathable & sweat-wicking.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, no hard rub/bleach/long soak. Flat shade dry, no sun, low iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1cLGcZfQMN1LtOEiktMyIx9d13N3xRTI4",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1V99vtWl3biO16kfWne96sS8hgiQSFxOm",
            "https://lh3.googleusercontent.com/d/1cLGcZfQMN1LtOEiktMyIx9d13N3xRTI4"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Slub Linen"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Long Sleeve Shirt",
                "variant_id": "NSCXCS",
                "location": "CN",
                "material": "Slub Linen",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 310,
        "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
        "slug": "aop-long-sleeve-hockey-cardigan-with-front-tie-detail-TOLNHLCXDJKS",
        "sku": "TOLNHLCXDJKS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1IvZAoe-6FktCRpez84sfUeYKBKBGfy3V",
        "modified_at": 1783584865,
        "price": 14.5,
        "min_price": 14.5,
        "max_price": 19.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1PnMc6Ywviy3CBdzmLL1qiKAzOT6EGlCj?usp=drive_link",
        "description": "Product Introduction：Featuring a distinctive front tie detail and long sleeves, this hockey cardigan blends classic athletic style with a modern twist. The relaxed fit provides all-day comfort and easy movement, making it ideal for team events, casual outings, sports fans, or layering in cooler weather. Pairs effortlessly with jeans, joggers, or athletic apparel.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1BPEGLJ5-IgzURbSMaGwhtG32oA2Qwr3D",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1IvZAoe-6FktCRpez84sfUeYKBKBGfy3V",
            "https://lh3.googleusercontent.com/d/1BPEGLJ5-IgzURbSMaGwhtG32oA2Qwr3D"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Long-Sleeve Hockey Cardigan with Front Tie Detail",
                "variant_id": "TOLNHLCXDJKS-140G-BIRD-EYE-POLYSTER",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2773,
        "name": "AOP HNH Children's Lapel Button Polo",
        "slug": "aop-hnh-childrens-lapel-button-polo-HNHRTFLNKPOLO",
        "sku": "HNHRTFLNKPOLO",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1k6ggBnXwvyjYTII3SpUB4jFkcjXscK1K",
        "modified_at": 1790045387,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1wh8kVKja3I6hSURqjetAz9-Lq-4tAOi8?usp=drive_link",
        "description": "Product Introduction：This AOP children's lapel button polo features vibrant all-over prints that bring a playful yet polished look to any young one's wardrobe. The classic lapel collar and button-front design offer a neat, smart appearance, while the soft, breathable fabric keeps kids comfortable during active play. Available in sizes 2T through XL, it's perfect for school days, family gatherings, or casual outings. A great gift for birthdays, back-to-school season, or Children's Day. Suitable for spring, summer, and early autumn, it pairs effortlessly with shorts, jeans, or chinos—style with sneakers or sandals for a cute, versatile outfit that kids will love to wear.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Bird-eye polyster,Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1tmZWbf8HVcpb57xXAnre0LOBWtjT1zLi",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1k6ggBnXwvyjYTII3SpUB4jFkcjXscK1K",
            "https://lh3.googleusercontent.com/d/1CO1qSdk8J6yz2UppgTx1Zu7pGcUOZlxR",
            "https://lh3.googleusercontent.com/d/1l8jRwdWq5QhCyEDRm8tWb8a26hB-Xkru",
            null,
            "https://lh3.googleusercontent.com/d/1tmZWbf8HVcpb57xXAnre0LOBWtjT1zLi"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "2T",
                    "3T",
                    "4T",
                    "5T",
                    "6T",
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "180g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "6T",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP HNH Children's Lapel Button Polo",
                "variant_id": "HNHRTFLNKPOLO",
                "location": "CN",
                "material": "180g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 778,
        "name": "Pu Women's Round Bag",
        "slug": "pu-womens-round-bag-FX2",
        "sku": "FX2",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1gVjA86WsRGPH2vKVMXmnu-MU0HTeurse",
        "modified_at": 1785396354,
        "price": 21,
        "min_price": 21,
        "max_price": 26,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 18,
            "name": "Bag & Wallet",
            "slug": "bag-wallet",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/bag.jpg",
            "description": null,
            "modified_at": 1773762814
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/14RdWcRk-NAedrTaMQ_TaDp6UFU-_HQKw?usp=drive_link",
        "description": "Product Introduction：Chic PU leather round bag with a playful, eye-catching silhouette. Compact yet roomy for phone, cards, and small essentials. Perfect for parties, dates, or casual outings. Lightweight and trendy—a fun gift for fashion lovers on birthdays or holidays.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：PU leather,Flexible, waterproof, varied patterns, good value and nice shaping effect.<br />\n<br />\n3.Washing Instructions：Damp cloth cleaning only. No soaking, sun exposure or alcohol.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/19BQLGXxlebXyyUqYpcdOMdLhjuISAcnS",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1gVjA86WsRGPH2vKVMXmnu-MU0HTeurse",
            "https://lh3.googleusercontent.com/d/19BQLGXxlebXyyUqYpcdOMdLhjuISAcnS"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "one size"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU Leather"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Pu Women's Round Bag",
                "variant_id": "FX2-ONE-SIZE",
                "location": "CN",
                "size": "one size",
                "material": "PU Leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 177,
        "name": "AOP baseball collar down jacket",
        "slug": "aop-baseball-collar-down-jacket-JMJK",
        "sku": "JMJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Ni7TcZ2KpThwco6VNOLIhvcipS19lDCm",
        "modified_at": 1783584865,
        "price": 46.5,
        "min_price": 46.5,
        "max_price": 51.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1xSXPAzJ2H2yPXt4xVMW5qvTQPIll6LRb?usp=drive_link",
        "description": "Product Introduction：AOP baseball collar down jacket with quilted padding and ribbed cuffs offers a sleek, sporty silhouette. Lightweight yet warm, it delivers comfortable layering and modern street appeal. Ideal for commuting, travel, and outdoor wear. Suitable for autumn and winter. Easy to match with jeans, hoodies, or sneakers. Great gift option.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1QxDOs_zr4wL1n9K_Xprkx4xuYA0I294N",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Ni7TcZ2KpThwco6VNOLIhvcipS19lDCm",
            "https://lh3.googleusercontent.com/d/1QxDOs_zr4wL1n9K_Xprkx4xuYA0I294N"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "130g Broken twill fabric\n160g cotton"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP baseball collar down jacket",
                "variant_id": "JMJK-130G-BROKEN-TWILL-FABRIC-160G-COTTON",
                "location": "CN",
                "material": "130g Broken twill fabric\n160g cotton",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2592,
        "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
        "slug": "aop-din-puffer-vest-asian-fit-piping-trim-armholes-DINYRBXYMBBT",
        "sku": "DINYRBXYMBBT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/19RlMx6PiujG6uVotJriu5wTecl3KhvDO",
        "modified_at": 1790045387,
        "price": 21.5,
        "min_price": 21.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/12MpxXh22vLLvetpEsNIwQjgROaIPbLZn?usp=drive_link",
        "description": "Product Introduction：Unisex AOP stand collar puffer vest with piping trim armholes, Asian tailored fit. Full 3D all-over custom print available, easy layered wear in autumn and winter for commuting & outdoors, warm personalized gifts for holidays.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Fine brushed, soft touch & matte texture. Windproof, dustproof, smooth & skin-friendly for coats.<br />\n<br />\n4.Washing Instructions：Cold gentle wash. No hard brushes, avoid suede wear.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1Oc98NlNblwqnLyU6vWr4Sm_YVoMOHkxf",
        "gallery": [
            "https://lh3.googleusercontent.com/d/19RlMx6PiujG6uVotJriu5wTecl3KhvDO",
            "https://lh3.googleusercontent.com/d/1SRs4iH2P6kdR59LlWWsYPQe7ZVPyEN32",
            "https://lh3.googleusercontent.com/d/10gKqjJzBHQP5tfuYWp3t4pkhv3uT1n6-",
            "https://lh3.googleusercontent.com/d/1Yvq3C1x8v5Dtsj4Qup-eVz4m_ktM4JlM",
            "https://lh3.googleusercontent.com/d/1Oc98NlNblwqnLyU6vWr4Sm_YVoMOHkxf"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Peach Skin Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP DIN Puffer Vest (Asian Fit| Piping Trim Armholes)",
                "variant_id": "DINYRBXYMBBT",
                "location": "CN",
                "material": "Peach Skin Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3158,
        "name": "Diamond Quilted Pillowcase",
        "slug": "diamond-quilted-pillowcase-LXGHFZT",
        "sku": "LXGHFZT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1tca8an-e21zofLmRD05oXMr4TW8tr69s",
        "modified_at": 1787558906,
        "price": 11,
        "min_price": 11,
        "max_price": 23,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1kC4dx91me86AJDIg6vrR8bQpSyzUA6gU?usp=drive_link",
        "description": "Product Introduction：Diamond grid quilted pillowcase is soft and skin-friendly with neat workmanship and full print personalized customization. Elegant for bedroom decor, easy to replace, a warm practical home gift for housewarming and various festivals.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Wrinkle & wear resistant, quick-dry, non-deformable, easy care, colorfast.<br />\n<br />\n3.Washing Instructions：Cold gentle wash, machine washable. No high heat drying / bleach. Medium-low iron. Low shrinkage.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1tca8an-e21zofLmRD05oXMr4TW8tr69s",
            "https://lh3.googleusercontent.com/d/1hy3kVdutzv67StOOv_l4eu8Bl-BMalc_",
            "https://lh3.googleusercontent.com/d/1SJW8t6Ma6V5Tz6PXVGI-XbIYvQ-3Omr6",
            "https://lh3.googleusercontent.com/d/1nXFAIr9JM5ks6LxzEPr-QYTdBZRRHNUa",
            "https://lh3.googleusercontent.com/d/1VLSPj1pJpHlCZv1TFyEH_DRXm1NjyQ7e"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "40x40cm",
                    "45x45cm",
                    "58x58cm",
                    "50x75cm",
                    "50x90cm",
                    "91x91cm"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Quilt"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Diamond Quilted Pillowcase",
                "variant_id": "LXGHFZT-40X40CM-QUILT",
                "location": "CN",
                "size": "40x40cm",
                "material": "Quilt",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 9,
                        "non_contiguous": 14
                    },
                    "EU": {
                        "mainland": 10,
                        "non_contiguous": 10
                    },
                    "CA": {
                        "mainland": 14,
                        "non_contiguous": 14
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Quilted Pillowcase",
                "variant_id": "LXGHFZT-45X45CM-QUILT",
                "location": "CN",
                "size": "45x45cm",
                "material": "Quilt",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10,
                        "non_contiguous": 15
                    },
                    "EU": {
                        "mainland": 11,
                        "non_contiguous": 11
                    },
                    "CA": {
                        "mainland": 15,
                        "non_contiguous": 15
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Quilted Pillowcase",
                "variant_id": "LXGHFZT-58X58CM-QUILT",
                "location": "CN",
                "size": "58x58cm",
                "material": "Quilt",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14,
                        "non_contiguous": 19
                    },
                    "EU": {
                        "mainland": 15,
                        "non_contiguous": 15
                    },
                    "CA": {
                        "mainland": 19,
                        "non_contiguous": 19
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Quilted Pillowcase",
                "variant_id": "LXGHFZT-50X75CM-QUILT",
                "location": "CN",
                "size": "50x75cm",
                "material": "Quilt",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Quilted Pillowcase",
                "variant_id": "LXGHFZT-50X90CM-QUILT",
                "location": "CN",
                "size": "50x90cm",
                "material": "Quilt",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 14,
                        "non_contiguous": 19
                    },
                    "EU": {
                        "mainland": 15,
                        "non_contiguous": 15
                    },
                    "CA": {
                        "mainland": 19,
                        "non_contiguous": 19
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Quilted Pillowcase",
                "variant_id": "LXGHFZT-91X91CM-QUILT",
                "location": "CN",
                "size": "91x91cm",
                "material": "Quilt",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 18,
                        "non_contiguous": 23
                    },
                    "EU": {
                        "mainland": 19,
                        "non_contiguous": 19
                    },
                    "CA": {
                        "mainland": 23,
                        "non_contiguous": 23
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 16,
                        "non_contiguous": 21
                    },
                    "EU": {
                        "mainland": 17,
                        "non_contiguous": 17
                    },
                    "CA": {
                        "mainland": 21,
                        "non_contiguous": 21
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 119,
        "name": "2D Sherpa Fleece Jacket",
        "slug": "2d-sherpa-fleece-jacket-2DYGRLLWY",
        "sku": "2DYGRLLWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1m5La3e0gRSksH3ZXKArCXbvuGr95wLfI",
        "modified_at": 1785486868,
        "price": 32.5,
        "min_price": 32.5,
        "max_price": 37.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1gi7aLpprw3pH4K6IoRyfrN2DUM5QOPE0?usp=drive_link",
        "description": "Product Introduction：The Sherpa Fleece Jacket features a soft, cozy sherpa fleece texture that provides exceptional warmth and comfort during colder days. Designed with a stylish and relaxed fit, it is perfect for outdoor activities, casual outings, travel, or everyday layering. A practical and fashionable gift choice for friends, family, or anyone who loves comfortable winter essentials.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Full fluffy pile, warm & ultra soft. Cold resistant, perfect for warmth wear.<br />\n<br />\n3.Washing Instructions：Cold gentle wash, low temp air dry. No sun exposure or hard scrubbing.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1XfLeYnJC-hDehW7QaRPjfcTBJofqbEMD",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1m5La3e0gRSksH3ZXKArCXbvuGr95wLfI",
            "https://lh3.googleusercontent.com/d/1XfLeYnJC-hDehW7QaRPjfcTBJofqbEMD"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Grey",
                    "Black",
                    "White",
                    "Wine Red",
                    "Army Green",
                    "Blue",
                    "Navy Blue",
                    "Brown"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Sherpa Fleece"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "S",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Sherpa Fleece Jacket",
                "variant_id": "2DYGRLLWY-SHERPA-FLEECE",
                "location": "CN",
                "material": "Sherpa Fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 150,
        "name": "AOP Short-sleeved shirt and shorts pajama set",
        "slug": "aop-short-sleeved-shirt-and-shorts-pajama-set-HYDXCSDKSYTZ",
        "sku": "HYDXCSDKSYTZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1YZhhvI0oEMcHJ14B9_S0IvHiOmRLeUpL",
        "modified_at": 1783584865,
        "price": 19.5,
        "min_price": 19.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1u0TBaBKWyKe6sxoHoB_1gPAWA498ZyK2?usp=drive_link",
        "description": "Product Introduction：AOP short-sleeved shirt and shorts pajama set featuring a soft, breathable fabric with a relaxed silhouette for ultimate comfort. The lightweight design offers a smooth, cozy feel for sleep and lounging. Ideal for home wear, vacations and casual relaxation. Perfect for spring and summer a thoughtful gift for loved ones.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Glossy silky, nice drape, lightweight, wrinkle-free.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard rub/wring, shade dry, no sun/high iron to keep luster.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/13XCkiK_70as8NxP1VQUfeCIFMCmueoOm",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1YZhhvI0oEMcHJ14B9_S0IvHiOmRLeUpL",
            "https://lh3.googleusercontent.com/d/13XCkiK_70as8NxP1VQUfeCIFMCmueoOm"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "90gSatin"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Short-sleeved shirt and shorts pajama set",
                "variant_id": "HYDXCSDKSYTZ-90GSATIN",
                "location": "CN",
                "material": "90gSatin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 60,
        "name": "2D Casual Workwear Set",
        "slug": "2d-casual-workwear-set-2DXXGZTZ",
        "sku": "2DXXGZTZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1p5iC44UmfQa3G3-FlYio9XKZK0UEk_6J",
        "modified_at": 1785486868,
        "price": 32.5,
        "min_price": 32.5,
        "max_price": 37.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1jU4geoYBsc8Ma-YOMLdjweEWpI-6lDhQ?usp=drive_link",
        "description": "Product Introduction：The Casual Workwear Set features a stylish design with comfortable fabric, combining a professional look with everyday comfort. Perfect for work, outdoor activities, casual outings, or daily wear, it offers a versatile and practical outfit choice. Durable and easy to style, it makes a great gift for employees, friends, family, or anyone who values comfort and modern fashion.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1mkUKsAlfR0dT7PKvt9mEAsURrG5mc0Me",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1p5iC44UmfQa3G3-FlYio9XKZK0UEk_6J",
            "https://lh3.googleusercontent.com/d/1mkUKsAlfR0dT7PKvt9mEAsURrG5mc0Me"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Beige"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "M",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "L",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "2XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "3XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Casual Workwear Set",
                "variant_id": "2DXXGZTZ-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32.5,
                        "non_contiguous": 37.5
                    },
                    "EU": {
                        "mainland": 33.5,
                        "non_contiguous": 33.5
                    },
                    "CA": {
                        "mainland": 37.5,
                        "non_contiguous": 37.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30.5,
                        "non_contiguous": 35.5
                    },
                    "EU": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    },
                    "CA": {
                        "mainland": 35.5,
                        "non_contiguous": 35.5
                    }
                },
                "size": "4XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2460,
        "name": "AOP TBD 3D half zip sweatshirt",
        "slug": "aop-tbd-3d-half-zip-sweatshirt-TBD3DBLLWY",
        "sku": "TBD3DBLLWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1dGo5Lam76_HXwnGdNiqRNIt3PTt3_ZYY",
        "modified_at": 1783659871,
        "price": 25,
        "min_price": 25,
        "max_price": 30,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1GXD-pyO4OftXHh9HRRSqIDi1Pcw9Qs_T?usp=drive_link",
        "description": "Product Introduction：This 3D all-over print half-zip sweatshirt features a relaxed casual fit with customizable patterns. Available in various sizes, it matches outfits easily in spring and autumn, making it a nice personalized holiday gift for relatives and friends.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1q9fiURW__DARTCldPAJOXGpFvYA_LyLq",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1dGo5Lam76_HXwnGdNiqRNIt3PTt3_ZYY",
            "https://lh3.googleusercontent.com/d/1q9fiURW__DARTCldPAJOXGpFvYA_LyLq"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "320gAir layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP TBD 3D half zip sweatshirt",
                "variant_id": "TBD3DBLLWY",
                "location": "CN",
                "material": "320gAir layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 414,
        "name": "30oz Tumbler",
        "slug": "30oz-tumbler-30OZYXQC",
        "sku": "30OZYXQC",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1J3s6plx2JcBuUA_suxL9rLqM8sno_phM",
        "modified_at": 1784270350,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 15,
            "name": "Drinkware",
            "slug": "drinkware",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/drinkware.jpg",
            "description": null,
            "modified_at": 1773763799
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ETUjx01k3g8Q3f2MoICsq04cAEYwk_4w?usp=drive_link",
        "description": "Product Introduction：This 30oz tumbler features 3D all-over print customization. Double-wall vacuum insulation, leak-proof, ideal for daily commuting, a practical personalized gift choice.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Drop-proof | Leakproof | Insulated for hot & cold | Lightweight, ideal for daily & outdoor use.<br />\n<br />\n3.Washing Instructions：Regular hand wash, periodic seal cleaning. No steel wool / acid cleaners; no carbonated & alkaline beverages; Do not heat empty.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1J3s6plx2JcBuUA_suxL9rLqM8sno_phM",
            "https://lh3.googleusercontent.com/d/1Cmp2M-x_PwP_amrMmygRdTn_t_uKHVEO"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "30oz"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Bottom Closed No Opening",
                    "Opening No Bottom",
                    "Opening & Bottom Available",
                    "No Opening & No Bottom"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Stainless Steel"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "30oz Tumbler",
                "variant_id": "30OZYXQC-30OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "30oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Bottom Closed No Opening",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "30oz Tumbler",
                "variant_id": "30OZYXQC-30OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "30oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Opening No Bottom",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "30oz Tumbler",
                "variant_id": "30OZYXQC-30OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "30oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Opening & Bottom Available",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "30oz Tumbler",
                "variant_id": "30OZYXQC-30OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "30oz",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "No Opening & No Bottom",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3354,
        "name": "AOP Universal hooded sweatshirt double hat - Waffle",
        "slug": "aop-universal-hooded-sweatshirt-double-hat-waffle-TBLMWYSM-HFG",
        "sku": "TBLMWYSM-HFG",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1WZzgFxz0OudnBT0o9uO8grixujkT4IXC",
        "modified_at": 1784624493,
        "price": 19.5,
        "min_price": 19.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1xuA33FzOQ1l_E4f7qrw-JK5p5ECv67ZM?usp=drive_link",
        "description": "Product Introduction：Waffle double-hoodie with rich texture, layered depth from unique fabric. Great for daily casual wear, relaxed fit with effortless street style.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Soft textured, non-sticky, breathable fluffy fabric.<br />\n<br />\n4.Washing Instructions：Cold gentle wash/delicate cycle, no hot water & bleach. Flat shade dry, no wringing/sun, low iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1ASydWXXF-JP_vIfudn4lohzssmwBWXLq",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1WZzgFxz0OudnBT0o9uO8grixujkT4IXC",
            "https://lh3.googleusercontent.com/d/1jfrByp0CHzHKeYJkPdO17EGZ8hbnPtQR",
            "https://lh3.googleusercontent.com/d/1zP4JoC8Eo5sgWl0P5hjVOtjctNmjGp0X",
            "https://lh3.googleusercontent.com/d/1ASydWXXF-JP_vIfudn4lohzssmwBWXLq"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Waffle fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Universal hooded sweatshirt double hat - Waffle",
                "variant_id": "TBLMWYSM-HFG-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 325,
        "name": "AOP Ugly Cardigan",
        "slug": "aop-ugly-cardigan-FZZKS",
        "sku": "FZZKS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1rJOOjvCwSX0tj6BbpgxJph-sUlL4XR6Z",
        "modified_at": 1783584865,
        "price": 21.5,
        "min_price": 21.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1tynRG_lP75ZkorHKtQRIhJ2--HFWnr1r?usp=drive_link",
        "description": "Product Introduction：Crafted from soft 270g artificial wool, this ugly cardigan offers warmth, comfort, and a fun festive style. The relaxed fit makes it perfect for layering during cooler seasons, while the playful design is ideal for holiday parties, family gatherings, and Christmas celebrations. A great gift for friends, family, or anyone who loves seasonal fashion.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick textured fabric, warm & stretchy. Relaxed slim style, cozy without bulk in cold seasons.<br />\n<br />\n4.Washing Instructions：Hand wash preferred. Lay flat to dry. Do not hang.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/18iht1OTp4gt5VJ48kZdGspeYtXcmJhcX",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1rJOOjvCwSX0tj6BbpgxJph-sUlL4XR6Z",
            "https://lh3.googleusercontent.com/d/18iht1OTp4gt5VJ48kZdGspeYtXcmJhcX"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "270gArtificial wool"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Ugly Cardigan",
                "variant_id": "FZZKS-270GARTIFICIAL-WOOL",
                "location": "CN",
                "material": "270gArtificial wool",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3,
        "name": "2D Zip-Up Hoodie with Leather Trim",
        "slug": "2d-zip-up-hoodie-with-leather-trim-LLTPWY",
        "sku": "LLTPWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1XL5va4z2PkHg0sUM6HgAvBS2RgJdWnua",
        "modified_at": 1785486868,
        "price": 23.5,
        "min_price": 23.5,
        "max_price": 28.5,
        "is_new": false,
        "is_best_seller": true,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1IqKMr-44Wa28WnF-8fHcQV3K77HSA_f6?usp=drive_link",
        "description": "Product Introduction：This 2D zip-up hoodie with leather trim comes in 9 colors and multiple sizes. Stylish and well-fitted, easy to match, suitable for daily casual wear in spring, autumn and winter. Ideal as a practical holiday gift for men and women.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1naMD1M-pLYsdAGeFWxYUonO4Cm7mcNVa",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1XL5va4z2PkHg0sUM6HgAvBS2RgJdWnua",
            "https://lh3.googleusercontent.com/d/1naMD1M-pLYsdAGeFWxYUonO4Cm7mcNVa"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Grey",
                    "Navy Blue",
                    "Army Green",
                    "Khaki",
                    "Pink",
                    "Blue",
                    "Wine Red"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Navy Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Khaki",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Pink",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Zip-Up Hoodie with Leather Trim",
                "variant_id": "LLTPWY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 269,
        "name": "3D Thick Fleece Hoodie",
        "slug": "3d-thick-fleece-hoodie-TBHRLMS",
        "sku": "TBHRLMS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1cly_wnqJpKrU_ln8OPPVFFdzxLjVScT4",
        "modified_at": 1783584865,
        "price": 29.5,
        "min_price": 29.5,
        "max_price": 34.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1nglqrnS3VQe2lg-4n_2LHWzJ_2-7eU7-?usp=drive_link",
        "description": "Product Introduction：Crafted from 180g heavy flannel fleece, this 3D hoodie delivers exceptional warmth and a cozy feel for chilly days. The relaxed fit and vibrant all-over print create a stylish yet comfortable look. Perfect for outdoor activities, travel, or everyday wear during autumn and winter. A thoughtful gift for family and friends.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Fine short plush, soft & skin-friendly. Warm, lightweight and comfortable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, shade dry. No high heat drying to prevent clumping.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/16EbG0wqlQFxhO79TjWM0odujCMaysHH-",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1cly_wnqJpKrU_ln8OPPVFFdzxLjVScT4",
            "https://lh3.googleusercontent.com/d/16EbG0wqlQFxhO79TjWM0odujCMaysHH-"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "180gHeavy flannel fleece"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Thick Fleece Hoodie",
                "variant_id": "TBHRLMS-180GHEAVY-FLANNEL-FLEECE",
                "location": "CN",
                "material": "180gHeavy flannel fleece",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29.5,
                        "non_contiguous": 34.5
                    },
                    "EU": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    },
                    "CA": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2603,
        "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
        "slug": "aop-ngo-bound-short-sleeve-shirt-and-shorts-pajama-set-NGO-BBDXCSDKSYTZ",
        "sku": "NGO-BBDXCSDKSYTZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/15dR4S7teYnWq8xrpBRgF4EO51diOeayF",
        "modified_at": 1783584867,
        "price": 22.5,
        "min_price": 22.5,
        "max_price": 27.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1gXb5W_IZj8xWjAco_6wjaoDtIWwbyM01?usp=drive_link",
        "description": "Product Introduction：Short-sleeve shirt & shorts pajama set with contrast piping, full 3D all-over print customizable. Loose silky fabric breathable for summer home wear, matched set, ideal personalized couple gifts for festivals.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Glossy silky, nice drape, lightweight, wrinkle-free.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard rub/wring, shade dry, no sun/high iron to keep luster.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1E3vRN5NLek8U0A_HaeBZEDV_L5l0WYMv",
        "gallery": [
            "https://lh3.googleusercontent.com/d/15dR4S7teYnWq8xrpBRgF4EO51diOeayF",
            "https://lh3.googleusercontent.com/d/1E3vRN5NLek8U0A_HaeBZEDV_L5l0WYMv"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "90g Satin"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Short Sleeve Shirt and Shorts Pajama Set",
                "variant_id": "NGO-BBDXCSDKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20.5,
                        "non_contiguous": 25.5
                    },
                    "EU": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    },
                    "CA": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 234,
        "name": "3D Leggings",
        "slug": "3d-leggings-MEGYJK",
        "sku": "MEGYJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1RYXQyb3fdJpQjiL8WvJYX9De3yzAuOPs",
        "modified_at": 1783584865,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1R6XL-1WO_kjnweQVWdKnilY1RNfCsZP-?usp=drive_link",
        "description": "Product Introduction：High-waist 3D leggings with a sculpted, body-hugging silhouette that enhances natural curves while ensuring flexible comfort. Perfect for gym sessions, yoga, running, or casual athleisure looks. Suitable for active individuals seeking style and performance. Ideal gift for fitness lovers. Wearable year-round, easily paired with hoodies, tees, or sports bras for versatile everyday outfits.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Silky soft, comfy wear, good drape, stretchy, breathable & sweat absorbent.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, shade dry, no sun/high heat iron to prevent shrink & stiffening.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/17xiTTVFrweBQiemO0buj35CvF6taldoG",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1RYXQyb3fdJpQjiL8WvJYX9De3yzAuOPs",
            "https://lh3.googleusercontent.com/d/17xiTTVFrweBQiemO0buj35CvF6taldoG"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "150g milk silk"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Leggings",
                "variant_id": "MEGYJK-150G-MILK-SILK",
                "location": "CN",
                "material": "150g milk silk",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 455,
        "name": "XR3D Knit Beanie",
        "slug": "xr3d-knit-beanie-XR-CR3DZZM",
        "sku": "XR-CR3DZZM",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1FwtvLSYUKIQamg0xKPoaIqUSr4Gy0OVq",
        "modified_at": 1773974356,
        "price": 11,
        "min_price": 11,
        "max_price": 16,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 17,
            "name": "Cap & Hat",
            "slug": "cap-hat",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/hat.jpg",
            "description": null,
            "modified_at": 1786348981
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ZoM3-aWrpzMID6Dv-xSpg6CrYJBaDBJ7?usp=drive_link",
        "description": "Product Introduction：Soft XR3D knitted beanie allows full-hat custom pattern printing, made of gentle stretch fabric that fits snugly. Suitable for outdoor trips and indoor wear in cold seasons, personalized prints make it a warm winter gift.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Thick textured fabric, warm & stretchy. Relaxed slim style, cozy without bulk in cold seasons.<br />\n<br />\n3.Washing Instructions：Hand wash preferred. Lay flat to dry. Do not hang.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1FwtvLSYUKIQamg0xKPoaIqUSr4Gy0OVq",
            "https://lh3.googleusercontent.com/d/1MO4Coe8CSQzweWR6aRa47TlkGysxl9cA"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "270G Puller Strip"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "XR3D Knit Beanie",
                "variant_id": "XR-CR3DZZM-ONE-SIZE-270G-PULLER-STRIP",
                "location": "CN",
                "color": "3D",
                "material": "270G Puller Strip",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 9,
                        "non_contiguous": 14
                    },
                    "EU": {
                        "mainland": 10,
                        "non_contiguous": 10
                    },
                    "CA": {
                        "mainland": 14,
                        "non_contiguous": 14
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 427,
        "name": "3D Adult Bucket Hat",
        "slug": "3d-adult-bucket-hat-CRYFM",
        "sku": "CRYFM",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1v0Ml7ZGovOBw_miw3DhWtsihS1DVUcqL",
        "modified_at": 1784003467,
        "price": 15,
        "min_price": 15,
        "max_price": 20,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 17,
            "name": "Cap & Hat",
            "slug": "cap-hat",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/hat.jpg",
            "description": null,
            "modified_at": 1786348981
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1_0_r2QmxISNe-yOvyPCYnEZKMYtcQptI?usp=drive_link",
        "description": "Product Introduction：This plain blank bucket hat supports full-cap 3D digital printing customization. The wide brim blocks harsh sunlight with lightweight, skin-friendly fabric. Ideal for travel photos and daily commutes, customized patterns make it a thoughtful gift for travel lovers.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Crisp, durable, wrinkle-resistant, well-shaped and easy to maintain.<br />\n<br />\n3.Washing Instructions：Regular wash, medium iron. Do not wring, hang dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1v0Ml7ZGovOBw_miw3DhWtsihS1DVUcqL",
            "https://lh3.googleusercontent.com/d/1owkqnD1OSAHydLGVqRh7UB21b4DP2MV5"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "S",
                    "M",
                    "L"
                ]
            },
            {
                "option": "material",
                "values": [
                    "220g Twill"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Adult Bucket Hat",
                "variant_id": "CRYFM-ONE-SIZE-220G-TWILL",
                "location": "CN",
                "material": "220g Twill",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "color": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult Bucket Hat",
                "variant_id": "CRYFM-ONE-SIZE-220G-TWILL",
                "location": "CN",
                "material": "220g Twill",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "color": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult Bucket Hat",
                "variant_id": "CRYFM-ONE-SIZE-220G-TWILL",
                "location": "CN",
                "material": "220g Twill",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "color": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2299,
        "name": "AOP Women's Short Sleeve",
        "slug": "aop-womens-short-sleeve-MEGNSDX",
        "sku": "MEGNSDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1mmjE4ZWp0-LkaGhVUjLgXdqCGlFPvTHj",
        "modified_at": 1783584866,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/17F548EF-Lm55XBtxhulTb4QPRoUHoxJL?usp=drive_link",
        "description": "Product Introduction：This AOP Women's Short Sleeve T-Shirt features 3D all-over custom print. With a classic crew neck for a snug fit, the skin-friendly and breathable fabric offers all-day comfort, and the loose fit ensures versatile style—perfect for summer daily wear and commuting.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1d18-f27sKhVH_0jdgqlwObZ5-O4jJCt2",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1mmjE4ZWp0-LkaGhVUjLgXdqCGlFPvTHj",
            "https://lh3.googleusercontent.com/d/1d18-f27sKhVH_0jdgqlwObZ5-O4jJCt2"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Cotton-like"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Women's Short Sleeve",
                "variant_id": "MEGNSDX",
                "location": "CN",
                "material": "Cotton-like",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 381,
        "name": "Gentleman Stainless Steel Watch-1",
        "slug": "gentleman-stainless-steel-watch-1-LLSKSB",
        "sku": "LLSKSB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1_kvPRsteCmcKcfp-5IHQ9207dZYBiBdD",
        "modified_at": 1783936881,
        "price": 15.5,
        "min_price": 15.5,
        "max_price": 22.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 7,
            "name": "Watch",
            "slug": "watch",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/watch.jpg",
            "description": null,
            "modified_at": 1773193285
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1g8XkzQ_3t7iU-dAeTlx5Hz8zBYDT2lvq?usp=drive_link",
        "description": "Product Introduction：Trendy and distinctive design, unique dial shape stands out easily. Soft strap fits the wrist comfortably, perfect for street fashion and everyday wear. Strong fashion statement, showcases your personal style.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Harder than regular metal, sturdy, fine texture, great value.<br />\n<br />\n3.Packaging：No box|Standard Paper Box|Luxury Leather Box<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1VZKmxS5zHU1xz0czmKaE1D1Unr0Q5tc4",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1_kvPRsteCmcKcfp-5IHQ9207dZYBiBdD",
            "https://lh3.googleusercontent.com/d/1VZKmxS5zHU1xz0czmKaE1D1Unr0Q5tc4"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "Black",
                    "Silver"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Alloy material"
                ]
            },
            {
                "option": "packaging",
                "values": [
                    "No box",
                    "Standard Paper Box",
                    "Luxury Leather Box"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Gentleman Stainless Steel Watch-1",
                "variant_id": "LLSKSB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Gentleman Stainless Steel Watch-1",
                "variant_id": "LLSKSB-ALLOY-MATERIAL-NO-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "No box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "color": "Silver",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Gentleman Stainless Steel Watch-1",
                "variant_id": "LLSKSB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Gentleman Stainless Steel Watch-1",
                "variant_id": "LLSKSB-ALLOY-MATERIAL-STANDARD-PAPER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Standard Paper Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "color": "Silver",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Gentleman Stainless Steel Watch-1",
                "variant_id": "LLSKSB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Gentleman Stainless Steel Watch-1",
                "variant_id": "LLSKSB-ALLOY-MATERIAL-LUXURY-LEATHER-BOX",
                "location": "CN",
                "material": "Alloy material",
                "packaging": "Luxury Leather Box",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "color": "Silver",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 712,
        "name": "3D Handbag-Zipper",
        "slug": "3d-handbag-zipper-ZCSTBLL",
        "sku": "ZCSTBLL",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1OU3bpgqeNbX7Met_ZmhUcHnSHAoN1Ega",
        "modified_at": 1785396354,
        "price": 23,
        "min_price": 23,
        "max_price": 36,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 18,
            "name": "Bag & Wallet",
            "slug": "bag-wallet",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/bag.jpg",
            "description": null,
            "modified_at": 1773762814
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/19_BSeirJJoyLtT-uNEwJt1LQ0ZBH6QPr?usp=drive_link",
        "description": "Product Introduction：Sleek 3D PU handbag with smooth zipper closure and modern quilted texture. Compact yet spacious for daily essentials—phone, cards, and keys. Perfect for parties, dates, or work. Durable, trendy, and chic—a stylish gift for fashion lovers.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：PU leather,Flexible, waterproof, varied patterns, good value and nice shaping effect.<br />\n<br />\n3.Washing Instructions：Sleek 3D PU handbag with smooth zipper closure and modern quilted texture. Compact yet spacious for daily essentials—phone, cards, and keys. Perfect for parties, dates, or work. Durable, trendy, and chic—a stylish gift for fashion lovers.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1OU3bpgqeNbX7Met_ZmhUcHnSHAoN1Ega",
            "https://lh3.googleusercontent.com/d/16VW5tMURk8-B2U3N0tflDNwiC9bH0kxk"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "Size S (with shoulder straps)",
                    "Size M (with shoulder straps)",
                    "Size L (with shoulder straps)"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black handle",
                    "White handle"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Handbag-Zipper",
                "variant_id": "ZCSTBLL-SIZE-S-WITH-SHOULDER-STRAPS-PU",
                "location": "CN",
                "size": "Size S (with shoulder straps)",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "color": "Black handle",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Handbag-Zipper",
                "variant_id": "ZCSTBLL-SIZE-S-WITH-SHOULDER-STRAPS-PU",
                "location": "CN",
                "size": "Size S (with shoulder straps)",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "color": "White handle",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Handbag-Zipper",
                "variant_id": "ZCSTBLL-SIZE-M-WITH-SHOULDER-STRAPS-PU",
                "location": "CN",
                "size": "Size M (with shoulder straps)",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 27,
                        "non_contiguous": 32
                    },
                    "EU": {
                        "mainland": 28,
                        "non_contiguous": 28
                    },
                    "CA": {
                        "mainland": 32,
                        "non_contiguous": 32
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "color": "Black handle",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Handbag-Zipper",
                "variant_id": "ZCSTBLL-SIZE-M-WITH-SHOULDER-STRAPS-PU",
                "location": "CN",
                "size": "Size M (with shoulder straps)",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 27,
                        "non_contiguous": 32
                    },
                    "EU": {
                        "mainland": 28,
                        "non_contiguous": 28
                    },
                    "CA": {
                        "mainland": 32,
                        "non_contiguous": 32
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "color": "White handle",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Handbag-Zipper",
                "variant_id": "ZCSTBLL-SIZE-L-WITH-SHOULDER-STRAPS-PU",
                "location": "CN",
                "size": "Size L (with shoulder straps)",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "color": "Black handle",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Handbag-Zipper",
                "variant_id": "ZCSTBLL-SIZE-L-WITH-SHOULDER-STRAPS-PU",
                "location": "CN",
                "size": "Size L (with shoulder straps)",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "color": "White handle",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3619,
        "name": "Quilted Halloween Witch Hat",
        "slug": "quilted-halloween-witch-hat-HFWSJNVM",
        "sku": "HFWSJNVM",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1nKLHdWzu8rrb_3ztk178A4Ky4tMdZ_P0",
        "modified_at": 1786349014,
        "price": 15,
        "min_price": 15,
        "max_price": 20.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 17,
            "name": "Cap & Hat",
            "slug": "cap-hat",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/hat.jpg",
            "description": null,
            "modified_at": 1786348981
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1IDGxUdRXgD9XbfutnS8mB1mks2kWkWbE?usp=drive_link",
        "description": "Product Introduction：Quilted patchwork Halloween witch hat, multi‑color scrap‑fabric splicing with 3D quilting craft. Wide ruffled brim and pointed cone top. Vintage playful style, ideal for party cosplay and holiday photo shoots with strong festive vibe.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Soft and plush surface with delicate touch, great warmth and pill-resistant.<br />\n<br />\n3.Washing Instructions：Wash inside out, no hard rubbing. Shade dry, avoid strong sun.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1nKLHdWzu8rrb_3ztk178A4Ky4tMdZ_P0",
            "https://lh3.googleusercontent.com/d/18jz25zrwPm2AW3aLRg25GoRakFpz1Kvh",
            "https://lh3.googleusercontent.com/d/1Z297auLZhExkEVQdl5vfeGiKufwSJwo9",
            "https://lh3.googleusercontent.com/d/1-PcbQeSJQqqL3Kt6xsQXB_-RoKiqI3Rc",
            "https://lh3.googleusercontent.com/d/1YDNik9JSV5YFYhIL4YUt86iwLFdBbkH8"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "Kids",
                    "Adult / Big Kids"
                ]
            },
            {
                "option": "color",
                "values": [
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Brushed Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Quilted Halloween Witch Hat",
                "variant_id": "HFWSJNVM-3D-KIDS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "Kids",
                "color": "3D",
                "material": "Brushed Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Quilted Halloween Witch Hat",
                "variant_id": "HFWSJNVM-3D-ADULT-BIG-KIDS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "Adult / Big Kids",
                "color": "3D",
                "material": "Brushed Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 24,
        "name": "2D windproof jacket",
        "slug": "2d-windproof-jacket-2DCFY",
        "sku": "2DCFY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ClQeHW0YEKcSRgjMy0c25y0Krhj6AQ0r",
        "modified_at": 1785486868,
        "price": 35.5,
        "min_price": 35.5,
        "max_price": 40.5,
        "is_new": true,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1WcMJjyd3hlSmtZUPWnf2dFvmjHaNRccn?usp=drive_link",
        "description": "Product Introduction：This 2D windproof jacket is available in black, red and blue, sizes S–5XL. Lightweight, wind-resistant with a relaxed fit, perfect for outdoor and daily wear in spring and autumn. Easy to match, great as a practical holiday gift.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1_CMrqIdXRucG0y2a8ZQX1Z23BgoWiMbt",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ClQeHW0YEKcSRgjMy0c25y0Krhj6AQ0r",
            "https://lh3.googleusercontent.com/d/1_CMrqIdXRucG0y2a8ZQX1Z23BgoWiMbt"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Red",
                    "Blue"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "S",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "S",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "M",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "M",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "L",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "L",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "2XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "2XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "3XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "3XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "4XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "4XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "5XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "5XL",
                "color": "Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D windproof jacket",
                "variant_id": "2DCFY-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 35.5,
                        "non_contiguous": 40.5
                    },
                    "EU": {
                        "mainland": 36.5,
                        "non_contiguous": 36.5
                    },
                    "CA": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 33.5,
                        "non_contiguous": 38.5
                    },
                    "EU": {
                        "mainland": 34.5,
                        "non_contiguous": 34.5
                    },
                    "CA": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    }
                },
                "size": "5XL",
                "color": "Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3809,
        "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
        "slug": "aop-doublestitched-mhn-adult-hoodie-250g-japanese-fabric-SFXMHNCRLMS-250GRBB",
        "sku": "SFXMHNCRLMS-250GRBB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Z-ylOmFzgUqihpwr_aYOQdgORzcUfbQ0",
        "modified_at": 1790220752,
        "price": 21,
        "min_price": 21,
        "max_price": 26,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1mprvGgndyh2J3xqvB24BYyNGgubYJAzR?usp=drive_link",
        "description": "<p>Processing Time: 5-7 days</p><p>Shipping Time: 7-15 days</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1mprvGgndyh2J3xqvB24BYyNGgubYJAzR?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/14aLKJ5PIJqJEBYwr2SdgpThKLCmGRwDA",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Z-ylOmFzgUqihpwr_aYOQdgORzcUfbQ0",
            "https://lh3.googleusercontent.com/d/15Y39LsluS_nDsvKCA_maqukwqZGAk2CN",
            "https://lh3.googleusercontent.com/d/1kHDGS1VdEhyfVYAuiYxz5-d0K3z4CH2T",
            "https://lh3.googleusercontent.com/d/16VYdfF2j4kTU7wrPl_tOuDXIt72-pYhs",
            "https://lh3.googleusercontent.com/d/14aLKJ5PIJqJEBYwr2SdgpThKLCmGRwDA"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Japanese fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Double‑Stitched MHN Adult Hoodie, 250g Japanese Fabric",
                "variant_id": "SFXMHNCRLMS-250GRBB-JAPANESE-FABRIC",
                "location": "CN",
                "material": "Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 923,
        "name": "High-Top Canvas Shoes (Printable Tongue)",
        "slug": "high-top-canvas-shoes-printable-tongue-WK1W",
        "sku": "WK1W",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/140OdY1jwUrAISRoyC8TO7t4DIZJC9bUj",
        "modified_at": 1783418292,
        "price": 30,
        "min_price": 30,
        "max_price": 35,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1QepHIlMMpd59TVsh2fKX_JDqETlxZnEm?usp=drive_link",
        "description": "Product Introduction：Customizable full 3D print available, patterns can be printed on the tongue. Breathable mesh upper, lightweight cushioned EVA sole. Versatile high-top design comfy for daily trips, a unique holiday gift.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1kHDiEwusOnP_2cqYua25LRztdwuuxsqX",
        "gallery": [
            "https://lh3.googleusercontent.com/d/140OdY1jwUrAISRoyC8TO7t4DIZJC9bUj",
            "https://lh3.googleusercontent.com/d/1kHDiEwusOnP_2cqYua25LRztdwuuxsqX"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "35",
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Black"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Mesh + PU\nSole: EVA"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "35",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "35",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "36",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "36",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "37",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "37",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "38",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "38",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "39",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "39",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "40",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "40",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "41",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "41",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "42",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "42",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "43",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "43",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "44",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "44",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "45",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "45",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "46",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "46",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "47",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "47",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "48",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "48",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "49",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "High-Top Canvas Shoes (Printable Tongue)",
                "variant_id": "WK1W",
                "location": "CN",
                "material": "Upper: Mesh + PU\nSole: EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "size": "49",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 26,
        "name": "2D Leather Jacket 2 - Hooded Jacket",
        "slug": "2d-leather-jacket-2-hooded-jacket-2DPYDMJK",
        "sku": "2DPYDMJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1RNAMYTvM-sBZOiNI0pRiuUzTiD6Hcwrh",
        "modified_at": 1785486868,
        "price": 48.5,
        "min_price": 48.5,
        "max_price": 53.5,
        "is_new": true,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/19qJDexTCn8iMnJf5sHSbS7E_ObAdIDYy?usp=drive_link",
        "description": "Product Introduction：This 2D Hooded Leather Jacket 2 comes in black and brown, sizes S–3XL. With a stylish fit and soft texture, it’s perfect for casual daily and street wear in spring and autumn. Easy to match and a great holiday gift choice.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Stiff compact fabric | Wind & water resistant | Durable stylish | Vintage upscale | Warm keeping.<br />\n<br />\n3.Washing Instructions：Reduce washing; spot clean with leather cleaner. No soak/sun exposure, shade storage, keep off oil/sharp items, condition seasonally.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1g2wrL1wki6NYfzyEL-yvEVdN4P4JY-J4",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1RNAMYTvM-sBZOiNI0pRiuUzTiD6Hcwrh",
            "https://lh3.googleusercontent.com/d/1g2wrL1wki6NYfzyEL-yvEVdN4P4JY-J4"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Brown"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU leather"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "S",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "M",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "L",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "2XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Leather Jacket 2 - Hooded Jacket",
                "variant_id": "2DPYDMJK-PU-LEATHER",
                "location": "CN",
                "material": "PU leather",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 48.5,
                        "non_contiguous": 53.5
                    },
                    "EU": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    },
                    "CA": {
                        "mainland": 53.5,
                        "non_contiguous": 53.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "size": "3XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 1500,
        "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
        "slug": "diamond-needle-quilted-cotton-three-piece-bed-set-LXZHFMBZSJT",
        "sku": "LXZHFMBZSJT",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1IuNPrBkRiIxOpbYQ1x5cLgezE-Y-lr1Z",
        "modified_at": 1785487716,
        "price": 27,
        "min_price": 27,
        "max_price": 57,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1yBj0xHCxIZ1HarlkcTuhWZHyo5nzuKX_?usp=drive_link",
        "description": "Product Introduction：Crafted with delicate diamond quilting, this cotton bedding has rich sizing selections to fit various beds. Suitable for home and guest room decoration, it works as nice moving gifts, wear-resistant stitching prevents filling shifting during long use.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Wrinkle & wear resistant, quick-dry, non-deformable, easy care, colorfast.<br />\n<br />\n3.Washing Instructions：Cold gentle wash, machine washable. No high heat drying / bleach. Medium-low iron. Low shrinkage.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1IuNPrBkRiIxOpbYQ1x5cLgezE-Y-lr1Z",
            "https://lh3.googleusercontent.com/d/1cxIxmrMQdDFYMgbM53oXHFUL5UVwrcqJ"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "130x150cm",
                    "140x152cm",
                    "150x200cm",
                    "180x200cm",
                    "173x203cm",
                    "200x230cm",
                    "230x230cm",
                    "230x260cm",
                    "190x215cm",
                    "180x220cm",
                    "230x280cm",
                    "265x240cm",
                    "150x180cm",
                    "175x229cm"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Polyester fiber"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-130X150CM",
                "location": "CN",
                "size": "130x150cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 27,
                        "non_contiguous": 32
                    },
                    "EU": {
                        "mainland": 28,
                        "non_contiguous": 28
                    },
                    "CA": {
                        "mainland": 32,
                        "non_contiguous": 32
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 25,
                        "non_contiguous": 30
                    },
                    "EU": {
                        "mainland": 26,
                        "non_contiguous": 26
                    },
                    "CA": {
                        "mainland": 30,
                        "non_contiguous": 30
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-140X152CM",
                "location": "CN",
                "size": "140x152cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-150X200CM",
                "location": "CN",
                "size": "150x200cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-180X200CM",
                "location": "CN",
                "size": "180x200cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-173X203CM",
                "location": "CN",
                "size": "173x203cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-200X230CM",
                "location": "CN",
                "size": "200x230cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-230X230CM",
                "location": "CN",
                "size": "230x230cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 45,
                        "non_contiguous": 50
                    },
                    "EU": {
                        "mainland": 46,
                        "non_contiguous": 46
                    },
                    "CA": {
                        "mainland": 50,
                        "non_contiguous": 50
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-230X260CM",
                "location": "CN",
                "size": "230x260cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49,
                        "non_contiguous": 54
                    },
                    "EU": {
                        "mainland": 50,
                        "non_contiguous": 50
                    },
                    "CA": {
                        "mainland": 54,
                        "non_contiguous": 54
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47,
                        "non_contiguous": 52
                    },
                    "EU": {
                        "mainland": 48,
                        "non_contiguous": 48
                    },
                    "CA": {
                        "mainland": 52,
                        "non_contiguous": 52
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-190X215CM",
                "location": "CN",
                "size": "190x215cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-180X220CM",
                "location": "CN",
                "size": "180x220cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-230X280CM",
                "location": "CN",
                "size": "230x280cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 52,
                        "non_contiguous": 57
                    },
                    "EU": {
                        "mainland": 53,
                        "non_contiguous": 53
                    },
                    "CA": {
                        "mainland": 57,
                        "non_contiguous": 57
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 50,
                        "non_contiguous": 55
                    },
                    "EU": {
                        "mainland": 51,
                        "non_contiguous": 51
                    },
                    "CA": {
                        "mainland": 55,
                        "non_contiguous": 55
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-265X240CM-POLYESTER-FIBER",
                "location": "CN",
                "size": "265x240cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 52,
                        "non_contiguous": 57
                    },
                    "EU": {
                        "mainland": 53,
                        "non_contiguous": 53
                    },
                    "CA": {
                        "mainland": 57,
                        "non_contiguous": 57
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 50,
                        "non_contiguous": 55
                    },
                    "EU": {
                        "mainland": 51,
                        "non_contiguous": 51
                    },
                    "CA": {
                        "mainland": 55,
                        "non_contiguous": 55
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-150X180CM-POLYESTER-FIBER",
                "location": "CN",
                "size": "150x180cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Diamond Needle Quilted Cotton \nThree-piece Bed Set",
                "variant_id": "LXZHFMBZSJT-175X229CM-POLYESTER-FIBER",
                "location": "CN",
                "size": "175x229cm",
                "material": "Polyester fiber",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 37,
                        "non_contiguous": 42
                    },
                    "EU": {
                        "mainland": 38,
                        "non_contiguous": 38
                    },
                    "CA": {
                        "mainland": 42,
                        "non_contiguous": 42
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 35,
                        "non_contiguous": 40
                    },
                    "EU": {
                        "mainland": 36,
                        "non_contiguous": 36
                    },
                    "CA": {
                        "mainland": 40,
                        "non_contiguous": 40
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 598,
        "name": "AD-SMBA",
        "slug": "ad-smba-SMBA",
        "sku": "SMBA",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/15IEqOgafM3IZXRk-BhsCC3eSjQpIRORJ",
        "modified_at": 1784624763,
        "price": 43,
        "min_price": 43,
        "max_price": 48,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1QYt7tOP2VIfMLRhaT8jX2uVG37woJXCB?usp=drive_link",
        "description": "Product Introduction：AD-SMBA retro German trainers support custom full 3D printing. Breathable mesh upper with anti-slip TPU gum outsole, lightweight and snug without chafing. Minimalist all-season style, ideal for men and women’s daily commutes, great personalized holiday gifts.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1Lh3rbjQSy8y5O8xdrO4irtTrhNiNW_Xy",
        "gallery": [
            "https://lh3.googleusercontent.com/d/15IEqOgafM3IZXRk-BhsCC3eSjQpIRORJ",
            "https://lh3.googleusercontent.com/d/1KRTvcWsk8-LOUQqbsVxECkqQGinWXtjK",
            "https://lh3.googleusercontent.com/d/1kQzCXp3OrhnnnwaDsodL6mji2g4TNfLC",
            "https://lh3.googleusercontent.com/d/1Lh3rbjQSy8y5O8xdrO4irtTrhNiNW_Xy"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Upper: Mesh fabric\nSole: TPU"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AD-SMBA",
                "variant_id": "SMBA-MESH-TPU",
                "location": "CN",
                "material": "Upper: Mesh fabric\nSole: TPU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3949,
        "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
        "slug": "aop-one-piece-hood-hoodie-250gsm-japanese-fabric-YTXMZ-LMSRBU250",
        "sku": "YTXMZ-LMSRBU250",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ymfVtad-R1P0xiPhanDAu7VNIGZ4Zi1c",
        "modified_at": 1790763486,
        "price": 21.5,
        "min_price": 21.5,
        "max_price": 26.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/12UVaChXNscIwAJP_frpsJ3HxL_PfEyyT?usp=drive_link",
        "description": "<p>Processing Time: 5-7 days</p><p>Shipping Time: 7-15 days</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/12UVaChXNscIwAJP_frpsJ3HxL_PfEyyT?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/1KWM6juP4IMYOP2r5Vl8eJxKkebE0yV5p",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ymfVtad-R1P0xiPhanDAu7VNIGZ4Zi1c",
            "https://lh3.googleusercontent.com/d/1jbH7jUj4RtPY0nYFirZecuAkfnBPkHPv",
            "https://lh3.googleusercontent.com/d/1MIsC2TxaoTwpxP4gFd46NUwh7v2SEgQf",
            "https://lh3.googleusercontent.com/d/1JyQq-rmKuryI2rIB2t-UsDX6EcA5U7Ea",
            "https://lh3.googleusercontent.com/d/1KWM6juP4IMYOP2r5Vl8eJxKkebE0yV5p"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "250g Japanese fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP One-piece Hood - Hoodie, 250gsm Japanese Fabric",
                "variant_id": "YTXMZ-LMSRBU250-250G-JAPANESE-FABRIC",
                "location": "CN",
                "material": "250g Japanese fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2506,
        "name": "AOP Regular fit short sleeve button polo with pocket",
        "slug": "aop-regular-fit-short-sleeve-button-polo-with-pocket-TBPOLONKDXKD",
        "sku": "TBPOLONKDXKD",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/13g1arjwBW54HM4fpH0pzURP_KktjvZsF",
        "modified_at": 1783584867,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ITStkCnw9ftLtDMLtYX437Zb90kdReXS?usp=drive_link",
        "description": "Product Introduction：Regular-fit short-sleeve polo with chest pocket, fully customizable with 3D all-over prints. Neat non-restrictive cut, breathable fabric for spring & summer work and trips, matches all trousers, ideal custom gifts for men for holidays and team events.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Light soft cool touch, breathable mesh, sweat-wicking & fast drying.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent, no hard rubbing/softener. Shade dry, low iron, no high heat/sun to avoid mesh snag & distort.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1QrB74kyMSTEsDDXnmpqfKKIDBSSIcep2",
        "gallery": [
            "https://lh3.googleusercontent.com/d/13g1arjwBW54HM4fpH0pzURP_KktjvZsF",
            "https://lh3.googleusercontent.com/d/1QrB74kyMSTEsDDXnmpqfKKIDBSSIcep2"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "140g Bird-eye polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Regular fit short sleeve button polo with pocket",
                "variant_id": "TBPOLONKDXKD",
                "location": "CN",
                "material": "140g Bird-eye polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2,
        "name": "2D Stand Collar Long Sleeve Shirt",
        "slug": "2d-stand-collar-long-sleeve-shirt-2DXXLLCX",
        "sku": "2DXXLLCX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1R3QsMUTTCkCgK7pvDfRIYMcQRZ-SYj68",
        "modified_at": 1785486868,
        "price": 24.5,
        "min_price": 24.5,
        "max_price": 29.5,
        "is_new": false,
        "is_best_seller": true,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1P-dDPjrM3HD6tTJUwCc5g9n2PyM80_St?usp=drive_link",
        "description": "Product Introduction：This 2D stand collar long sleeve shirt features a sleek and modern design with a clean silhouette and stylish button details. The structured collar adds a refined touch, while the comfortable fit is suitable for daily wear, work, travel, and casual occasions. Perfect for men who value simple elegance, it pairs easily with jeans or trousers and makes a great gift for birthdays or holidays.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1hlOHPqZxO4JOWMucv4DOhPw7-PVSmQYR",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1R3QsMUTTCkCgK7pvDfRIYMcQRZ-SYj68",
            "https://lh3.googleusercontent.com/d/1iZS7AFY5XPBrbCylHBYVU2juQOFlDEAI",
            "https://lh3.googleusercontent.com/d/1hlOHPqZxO4JOWMucv4DOhPw7-PVSmQYR"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Navy blue",
                    "Light Green",
                    "Black",
                    "Wine Red",
                    "Army Green",
                    "Beige",
                    "Denim Blue",
                    "Grey",
                    "Brown"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "S",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "M",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "L",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "2XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "3XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "4XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Navy blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Light Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Wine Red",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Army Green",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Beige",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Denim Blue",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Stand Collar Long Sleeve Shirt",
                "variant_id": "2DXXLLCX-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22.5,
                        "non_contiguous": 27.5
                    },
                    "EU": {
                        "mainland": 23.5,
                        "non_contiguous": 23.5
                    },
                    "CA": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    }
                },
                "size": "5XL",
                "color": "Brown",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 207,
        "name": "AOP Plain short-sleeved hoodie",
        "slug": "aop-plain-short-sleeved-hoodie-DXLMS",
        "sku": "DXLMS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ZDN6gTitcFxQsBCx_G-hRtsl0AblCdf8",
        "modified_at": 1783584865,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1wzuNeXmE7KGPZmRfm2dQiY2QVzm1jVv0?usp=drive_link",
        "description": "Product Introduction：AOP plain short-sleeved hoodie features a clean minimalist look with soft breathable fabric and relaxed fit for everyday comfort. The hooded design adds a sporty, modern touch while maintaining lightweight wearability. Ideal for casual outings, travel, or light workouts. Perfect for spring and summer, easy to pair with shorts or joggers for effortless street style.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1htA42YCzeD0JEy07Iq0woyltukCVI7pB",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ZDN6gTitcFxQsBCx_G-hRtsl0AblCdf8",
            "https://lh3.googleusercontent.com/d/1htA42YCzeD0JEy07Iq0woyltukCVI7pB"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Plain short-sleeved hoodie",
                "variant_id": "DXLMS-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 444,
        "name": "Double-layer Double-sided Printed National Flag",
        "slug": "double-layer-double-sided-printed-national-flag-LJSCGQ",
        "sku": "LJSCGQ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1gXvIv6gnrHFoRWEBJgT8QTl5WG0Z93jv",
        "modified_at": 1785487715,
        "price": 11,
        "min_price": 11,
        "max_price": 43,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1imhLdCb9NVkOhaa7OMfuu-kRVpvSNVST?usp=drive_link",
        "description": "Product Introduction：This 3D Full-Print Custom Double-layer Double-sided Flag features a repeating brand pattern. Sturdy double-layer fabric ensures durability, ideal for events, home decor, or celebrations. A personalized, patriotic gift for holidays or special occasions, built to withstand outdoor use.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Waterproof, mildew-proof, light, flexible, easy-clean and shape-retaining.<br />\n<br />\n3.Washing Instructions：Wipe or regular wash, hang shade dry. Clean regularly for mildew prevention.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1gXvIv6gnrHFoRWEBJgT8QTl5WG0Z93jv",
            "https://lh3.googleusercontent.com/d/1UrBc4Mz0ojqEfr24tNtkVFt0Ycm1AFzr"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "29 x 44cm",
                    "92 x 152 cm",
                    "58x89cm",
                    "75x100cm",
                    "89x150cm",
                    "97x145cm",
                    "120x180cm",
                    "128x192cm",
                    "90x150cm",
                    "152x228cm",
                    "183x288cm",
                    "35x45",
                    "64x96cm",
                    "191x152cm",
                    "30x45cm",
                    "160x240cm"
                ]
            },
            {
                "option": "material",
                "values": [
                    "90g/m² Shower Curtain Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-29-X-44CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "29 x 44cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 9,
                        "non_contiguous": 14
                    },
                    "EU": {
                        "mainland": 10,
                        "non_contiguous": 10
                    },
                    "CA": {
                        "mainland": 14,
                        "non_contiguous": 14
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-92-X-152-CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "92 x 152 cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-58X89CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "58x89cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10,
                        "non_contiguous": 15
                    },
                    "EU": {
                        "mainland": 11,
                        "non_contiguous": 11
                    },
                    "CA": {
                        "mainland": 15,
                        "non_contiguous": 15
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-75X100CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "75x100cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-89X150CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "89x150cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-97X145CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "97x145cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-120X180CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "120x180cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 19,
                        "non_contiguous": 24
                    },
                    "EU": {
                        "mainland": 20,
                        "non_contiguous": 20
                    },
                    "CA": {
                        "mainland": 24,
                        "non_contiguous": 24
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-128X192CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "128x192cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 20,
                        "non_contiguous": 25
                    },
                    "EU": {
                        "mainland": 21,
                        "non_contiguous": 21
                    },
                    "CA": {
                        "mainland": 25,
                        "non_contiguous": 25
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-90X150CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "90x150cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-152X228CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "152x228cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 24,
                        "non_contiguous": 29
                    },
                    "EU": {
                        "mainland": 25,
                        "non_contiguous": 25
                    },
                    "CA": {
                        "mainland": 29,
                        "non_contiguous": 29
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 22,
                        "non_contiguous": 27
                    },
                    "EU": {
                        "mainland": 23,
                        "non_contiguous": 23
                    },
                    "CA": {
                        "mainland": 27,
                        "non_contiguous": 27
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-183X288CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "183x288cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 38,
                        "non_contiguous": 43
                    },
                    "EU": {
                        "mainland": 39,
                        "non_contiguous": 39
                    },
                    "CA": {
                        "mainland": 43,
                        "non_contiguous": 43
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 36,
                        "non_contiguous": 41
                    },
                    "EU": {
                        "mainland": 37,
                        "non_contiguous": 37
                    },
                    "CA": {
                        "mainland": 41,
                        "non_contiguous": 41
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-35X45-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "35x45",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10,
                        "non_contiguous": 15
                    },
                    "EU": {
                        "mainland": 11,
                        "non_contiguous": 11
                    },
                    "CA": {
                        "mainland": 15,
                        "non_contiguous": 15
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-64X96CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "64x96cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-191X152CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "191x152cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 34,
                        "non_contiguous": 39
                    },
                    "EU": {
                        "mainland": 35,
                        "non_contiguous": 35
                    },
                    "CA": {
                        "mainland": 39,
                        "non_contiguous": 39
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-30X45CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "30x45cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 11,
                        "non_contiguous": 16
                    },
                    "EU": {
                        "mainland": 12,
                        "non_contiguous": 12
                    },
                    "CA": {
                        "mainland": 16,
                        "non_contiguous": 16
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 9,
                        "non_contiguous": 14
                    },
                    "EU": {
                        "mainland": 10,
                        "non_contiguous": 10
                    },
                    "CA": {
                        "mainland": 14,
                        "non_contiguous": 14
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-layer Double-sided Printed National Flag",
                "variant_id": "LJSCGQ-160X240CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "160x240cm",
                "material": "90g/m² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2669,
        "name": "AOP EGD Long Sleeve Button Shirt",
        "slug": "aop-egd-long-sleeve-button-shirt-EGDCXNKCS",
        "sku": "EGDCXNKCS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ZfH3IUj2ELdR6PHDw7oaFDQZsjc6jSb2",
        "modified_at": 1790220752,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1AmYIiAzwmVdeiT_2F-eXSStcaK5mC9K2?usp=drive_link",
        "description": "Product Introduction：This long sleeve button shirt supports full 3D all-over personalized printing. Wrinkle-resistant soft fabric fits casual daily wear and light business occasions. Ultra-wide size range from 2XS to 6XL, ideal custom souvenir and holiday gift for all body types.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Skin-friendly & unrestricted. 4-way super stretch, flexible, body-hugging and shape-retaining.<br />\n<br />\n4.Washing Instructions：Cold gentle wash. No hard rubbing or wringing. No bleach. Low heat tumble dry / shade dry. No high heat ironing, to retain elasticity.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.\"",
        "size_guide": "https://lh3.googleusercontent.com/d/17BXNpZxRR6rsYThRj_EZyEi4KvPCc4pX",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ZfH3IUj2ELdR6PHDw7oaFDQZsjc6jSb2",
            "https://lh3.googleusercontent.com/d/1yAbN_JInVjWnKavU8D_omIxc0MoP9tTY",
            "https://lh3.googleusercontent.com/d/1hqbVWnJ8ELTPIuPRQjycd_iE2Dmzwayb",
            "https://lh3.googleusercontent.com/d/1OvW9AX6-x24wfDOjfyKi2mIigDVWRJuD",
            "https://lh3.googleusercontent.com/d/17BXNpZxRR6rsYThRj_EZyEi4KvPCc4pX"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "2XS",
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Four-side strench polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "2XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Long Sleeve Button Shirt",
                "variant_id": "EGDCXNKCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2707,
        "name": "AOP 3D Windproof Jacket",
        "slug": "aop-3d-windproof-jacket-3DFFJK",
        "sku": "3DFFJK",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1HNloAvPOVAivjO4vi61_NymCHVNf4Iew",
        "modified_at": 1783584867,
        "price": 23.5,
        "min_price": 23.5,
        "max_price": 28.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1V8YWZypwAicABb9EUM1l0ZZu03YX9r6C?usp=drive_link",
        "description": "Product Introduction：Windproof outer jacket supports full all-over custom printing. Light wind-resistant shell fabric fits outdoor hiking, commuting and daily travel in spring and autumn. Simple versatile silhouette, a functional customizable festival present.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick & rigid, tear-resistant, wrinkle-proof, shape-retaining and durable.<br />\n<br />\n4.Washing Instructions：Normal wash. Limited bleach. Medium heat iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.\"<br />\n<br />\n<br />\n<br />\n<br />\n",
        "size_guide": "https://lh3.googleusercontent.com/d/1eLjqLNyChMT9zHi5IH3Bgz5jlFSYHrW6",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1HNloAvPOVAivjO4vi61_NymCHVNf4Iew",
            "https://lh3.googleusercontent.com/d/1eLjqLNyChMT9zHi5IH3Bgz5jlFSYHrW6"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Broken twill fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP 3D Windproof Jacket",
                "variant_id": "3DFFJK",
                "location": "CN",
                "material": "Broken twill fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2672,
        "name": "AOP EGD Women's Long Sleeve Shirt",
        "slug": "aop-egd-womens-long-sleeve-shirt-EGDNSCXCS",
        "sku": "EGDNSCXCS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1bsbR5RuHjLq4M_CjZSqETqpxU9e8Zv2o",
        "modified_at": 1790220752,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1INarG3mTCKs70it-Ga22WzjAiFOlY52s?usp=drive_link",
        "description": "Product Introduction：Tailored women’s long sleeve blouse with full AOP custom printing. Elegant relaxed silhouette flatters female figures, breathable lightweight material works for spring and autumn commutes. It makes a delicate personalized festival gift for ladies.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Skin-friendly & unrestricted. 4-way super stretch, flexible, body-hugging and shape-retaining.<br />\n<br />\n4.Washing Instructions：Cold gentle wash. No hard rubbing or wringing. No bleach. Low heat tumble dry / shade dry. No high heat ironing, to retain elasticity.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.\"",
        "size_guide": "https://lh3.googleusercontent.com/d/11YVBtq4s9dGz47merRXkwMBiUJcHErU_",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1bsbR5RuHjLq4M_CjZSqETqpxU9e8Zv2o",
            "https://lh3.googleusercontent.com/d/17PdGZco_nQ0yUYhzFqi1gedoFfWr-ugL",
            "https://lh3.googleusercontent.com/d/1CAYAeDeGvOS6hPWoau9BfsjMwRVYpw6p",
            "https://lh3.googleusercontent.com/d/1vAfg42MfVfEZxngWY4ew9fDCcp_x7swd",
            "https://lh3.googleusercontent.com/d/11YVBtq4s9dGz47merRXkwMBiUJcHErU_"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Four-side strench polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP EGD Women's Long Sleeve Shirt",
                "variant_id": "EGDNSCXCS",
                "location": "CN",
                "material": "Four-side strench polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 599,
        "name": "Cropped Shoelaces",
        "slug": "cropped-shoelaces-CRDDXFC",
        "sku": "CRDDXFC",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1ESOSNMMHyoKG8zPIZb2drxb_zmuNRkH7",
        "modified_at": 1783418292,
        "price": 32,
        "min_price": 32,
        "max_price": 37,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1u7eJ_G4eMagjYLoft_byWRhJTvFx0y8i?usp=drive_link",
        "description": "<p>Processing Time: 7-9 days</p><p>Shipping Time: 10-16 days for Logo+TM design<br />\n7-14 days for No logo+normal design</p><p>Template or Size of design: <a href=\"https://drive.google.com/drive/folders/1u7eJ_G4eMagjYLoft_byWRhJTvFx0y8i?usp=drive_link\" target=\"_blank\">View</a></p>",
        "size_guide": "https://lh3.googleusercontent.com/d/1xU7Ofkc7xvr9MOW6sJu4q5oZkY5SPdAY",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1ESOSNMMHyoKG8zPIZb2drxb_zmuNRkH7",
            "https://lh3.googleusercontent.com/d/1xU7Ofkc7xvr9MOW6sJu4q5oZkY5SPdAY"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "EVA"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Cropped Shoelaces",
                "variant_id": "CRDDXFC-EVA",
                "location": "CN",
                "material": "EVA",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 32,
                        "non_contiguous": 37
                    },
                    "EU": {
                        "mainland": 33,
                        "non_contiguous": 33
                    },
                    "CA": {
                        "mainland": 37,
                        "non_contiguous": 37
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 30,
                        "non_contiguous": 35
                    },
                    "EU": {
                        "mainland": 31,
                        "non_contiguous": 31
                    },
                    "CA": {
                        "mainland": 35,
                        "non_contiguous": 35
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 93,
        "name": "2D Waffle Hoodie",
        "slug": "2d-waffle-hoodie-2DHFGLMS",
        "sku": "2DHFGLMS",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1GjAYTUQPuYKeHd10oO0qW7z2uKiY2EVD",
        "modified_at": 1790044795,
        "price": 25.5,
        "min_price": 25.5,
        "max_price": 30.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 2,
            "name": "2D Apparel",
            "slug": "2d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/2d_apparel.jpg",
            "description": null,
            "modified_at": 1779437520
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1hIxZpZAbE_a-sqZxzmxDEujjWQ828EWQ?usp=drive_link",
        "description": "Product Introduction：The Waffle Hoodie features a textured waffle knit fabric that provides a stylish look with a soft and comfortable feel. Designed for warmth, breathability, and everyday versatility, it is perfect for casual outings, travel, outdoor activities, or relaxing at home. A practical and fashionable gift choice for friends, family, or fashion lovers on birthdays, Christmas, or special occasions.<br />\n<br />\n1.Product process：DTG printing – great colors and long-lasting quality<br />\n<br />\n2.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n3.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1pdlrTMynmu9AkHtmbs-yIs5O7oB3sN1e",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1GjAYTUQPuYKeHd10oO0qW7z2uKiY2EVD",
            "https://lh3.googleusercontent.com/d/1tWqmUIoOYqcjyxprxazarUIlY9zI4LmU",
            "https://lh3.googleusercontent.com/d/1Eom9xkRswy9w1FRv4UiRLkZ_X1obx5ia",
            "https://lh3.googleusercontent.com/d/1D161r2WZojeVQVQUvxvg9Pitnfautig_",
            "https://lh3.googleusercontent.com/d/1-39jmEpRKs8fa-7-7i_6NeeKmmij5oja",
            "https://lh3.googleusercontent.com/d/1pdlrTMynmu9AkHtmbs-yIs5O7oB3sN1e"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "L",
                    "XL",
                    "M",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "White",
                    "Black",
                    "Light Grey",
                    "Dark Grey"
                ]
            },
            {
                "option": "material",
                "values": [
                    "100% polyster"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Light Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "S",
                "color": "Dark Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Light Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "L",
                "color": "Dark Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Light Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "XL",
                "color": "Dark Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Light Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "M",
                "color": "Dark Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Light Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "2XL",
                "color": "Dark Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "White",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Black",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Light Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "2D Waffle Hoodie",
                "variant_id": "2DHFGLMS-100-POLYSTER",
                "location": "CN",
                "material": "100% polyster",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "size": "3XL",
                "color": "Dark Grey",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3446,
        "name": "AOP Waffle Knit Hooded Sweatshirt",
        "slug": "aop-waffle-knit-hooded-sweatshirt-HFGLMWY",
        "sku": "HFGLMWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1GWlIuBUJWBNCirFWQrBO5lMSEOsx0ZHx",
        "modified_at": 1783664456,
        "price": 23.5,
        "min_price": 23.5,
        "max_price": 28.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1GspyGQRvHMT2gJ3ayXrPHOZznp85lMBZ?usp=drive_link",
        "description": "Product Introduction：Waffle hoodie with rich tactile texture, unique dimensional fabric. Great for casual daily outings, relaxed fit with effortless street style.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Soft textured, non-sticky, breathable fluffy fabric.<br />\n<br />\n4.Washing Instructions：Cold gentle wash/delicate cycle, no hot water & bleach. Flat shade dry, no wringing/sun, low iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/18WSZ426byINT63GrSfdZeuDgfa4HJDLR",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1GWlIuBUJWBNCirFWQrBO5lMSEOsx0ZHx",
            "https://lh3.googleusercontent.com/d/1gPjDd8WYeS7eTUFfaN-H5vYl7Lzsxf5X",
            "https://lh3.googleusercontent.com/d/1E-NwrmPSt56yTcEpKNJeGOCJ5gtQydJb",
            "https://lh3.googleusercontent.com/d/18WSZ426byINT63GrSfdZeuDgfa4HJDLR"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Waffle fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Hooded Sweatshirt",
                "variant_id": "HFGLMWY-WAFFLE-FABRIC",
                "location": "CN",
                "material": "Waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 239,
        "name": "3D V'neck T-shirt",
        "slug": "3d-vneck-t-shirt-TBVLDX",
        "sku": "TBVLDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1G4EaOBaWc6MOTlmsDNhBvM94wk6XnjmG",
        "modified_at": 1783584865,
        "price": 13.5,
        "min_price": 13.5,
        "max_price": 18.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1iAvhyzJKOULXa-s4hojw9z_MxJeVQiLm?usp=drive_link",
        "description": "Product Introduction：Soft 3D V-neck T-shirt featuring a sleek, flattering silhouette and breathable fabric for all-day comfort. Ideal for casual wear, street style, travel, and light activities. Suitable for spring, summer, and autumn layering. Perfect gift for birthdays or holidays. Easy to pair with jeans, shorts, or skirts for effortless everyday styling.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/196j8Fl2ykfikrK6NIOaVEzKhNrcHe0EZ",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1G4EaOBaWc6MOTlmsDNhBvM94wk6XnjmG",
            "https://lh3.googleusercontent.com/d/196j8Fl2ykfikrK6NIOaVEzKhNrcHe0EZ"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "6XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170g Polyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D V'neck T-shirt",
                "variant_id": "TBVLDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 11.5,
                        "non_contiguous": 16.5
                    },
                    "EU": {
                        "mainland": 12.5,
                        "non_contiguous": 12.5
                    },
                    "CA": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    }
                },
                "size": "6XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 209,
        "name": "AOP Sleeveless sweatshirt with pockets",
        "slug": "aop-sleeveless-sweatshirt-with-pockets-WXWYKD",
        "sku": "WXWYKD",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1B3eJiir0G1fcZIBuY6HZDYrC-IAxFWlX",
        "modified_at": 1783584865,
        "price": 15.5,
        "min_price": 15.5,
        "max_price": 20.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1lNYnM6juaC0wCUTQHbdsbAm3eYwLbOxA?usp=drive_link",
        "description": "Product Introduction：AOP sleeveless sweatshirt with pockets features a modern relaxed silhouette and soft breathable fabric for all-day comfort. The functional pocket design adds utility while keeping a clean streetwear look. Ideal for gym, travel, and casual outings. Perfect for spring and autumn, easy to pair with joggers, jeans, or shorts for versatile everyday styling.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Thick fluffy & springy, warm padded, well-shaped, breathable.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing/high heat/sun, flat shade dry, low iron to protect padding.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/15kuCoafWckAEUQRrK5GiZK9tKMzh1WkT",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1B3eJiir0G1fcZIBuY6HZDYrC-IAxFWlX",
            "https://lh3.googleusercontent.com/d/15kuCoafWckAEUQRrK5GiZK9tKMzh1WkT"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "200g Air layer fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Sleeveless sweatshirt with pockets",
                "variant_id": "WXWYKD-200G-AIR-LAYER-FABRIC",
                "location": "CN",
                "material": "200g Air layer fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13.5,
                        "non_contiguous": 18.5
                    },
                    "EU": {
                        "mainland": 14.5,
                        "non_contiguous": 14.5
                    },
                    "CA": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 394,
        "name": "Square Pattern Quilt Blank",
        "slug": "square-pattern-quilt-blank-HFMBZ",
        "sku": "HFMBZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1cLQq_jmtaB24KNUSH08TRUC4EH7oSp_6",
        "modified_at": 1784182326,
        "price": 15,
        "min_price": 15,
        "max_price": 63,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/11TnhifsufknIpo4rGDFJ3564NbZon9jZ?usp=drive_link",
        "description": "Product Introduction：This square pattern quilt blanket supports 3D full-print customization, with clear and stylish patterns. Soft, durable and versatile for sofas and bedrooms, it is an ideal gift for family and friends on festivals.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Soft anti-slip suede, perfect lining, snug and non-slip.<br />\n<br />\n3.Washing Instructions：Cold gentle wash. No sun or hard rubbing, prevent lint & pilling.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1cLQq_jmtaB24KNUSH08TRUC4EH7oSp_6",
            "https://lh3.googleusercontent.com/d/1MF-DLfFiKunFSN88ZnyGZJi_jWWTFI0c"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "130x150cm",
                    "140x152cm",
                    "150x200cm",
                    "180x200cm",
                    "173x203cm",
                    "200x230cm",
                    "230x230cm",
                    "230x260cm",
                    "230x280cm",
                    "75x100cm",
                    "173x218 cm",
                    "150x180cm",
                    "96x114cm",
                    "244x290cm"
                ]
            },
            {
                "option": "material",
                "values": [
                    "280 grams brushed fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-130X150CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "130x150cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23,
                        "non_contiguous": 28
                    },
                    "EU": {
                        "mainland": 24,
                        "non_contiguous": 24
                    },
                    "CA": {
                        "mainland": 28,
                        "non_contiguous": 28
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21,
                        "non_contiguous": 26
                    },
                    "EU": {
                        "mainland": 22,
                        "non_contiguous": 22
                    },
                    "CA": {
                        "mainland": 26,
                        "non_contiguous": 26
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-140X152CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "140x152cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24,
                        "non_contiguous": 29
                    },
                    "EU": {
                        "mainland": 25,
                        "non_contiguous": 25
                    },
                    "CA": {
                        "mainland": 29,
                        "non_contiguous": 29
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-150X200CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "150x200cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 29,
                        "non_contiguous": 34
                    },
                    "EU": {
                        "mainland": 30,
                        "non_contiguous": 30
                    },
                    "CA": {
                        "mainland": 34,
                        "non_contiguous": 34
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 27,
                        "non_contiguous": 32
                    },
                    "EU": {
                        "mainland": 28,
                        "non_contiguous": 28
                    },
                    "CA": {
                        "mainland": 32,
                        "non_contiguous": 32
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-180X200CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "180x200cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-173X203CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "173x203cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-200X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "200x230cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 39.5,
                        "non_contiguous": 44.5
                    },
                    "EU": {
                        "mainland": 40.5,
                        "non_contiguous": 40.5
                    },
                    "CA": {
                        "mainland": 44.5,
                        "non_contiguous": 44.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 37.5,
                        "non_contiguous": 42.5
                    },
                    "EU": {
                        "mainland": 38.5,
                        "non_contiguous": 38.5
                    },
                    "CA": {
                        "mainland": 42.5,
                        "non_contiguous": 42.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-230X230CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x230cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 42,
                        "non_contiguous": 47
                    },
                    "EU": {
                        "mainland": 43,
                        "non_contiguous": 43
                    },
                    "CA": {
                        "mainland": 47,
                        "non_contiguous": 47
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 40,
                        "non_contiguous": 45
                    },
                    "EU": {
                        "mainland": 41,
                        "non_contiguous": 41
                    },
                    "CA": {
                        "mainland": 45,
                        "non_contiguous": 45
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-230X260CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x260cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 46.5,
                        "non_contiguous": 51.5
                    },
                    "EU": {
                        "mainland": 47.5,
                        "non_contiguous": 47.5
                    },
                    "CA": {
                        "mainland": 51.5,
                        "non_contiguous": 51.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 44.5,
                        "non_contiguous": 49.5
                    },
                    "EU": {
                        "mainland": 45.5,
                        "non_contiguous": 45.5
                    },
                    "CA": {
                        "mainland": 49.5,
                        "non_contiguous": 49.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-230X280CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "230x280cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 49.5,
                        "non_contiguous": 54.5
                    },
                    "EU": {
                        "mainland": 50.5,
                        "non_contiguous": 50.5
                    },
                    "CA": {
                        "mainland": 54.5,
                        "non_contiguous": 54.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 47.5,
                        "non_contiguous": 52.5
                    },
                    "EU": {
                        "mainland": 48.5,
                        "non_contiguous": 48.5
                    },
                    "CA": {
                        "mainland": 52.5,
                        "non_contiguous": 52.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-75X100CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "75x100cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-173X218-CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "173x218 cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 33,
                        "non_contiguous": 38
                    },
                    "EU": {
                        "mainland": 34,
                        "non_contiguous": 34
                    },
                    "CA": {
                        "mainland": 38,
                        "non_contiguous": 38
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 31,
                        "non_contiguous": 36
                    },
                    "EU": {
                        "mainland": 32,
                        "non_contiguous": 32
                    },
                    "CA": {
                        "mainland": 36,
                        "non_contiguous": 36
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-150X180CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "150x180cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 27.5,
                        "non_contiguous": 32.5
                    },
                    "EU": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    },
                    "CA": {
                        "mainland": 32.5,
                        "non_contiguous": 32.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 25.5,
                        "non_contiguous": 30.5
                    },
                    "EU": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    },
                    "CA": {
                        "mainland": 30.5,
                        "non_contiguous": 30.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-96X114CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "96x114cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Square Pattern Quilt Blank",
                "variant_id": "HFMBZ-244X290CM-280-GRAMS-BRUSHED-FABRIC",
                "location": "CN",
                "size": "244x290cm",
                "material": "280 grams brushed fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 58,
                        "non_contiguous": 63
                    },
                    "EU": {
                        "mainland": 59,
                        "non_contiguous": 59
                    },
                    "CA": {
                        "mainland": 63,
                        "non_contiguous": 63
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 56,
                        "non_contiguous": 61
                    },
                    "EU": {
                        "mainland": 57,
                        "non_contiguous": 57
                    },
                    "CA": {
                        "mainland": 61,
                        "non_contiguous": 61
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2898,
        "name": "AOP Waffle Knit Crewneck Sweatshirt",
        "slug": "aop-waffle-knit-crewneck-sweatshirt-HFGYLWY",
        "sku": "HFGYLWY",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/175EoMC638e9Paqss-waui9qW_dvWfPwL",
        "modified_at": 1790045387,
        "price": 17.5,
        "min_price": 17.5,
        "max_price": 22.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1SL6wq8syNBnNerGREKdG4o2zOXsYH7nr?usp=drive_link",
        "description": "Product Introduction：This waffle-knit crew neck long-sleeve sweatshirt features a relaxed dropped-shoulder cut for cozy casual wear. Crafted from soft breathable fabric, it supports 3D all-over print customization. Versatile for spring and autumn daily commutes, it is available in regular to plus sizes.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Soft textured, non-sticky, breathable fluffy fabric.<br />\n<br />\n4.Washing Instructions：Cold gentle wash/delicate cycle, no hot water & bleach. Flat shade dry, no wringing/sun, low iron.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1MB94WG7H9l_-7sHAkYqXqC01-2wIkUoH",
        "gallery": [
            "https://lh3.googleusercontent.com/d/175EoMC638e9Paqss-waui9qW_dvWfPwL",
            "https://lh3.googleusercontent.com/d/1Ys2T9xgnRvuMyxrVUc1LX3U4xS8fNPG3",
            "https://lh3.googleusercontent.com/d/18G9rcjh9FyUZDyXUNfjZD-OizNd0FWvQ",
            "https://lh3.googleusercontent.com/d/1xrX4zdaXC1_OOqK3HlEhRaumSXW1JhpK",
            "https://lh3.googleusercontent.com/d/1MB94WG7H9l_-7sHAkYqXqC01-2wIkUoH"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "L",
                    "XL",
                    "M",
                    "2XL",
                    "3XL",
                    "4XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "waffle fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP Waffle Knit Crewneck Sweatshirt",
                "variant_id": "HFGYLWY",
                "location": "CN",
                "material": "waffle fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 434,
        "name": "Double-Layer Garden Flag",
        "slug": "double-layer-garden-flag-HYQSC",
        "sku": "HYQSC",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1B1mFnNlbj_N4DoECd88JnFhFSCtp1GcT",
        "modified_at": 1785487715,
        "price": 12,
        "min_price": 12,
        "max_price": 22,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 10,
            "name": "Home & Living",
            "slug": "home-living",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/blanket.jpg",
            "description": null,
            "modified_at": 1773195280
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1AC0n9VeTWlfB08dnmn9Q4V0-bQ47ej4v?usp=drive_link",
        "description": "Product Introduction：Double-layer garden flag keeps shape without light leakage, vibrant color and wind resistant. Perfect for yard decoration. Durable for garden lovers and an elegant holiday decor gift.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Waterproof, mildew-proof, light, flexible, easy-clean and shape-retaining.<br />\n<br />\n3.Washing Instructions：Wipe or regular wash, hang shade dry. Clean regularly for mildew prevention.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1B1mFnNlbj_N4DoECd88JnFhFSCtp1GcT",
            "https://lh3.googleusercontent.com/d/1PqOQBxcYKe6Tk9WlYt7VgxLp23zj9RsE"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "29*44cm",
                    "31*46cm",
                    "71*102cm",
                    "75*100cm",
                    "91*152cm",
                    "92*152cm",
                    "91x60cm",
                    "97x145cm"
                ]
            },
            {
                "option": "material",
                "values": [
                    "90G/M² Shower Curtain Fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-2944CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "29*44cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10,
                        "non_contiguous": 15
                    },
                    "EU": {
                        "mainland": 11,
                        "non_contiguous": 11
                    },
                    "CA": {
                        "mainland": 15,
                        "non_contiguous": 15
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-3146CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "31*46cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12,
                        "non_contiguous": 17
                    },
                    "EU": {
                        "mainland": 13,
                        "non_contiguous": 13
                    },
                    "CA": {
                        "mainland": 17,
                        "non_contiguous": 17
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10,
                        "non_contiguous": 15
                    },
                    "EU": {
                        "mainland": 11,
                        "non_contiguous": 11
                    },
                    "CA": {
                        "mainland": 15,
                        "non_contiguous": 15
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-71102CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "71*102cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-75100CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "75*100cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-91152CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "91*152cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-92152CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "92*152cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-9160CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "91x60cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Double-Layer Garden Flag",
                "variant_id": "HYQSC-97X145CM-90GM2-SHOWER-CURTAIN-FABRIC",
                "location": "CN",
                "size": "97x145cm",
                "material": "90G/M² Shower Curtain Fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17,
                        "non_contiguous": 22
                    },
                    "EU": {
                        "mainland": 18,
                        "non_contiguous": 18
                    },
                    "CA": {
                        "mainland": 22,
                        "non_contiguous": 22
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 428,
        "name": "3D Adult Flat Brim Cap",
        "slug": "3d-adult-flat-brim-cap-CRPYM",
        "sku": "CRPYM",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1a-H1oL6kGoQfSH2Q9KIIZZ6ocM6J3PyG",
        "modified_at": 1773974356,
        "price": 15,
        "min_price": 15,
        "max_price": 20,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 17,
            "name": "Cap & Hat",
            "slug": "cap-hat",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/hat.jpg",
            "description": null,
            "modified_at": 1786348981
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1e5vqqZ0ciI9lQNlDN_n-SZvskfioiAwx?usp=drive_link",
        "description": "Product Introduction：Trendy blank flat brim cap supports full-cap 3D all-over custom printing, with breathable vents for all-day comfort and a structured streetwear silhouette. Ideal for daily looks and events, custom prints make it a unique souvenir gift for fashion enthusiasts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.Material：Crisp, durable, wrinkle-resistant, well-shaped and easy to maintain.<br />\n<br />\n3.Washing Instructions：Regular wash, medium iron. Do not wring, hang dry.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1a-H1oL6kGoQfSH2Q9KIIZZ6ocM6J3PyG",
            "https://lh3.googleusercontent.com/d/1VOeYtSv3ypo9xPGgiuDAJq1hEnUSf_GO"
        ],
        "options": [
            {
                "option": "color",
                "values": [
                    "3D"
                ]
            },
            {
                "option": "material",
                "values": [
                    "220g Twill"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Adult Flat Brim Cap",
                "variant_id": "CRPYM-ONE-SIZE-220G-TWILL",
                "location": "CN",
                "color": "3D",
                "material": "220g Twill",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 15,
                        "non_contiguous": 20
                    },
                    "EU": {
                        "mainland": 16,
                        "non_contiguous": 16
                    },
                    "CA": {
                        "mainland": 20,
                        "non_contiguous": 20
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 13,
                        "non_contiguous": 18
                    },
                    "EU": {
                        "mainland": 14,
                        "non_contiguous": 14
                    },
                    "CA": {
                        "mainland": 18,
                        "non_contiguous": 18
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3732,
        "name": "AOP KHU Youth Short‑Sleeve T‑Shirt",
        "slug": "aop-khu-youth-shortsleeve-tshirt-KHUQNDX",
        "sku": "KHUQNDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1yUsYS-r3s1AYe46MAhFCxgHGMMbSsyp6",
        "modified_at": 1787196649,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1ekUPEMkzu-i5CwNIZ7G3W6hOrZCQnDNz?usp=drive_link",
        "description": "Product Introduction：KHU youth short‑sleeve tee with fun cartoon character all‑over print. Soft skin‑friendly fabric and loose fit. Perfect for daily wear and party outings in spring‑summer, eye‑catching and great as a fun gift.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1VH-xPq2AXcEdqQPSKX3TAAoiU97V3_7r",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1yUsYS-r3s1AYe46MAhFCxgHGMMbSsyp6",
            "https://lh3.googleusercontent.com/d/16Oaqil52tz4D-kUrRqAc8ZcZ5bxKZW7c",
            "https://lh3.googleusercontent.com/d/1A_f4EcczU4E4zVtCiruZI3oMdbnr95cu",
            "https://lh3.googleusercontent.com/d/1kPllcIlMovAQRzA4Ie_Y4WURonVGteBn",
            "https://lh3.googleusercontent.com/d/1DsXwgpo-O-jY1CHvb_-sWtSK9bGeeL5_",
            "https://lh3.googleusercontent.com/d/1VH-xPq2AXcEdqQPSKX3TAAoiU97V3_7r"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "Youth XS",
                    "Youth S",
                    "Youth M",
                    "Youth L",
                    "Youth XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170g Polyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP KHU Youth Short‑Sleeve T‑Shirt",
                "variant_id": "KHUQNDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "Youth XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP KHU Youth Short‑Sleeve T‑Shirt",
                "variant_id": "KHUQNDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "Youth S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP KHU Youth Short‑Sleeve T‑Shirt",
                "variant_id": "KHUQNDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "Youth M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP KHU Youth Short‑Sleeve T‑Shirt",
                "variant_id": "KHUQNDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "Youth L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP KHU Youth Short‑Sleeve T‑Shirt",
                "variant_id": "KHUQNDX-170G-POLYESTER-COTTON-IMITATION",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "Youth XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 246,
        "name": "3D Adult long-sleeved shirt pajama set with line",
        "slug": "3d-adult-long-sleeved-shirt-pajama-set-with-line-BBTTCSSYTZ",
        "sku": "BBTTCSSYTZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1Eq-zKJ3zGJcBp52_s9uMfPgnv-pulbrq",
        "modified_at": 1783579170,
        "price": 26.5,
        "min_price": 26.5,
        "max_price": 31.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1D0y3xZuU3eX_EBS0j8cDcS7LMVYupkuR?usp=drive_link",
        "description": "Product Introduction：3D adult long-sleeved pajama set with contrast piping delivers a clean, elegant look and soft comfort. Relaxed fit ensures breathable ease for sleep and home lounging. Button-down design adds classic style. Ideal for travel, hotels, and warm to mild seasons. A thoughtful gift for couples or daily comfortable wear set.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Smooth handfeel, sturdy wear; wrinkle-free, fast drying, abrasion-proof, no deformation, easy maintenance.<br />\n<br />\n4.Washing Instructions：Wash ≤30°C with neutral detergent. No hot soak/alkali soap. Shade dry, low temp iron, no high heat tumble dry.<br />\n                                   <br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/1ufS-p81E6-UEEnPP8wsxZqAyIcJ08Bz9",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1Eq-zKJ3zGJcBp52_s9uMfPgnv-pulbrq",
            "https://lh3.googleusercontent.com/d/1ufS-p81E6-UEEnPP8wsxZqAyIcJ08Bz9"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "150g Plain polyster fabric"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "XS",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "3D Adult long-sleeved shirt pajama set with line",
                "variant_id": "BBTTCSSYTZ-150G-PLAIN-POLYSTER-FABRIC",
                "location": "CN",
                "material": "150g Plain polyster fabric",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 26.5,
                        "non_contiguous": 31.5
                    },
                    "EU": {
                        "mainland": 27.5,
                        "non_contiguous": 27.5
                    },
                    "CA": {
                        "mainland": 31.5,
                        "non_contiguous": 31.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 24.5,
                        "non_contiguous": 29.5
                    },
                    "EU": {
                        "mainland": 25.5,
                        "non_contiguous": 25.5
                    },
                    "CA": {
                        "mainland": 29.5,
                        "non_contiguous": 29.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2655,
        "name": "AOP PTH V Neck Short Sleeve",
        "slug": "aop-pth-v-neck-short-sleeve-PTH-VLDX",
        "sku": "PTH-VLDX",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1t2_NLMypFsrhdTKpzb0j9tuo00ZfBN5p",
        "modified_at": 1783584867,
        "price": 12.5,
        "min_price": 12.5,
        "max_price": 17.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1zEwxaKsWycPXtoGSj5BcCHIwiSFv4OVQ?usp=drive_link",
        "description": "Product Introduction：Elegant V-neck short sleeve t-shirt allows full custom AOP printing. Slim-friendly relaxed fit upgrades summer casual style, breathable fabric for daily trips and light office wear, a lovely customized holiday gift for men and women.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Cotton-like softness, shrink & wrinkle resistant, quick dry, great drape.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard wringing, high heat or sun; shade dry & low iron to avoid stiffness, deform & pilling.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.\"<br />\n<br />\n<br />\n<br />\n<br />\n",
        "size_guide": "https://lh3.googleusercontent.com/d/1Ecf3RaknxpzySsKTEaeJ0kO7L2Cxm6_5",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1t2_NLMypFsrhdTKpzb0j9tuo00ZfBN5p",
            "https://lh3.googleusercontent.com/d/1Ecf3RaknxpzySsKTEaeJ0kO7L2Cxm6_5"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "170g Polyester cotton imitation"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP PTH V Neck Short Sleeve",
                "variant_id": "PTH-VLDX",
                "location": "CN",
                "material": "170g Polyester cotton imitation",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 12.5,
                        "non_contiguous": 17.5
                    },
                    "EU": {
                        "mainland": 13.5,
                        "non_contiguous": 13.5
                    },
                    "CA": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 10.5,
                        "non_contiguous": 15.5
                    },
                    "EU": {
                        "mainland": 11.5,
                        "non_contiguous": 11.5
                    },
                    "CA": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 2602,
        "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
        "slug": "aop-ngo-bound-long-sleeve-shirt-and-pants-pajama-set-NGO-BBCXCSCKSYTZ",
        "sku": "NGO-BBCXCSCKSYTZ",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1a8zt44mFyV22ncKEGhtu2PLOchT9EM9h",
        "modified_at": 1783584867,
        "price": 23.5,
        "min_price": 23.5,
        "max_price": 28.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 1,
            "name": "3D Apparel",
            "slug": "3d-apparel",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/3d_apparel.jpg",
            "description": null,
            "modified_at": 1774945807
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1k_2CUN_iV0y-1SFgnM9wbU5Lbu5U2Gxc?usp=drive_link",
        "description": "Product Introduction：Long sleeve & long pants pajama set with contrast piping, full 3D all-over print customizable. Loose draping silky fabric soft for spring autumn loungewear, complete matching set as premium personalized gifts.<br />\n<br />\n1.Product process：3D full printing technology. All over print,the colors are bright and highly restored, and the printing is firm and does not blurry or crack. 100 DPI resolution.<br />\n<br />\n2.3D Full Print：Each product is personalized and no MOQ.<br />\n<br />\n3.Material：Glossy silky, nice drape, lightweight, wrinkle-free.<br />\n<br />\n4.Washing Instructions：Cold gentle wash, neutral detergent. No hard rub/wring, shade dry, no sun/high iron to keep luster.<br />\n<br />\n5.We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n6.Here are the key points to note：<br />\n<br />\n- Measurements may have a 1–3 cm error – this is normal.<br />\n- Due to many mock up made by AI,product Mock up are for reference only.<br />\n- Every item is custom-made for you through printing, cutting, and sewing.<br />\n- Because each piece is individually made, the pattern may not align perfectly at the seams or sleeves – slight variations are expected.",
        "size_guide": "https://lh3.googleusercontent.com/d/12hMy8yirXvgbHuTygbnkwQ_7F9y0Gi6O",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1a8zt44mFyV22ncKEGhtu2PLOchT9EM9h",
            "https://lh3.googleusercontent.com/d/12hMy8yirXvgbHuTygbnkwQ_7F9y0Gi6O"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL"
                ]
            },
            {
                "option": "material",
                "values": [
                    "90g Satin"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "S",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "M",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "L",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "2XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "3XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "4XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "AOP NGO Bound Long Sleeve Shirt and Pants Pajama Set",
                "variant_id": "NGO-BBCXCSCKSYTZ",
                "location": "CN",
                "material": "90g Satin",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 23.5,
                        "non_contiguous": 28.5
                    },
                    "EU": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    },
                    "CA": {
                        "mainland": 28.5,
                        "non_contiguous": 28.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 21.5,
                        "non_contiguous": 26.5
                    },
                    "EU": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    },
                    "CA": {
                        "mainland": 26.5,
                        "non_contiguous": 26.5
                    }
                },
                "size": "5XL",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 709,
        "name": "3Dleather backpack",
        "slug": "3dleather-backpack-ICOPGSJB",
        "sku": "ICOPGSJB",
        "processing_time": "5-7 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1TDvOz2iWHf7WVUGnGQR3hEYlE9SBZYrT",
        "modified_at": 1785396354,
        "price": 28,
        "min_price": 28,
        "max_price": 33,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 18,
            "name": "Bag & Wallet",
            "slug": "bag-wallet",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/bag.jpg",
            "description": null,
            "modified_at": 1773762814
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1e2zks0IMA3dzr9X6AGfto7AHT8L_sU40?usp=drive_link",
        "description": "Product Introduction：Fashionable leather backpack with custom print, roomy interior fits daily belongings for school or short trips. Nice birthday gift for teens and adults, resilient leather reduces scratch damage in daily use.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Flexible, waterproof, varied patterns, good value and nice shaping effect.<br />\n<br />\n3.Washing Instructions：Damp cloth cleaning only. No soaking, sun exposure or alcohol.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1TDvOz2iWHf7WVUGnGQR3hEYlE9SBZYrT",
            "https://lh3.googleusercontent.com/d/15hlmTgqszx1Y0SAloW7_MPl_ZAOCrIdc"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "one size"
                ]
            },
            {
                "option": "material",
                "values": [
                    "PU"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "3Dleather backpack",
                "variant_id": "ICOPGSJB-ONE-SIZE-PU",
                "location": "CN",
                "size": "one size",
                "material": "PU",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 28,
                        "non_contiguous": 33
                    },
                    "EU": {
                        "mainland": 29,
                        "non_contiguous": 29
                    },
                    "CA": {
                        "mainland": 33,
                        "non_contiguous": 33
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 26,
                        "non_contiguous": 31
                    },
                    "EU": {
                        "mainland": 27,
                        "non_contiguous": 27
                    },
                    "CA": {
                        "mainland": 31,
                        "non_contiguous": 31
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 415,
        "name": "20oz Tumbler",
        "slug": "20oz-tumbler-20OZYXQCB-BLD",
        "sku": "20OZYXQCB-BLD",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1bhmtzFOQe61IPRsnW9BZ_sczRV131gBq",
        "modified_at": 1784270350,
        "price": 16.5,
        "min_price": 16.5,
        "max_price": 21.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 15,
            "name": "Drinkware",
            "slug": "drinkware",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/drinkware.jpg",
            "description": null,
            "modified_at": 1773763799
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/101QZ9VJjlTzPU4y239nbceJASa_7TOTQ?usp=drive_link",
        "description": "Product Introduction：This 20oz tumbler features 3D all-over print customization. Double-wall vacuum insulation, leak-proof, ideal for daily commuting, a practical personalized gift choice.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Drop-proof | Leakproof | Insulated for hot & cold | Lightweight, ideal for daily & outdoor use.<br />\n<br />\n3.Washing Instructions：Regular hand wash, periodic seal cleaning. No steel wool / acid cleaners; no carbonated & alkaline beverages; Do not heat empty.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1bhmtzFOQe61IPRsnW9BZ_sczRV131gBq",
            "https://lh3.googleusercontent.com/d/1CS0rkRKGcZadS4Hs7ALPDGdmhOUu7Wq_"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "20OZ"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Stainless Steel"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "20oz Tumbler",
                "variant_id": "20OZYXQCB-BLD-20OZ-STAINLESS-STEEL",
                "location": "CN",
                "size": "20OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 16.5,
                        "non_contiguous": 21.5
                    },
                    "EU": {
                        "mainland": 17.5,
                        "non_contiguous": 17.5
                    },
                    "CA": {
                        "mainland": 21.5,
                        "non_contiguous": 21.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 14.5,
                        "non_contiguous": 19.5
                    },
                    "EU": {
                        "mainland": 15.5,
                        "non_contiguous": 15.5
                    },
                    "CA": {
                        "mainland": 19.5,
                        "non_contiguous": 19.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 996,
        "name": "Handheld Cup",
        "slug": "handheld-cup-STBZ",
        "sku": "STBZ",
        "processing_time": "3-5 days",
        "shipping_time": "7-15 days",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1KSY7O6MACJPq_WpRhQouwYxJeGlKE9lZ",
        "modified_at": 1784270351,
        "price": 17.5,
        "min_price": 17.5,
        "max_price": 24.5,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 15,
            "name": "Drinkware",
            "slug": "drinkware",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/drinkware.jpg",
            "description": null,
            "modified_at": 1773763799
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/12iLUvXTGalX-KYplFG-9mvvqv6Sk4Yte?usp=drive_link",
        "description": "Product Introduction：This handheld tumbler supports 3D all-over print customization, available in 20OZ and 30OZ. Equipped with portable handle and sealed flip lid, vacuum insulated for commute and outdoor activities as a practical personalized gift.<br />\n<br />\n1.Product process：UV printing and Engrave printing, with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Material：Drop-proof | Leakproof | Insulated for hot & cold | Lightweight, ideal for daily & outdoor use.<br />\n<br />\n3.Washing Instructions：Regular hand wash, periodic seal cleaning. No steel wool / acid cleaners; no carbonated & alkaline beverages; Do not heat empty.<br />\n<br />\n4.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n5.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": null,
        "gallery": [
            "https://lh3.googleusercontent.com/d/1KSY7O6MACJPq_WpRhQouwYxJeGlKE9lZ",
            "https://lh3.googleusercontent.com/d/1kqyuL7YnuSiC9ZmCpmUAzg8iuEU1SuVH"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "20OZ",
                    "30OZ"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Stainless Steel"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "Handheld Cup",
                "variant_id": "STBZ-20OZ",
                "location": "CN",
                "size": "20OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 15.5,
                        "non_contiguous": 20.5
                    },
                    "EU": {
                        "mainland": 16.5,
                        "non_contiguous": 16.5
                    },
                    "CA": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "Handheld Cup",
                "variant_id": "STBZ-30OZ",
                "location": "CN",
                "size": "30OZ",
                "material": "Stainless Steel",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 19.5,
                        "non_contiguous": 24.5
                    },
                    "EU": {
                        "mainland": 20.5,
                        "non_contiguous": 20.5
                    },
                    "CA": {
                        "mainland": 24.5,
                        "non_contiguous": 24.5
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 17.5,
                        "non_contiguous": 22.5
                    },
                    "EU": {
                        "mainland": 18.5,
                        "non_contiguous": 18.5
                    },
                    "CA": {
                        "mainland": 22.5,
                        "non_contiguous": 22.5
                    }
                },
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    },
    {
        "id": 3256,
        "name": "SH23J",
        "slug": "sh23j-SH23J",
        "sku": "SH23J",
        "processing_time": "7-9 days",
        "shipping_time": "10-16 days for Logo+TM design\n7-14 days for No logo+normal design",
        "made_in": "CN",
        "thumbnail": "https://lh3.googleusercontent.com/d/1w_d7cUCLYPS3q3hHyttTP2S0QVTuK5pA",
        "modified_at": 1784624763,
        "price": 43,
        "min_price": 43,
        "max_price": 48,
        "is_new": false,
        "is_best_seller": false,
        "category": {
            "id": 16,
            "name": "Shoes & Footwear",
            "slug": "shoes-footwear",
            "thumbnail": "https://app.luxurypro.shop/assets/img/cat/shoes.jpg",
            "description": null,
            "modified_at": 1777823835
        },
        "seller_price": [],
        "seller_price_add": [],
        "template_guide": "https://drive.google.com/drive/folders/1UctY_mq7Pb2pTvkYBZiqeWgaKorMFBKQ?usp=drive_link",
        "description": "Product Introduction：Custom full 3D printing supported. Wear-resistant soft microfiber upper, durable rubber outsole. Low-top versatile design fits daily commutes and casual outings, comfortable all day without rubbing feet.<br />\n<br />\n1.Product process：UV printing or 3D Full Print with clear, vivid, and long-lasting patterns. 100 DPI resolution.<br />\n<br />\n2.Customize products, with no MOQ. We offer different shipping options, and the cost depends on how fast it is.<br />\n<br />\n3.Here are the key points to note：<br />\n<br />\n- Product images are for reference only.<br />\n- The actual item may differ slightly from the picture due to factors like production batch, equipment settings, lighting, or design complexity.<br />\n- Common differences include size, placement, color, and pattern details – these are normal and not defects.",
        "size_guide": "https://lh3.googleusercontent.com/d/1nN9CLCpEYoUFO5e_PQtFydAHSGXtxC5U",
        "gallery": [
            "https://lh3.googleusercontent.com/d/1w_d7cUCLYPS3q3hHyttTP2S0QVTuK5pA",
            "https://lh3.googleusercontent.com/d/1Kn2t2r6-fFUZN1Aef1qQF7yyR5GgXfpj",
            "https://lh3.googleusercontent.com/d/1YE_vvuX0Vl1bErKAGycm8zR9mPDr8urn",
            "https://lh3.googleusercontent.com/d/1nN9CLCpEYoUFO5e_PQtFydAHSGXtxC5U"
        ],
        "options": [
            {
                "option": "size",
                "values": [
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48"
                ]
            },
            {
                "option": "material",
                "values": [
                    "Microfiber Upper, RB (Polyethylene) Sole"
                ]
            },
            {
                "option": "shipping_type",
                "values": [
                    "SELLER"
                ]
            }
        ],
        "variants": [
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "36",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "37",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "38",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "39",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "40",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "41",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "42",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "43",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "44",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "45",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "46",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "47",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            },
            {
                "name": "SH23J",
                "variant_id": "SH23J",
                "location": "CN",
                "material": "Microfiber Upper, RB (Polyethylene) Sole",
                "shipping_type": "SELLER",
                "base_cost": 0,
                "base_cost_addition": 0,
                "addition_side": 0,
                "sleeve_left": 0,
                "sleeve_right": 0,
                "shipping_fee": 0,
                "addition_shipping_fee": 0,
                "fulfillment_name": "LuxuryPro",
                "fulfillment_code": "LUX",
                "seller_price": {
                    "US": {
                        "mainland": 43,
                        "non_contiguous": 48
                    },
                    "EU": {
                        "mainland": 44,
                        "non_contiguous": 44
                    },
                    "CA": {
                        "mainland": 48,
                        "non_contiguous": 48
                    }
                },
                "seller_price_add": {
                    "US": {
                        "mainland": 41,
                        "non_contiguous": 46
                    },
                    "EU": {
                        "mainland": 42,
                        "non_contiguous": 42
                    },
                    "CA": {
                        "mainland": 46,
                        "non_contiguous": 46
                    }
                },
                "size": "48",
                "shipping": {
                    "US": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "EU": {
                        "mainland": 0,
                        "non_contiguous": 0
                    },
                    "CA": {
                        "mainland": 0,
                        "non_contiguous": 0
                    }
                }
            }
        ]
    }
]
export default luxurypro
